//=============================================================================
//== JAVASCRIPT - THEME
//! PLEASE DO NOT MODIFY THIS FILE
//=============================================================================

/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: ' + 769 + 'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}
theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function () {
  'use strict';

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces) // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },

    prepareTransition: function (el, callback) {
      el.addEventListener('transitionend', removeClass);

      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }

      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === 'function') {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };

  theme.a11y = {
    moveFocus: function (elementId) {
      const element = document.getElementById(elementId);
      if (element) {
        element.focus();
      }
    },
    trapFocus: function (options) {
      function getFocusableElements() {
        const focusableEls = options.container.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        );
        const elArray = Array.from(focusableEls);
        return elArray.filter(el => el.offsetParent !== null);
      }

      function _manageFocus(evt) {
        const focusableElements = getFocusableElements();
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (evt.key === "Tab") {
          // Shift + Tab
          if (evt.shiftKey && evt.target === firstFocusable) {
            evt.preventDefault();
            lastFocusable.focus();
          }
          // Tab
          else if (!evt.shiftKey && evt.target === lastFocusable) {
            evt.preventDefault();
            firstFocusable.focus();
          }
        }
      }

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      options.container.addEventListener("keydown", _manageFocus);

      return function cleanup() {
        options.container.removeEventListener("keydown", _manageFocus);
      };
    },

    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';

      if (options.container) {
        options.container.removeAttribute('tabindex');
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');

          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }

          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
        variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();

  theme.Images = (function () {

    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }

      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }

    function lazyloadImagePath(string) {
      var image;

      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }

      return image;
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();

  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
      function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }

    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };

    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: '0px 0px ' + threshold + 'px 0px' });

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: 'link',
      script: 'script'
    };

    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };

    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () { };
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');

      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });

      this.instances.push(instance);
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll('[data-section-id]');

      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });

  theme.Variants = (function () {

    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {

      _getCurrentOptions: function () {
        var result = [];

        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');

          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function (option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function () {

        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant
          }
        }));

        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant
          }
        }));

        if (!variant) {
          return;
        }

        if (window.theme.settings.templateName === 'product') {
          var currentPromotionText = variantArray.find(x => x.variantId == variant.id)?.text.substring(0, 16);

          var ribbonElement = document.querySelector('.ribbon-alt.ribbon-alt_pdp span');
          if (ribbonElement && !ribbonElement.closest('.ribbon-alt_bundle')) {
            let ribbonText = null;

            const selectedVariantData = document.querySelector(`.product-variants-select option[value="${variant.id}"]`);
            if(selectedVariantData) {
              const price = selectedVariantData.getAttribute('data-variant-price');
              const comparePrice = selectedVariantData.getAttribute('data-variant-compare-price');

              if(comparePrice > price && window.enable_automatic_discount == 'true') {
                const discountRaw = ((comparePrice - price) / comparePrice) * 100;
                const discount_value = Math.floor((discountRaw + 2.5) / 5) * 5;
                ribbonText = `${discount_Percentage_label_prefix}${discount_value}% ${window.discount_badge_text ? window.discount_badge_text : ''}`;
              }
            }

            ribbonElement.textContent = ribbonText ||currentPromotionText || productLevelText;
          }
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }

        this._updateValuePacks();
        this._updateRibbonItem();
      },

      _updateRibbonItem: function () {
        const sectionId = this.container.getAttribute('data-section-id');

        if (!sectionId) {
          console.warn('Cannot found ID attr in section');
          return;
        }

        // Request Section Rendering API
        fetch(window.location.href + `&sections=${sectionId}`)
          .then(response => {
            if (!response.ok) {
              throw new Error('Error request');
            }
            return response.json();
          })
          .then(data => {
            const newHTML = data[sectionId];
            if (!newHTML) {
              console.warn('Cannot found new HTML for section:', sectionId);
              return;
            }

            const parser = new DOMParser();
            const parsedDoc = parser.parseFromString(newHTML, 'text/html');
            if (parsedDoc) {
              const newRibbonContainer = parsedDoc.querySelector('.product__ribbon-container');
              if (newRibbonContainer) {
                let oldRibbonContainer = document.querySelector('.product__ribbon-container');
                if (oldRibbonContainer) {
                  oldRibbonContainer.innerHTML = newRibbonContainer.innerHTML;
                }
              }
            }
          })
          .catch(err => {
            console.error('Error:', err);
          });
      },

      _updateValuePacks: function () {
        let oldValuePacksContainer = document.querySelector('.product-block-value-packs');
        if (oldValuePacksContainer) {
          const sectionId = this.container.getAttribute('data-section-id');

          if (!sectionId) {
            console.warn('Cannot found ID attr in section');
            return;
          }

          // Request Section Rendering API
          fetch(window.location.href + `&sections=${sectionId}`)
            .then(response => {
              if (!response.ok) {
                throw new Error('Error request');
              }
              return response.json();
            })
            .then(data => {
              const newHTML = data[sectionId];
              if (!newHTML) {
                console.warn('Cannot found new HTML for section:', sectionId);
                return;
              }

              const parser = new DOMParser();
              const parsedDoc = parser.parseFromString(newHTML, 'text/html');
              if (parsedDoc) {
                const newValuePacksContainer = parsedDoc.querySelector('.product-block-value-packs');
                if (newValuePacksContainer) {
                  let oldValuePacksContainer = document.querySelector('.product-block-value-packs');
                  if (oldValuePacksContainer) {
                    oldValuePacksContainer.outerHTML = newValuePacksContainer.outerHTML;
                    const qtyInput = document.querySelector('.product__quantity .js-qty__wrapper .js-qty__num');
                    if (qtyInput && window.valuePackInventoryHandler) {
                      window.valuePackInventoryHandler(qtyInput.value);
                    }
                  }
                }
              }
            })
            .catch(err => {
              console.error('Error:', err);
            });
        }
      },

      _updateImages: function (variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant.featured_image || {};

        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updatePrice: function (variant) {
        if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container.querySelector(this.originalSelectorId).dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function () {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');

        this.videoPlayer.setMuted(true);

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }

      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');

        if (this.options.style !== 'sound') {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { rootMargin: '0px 0px 50px 0px' });

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) { AOS.refreshHard() }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });

    return YouTube;
  })();

  // Patch Flickity resize event for iOS15 jank fix
  (function () {
    var originalResizeMethod = Flickity.prototype.resize;
    var lastWidth = window.innerWidth;

    Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    }
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener('touchstart', function (i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })

    document.body.addEventListener('touchmove', function (i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();




  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true) {
        if (searchParams) this.appendPreservedParams(searchParams);

        const sectionRenders = this.sections.map(section => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(searchParams);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );

        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            document.getElementById(section.nodeId).innerHTML =
              newDom.getElementById(section.nodeId).innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach(paramName => {
          const param = new URLSearchParams(window.location.search).get(
            paramName,
          );

          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },

      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${searchParams && '?'.concat(searchParams)
          }`,
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  theme.cart = {
    getCart: function () {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },

    getCartProductMarkup: function () {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then(function (response) { return response.text() });
    },

    changeItem: function (key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json())
        .then(function (cart) {
          //DWFT-3942 Cart scripts - BlueConic connection
          let enable_bluconic_connection = theme.settings.enable_bluconic_connection;
          if (enable_bluconic_connection == true) {
            getBluconicCartData();   //function calling here for shopping cart activity.
          }
          if (theme.settings.cart_saving_amount_message == 'true') {
            fetch(Shopify.routes.root + 'cart')
              .then(response => response.text())
              .then(html => {
                // Create a temporary DOM element to parse the fetched HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;

                // Find the target element in the fetched cart page
                const remoteElement = tempDiv.querySelector('.cart__item-row.discount_saving_message');
                if (!remoteElement) return;

                // Find the matching element in the current page
                const localElement = document.querySelector('.cart__item-row.discount_saving_message');
                if (!localElement) return;

                // Replace the innerHTML of the local element with the one from the fetched page
                localElement.innerHTML = remoteElement.innerHTML;
              })
              .catch(error => {
                console.error('Error fetching cart page:', error);
              });
          }
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },

    attributeToString: function (attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
      cartFooter: '.cart__item-row_footer',
      cartSavingText: '.cart__item-row--save',

      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };

    var classes = {
      btnLoading: 'btn--loading'
    };

    var config = {
      requiresTerms: false
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.cartFooter = form.querySelector(selectors.cartFooter);
      this.cartSavingText = form.querySelector(selectors.cartSavingText);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener('change', function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function () {
          this.buildCart();
        }.bind(this));
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts'),
          cartFooter: doc.querySelector('.cart__item-row_footer'),
          cartSavingText: doc.querySelector('.cart__item-row--save')
        }
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);

        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

        // Update cart footer
        if (this.cartFooter && markup.cartFooter) {
          this.cartFooter.innerHTML = markup.cartFooter.innerHTML;
        }

        // Update cart saving text
        if(this.cartSavingText && markup.cartSavingText) {
          this.cartSavingText.innerHTML = markup.cartSavingText.innerHTML;
        }

        // Below code for update progress bar after Free gift Item add/delete from cart.
        let promo_progress_bar = theme.settings.promo_progress_bar;
        let status_free_shipping_bar = theme.settings.free_shipping_progress_bar;
        if (status_free_shipping_bar == true && promo_progress_bar == true) {
          getCartItemCount();
        }
        //DWFT-4881 BYOB -> Mini-cart behaviour
        let byob_progress_bar = theme.settings.byob_progress_bar;
        if (byob_progress_bar == true) {
          getCartItemCount();
        }

        this.reInit();

        if (window.AOS) { AOS.refreshHard() }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }

        theme.cart.changeItem(key, qty)
          .then(function (cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }

            this.buildCart();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          }.bind(this))
          .catch(function (XMLHttpRequest) { });
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }

        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
        var countNew = '';

        if (count <= 99) {
          countNew = count;
        } else {
          countNew = '99+';
        }

        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = countNew;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  var counterdata = 0;
  theme.collapsibles = (function () {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };

    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };

    var namespace = '.collapsible';

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);

        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
      const parentProductSection = el.closest('.product-section');
      if (!isOpen && parentProductSection) {
        closeOtherTabs();
      }

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }

      //const form = document.querySelectorAll('form.filter-form')[1];
      const screenWidth = window.innerWidth;
      if (screenWidth > 769) {
        handleCollapsibleElements(el)
      }
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var navDomSize = 0;
        counterdata = counterdata + 1;
        if (counterdata > 1) {
          navDomSize = childHeight;
        }
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - navDomSize
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + 'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css('height', 'auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
    return {
      init: init
    };

    function closeOtherTabs() {
      let productBlocks = document.querySelectorAll('.product-section .product-block.product-block--tab.product-block--tab-tab');
      productBlocks.forEach(function (productBlock) {
        let button = productBlock.querySelector('.collapsible-trigger');
        if (button) {
          button.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
        }
        let collapsibleContent = productBlock.querySelector('[id^="Product-content"]');
        if (collapsibleContent) {
          collapsibleContent.classList.remove('is-open');
          collapsibleContent.style.height = '0px';
        }
      });
    }
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };

    var classes = {
      listVisible: 'disclosure-list--visible'
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });

    return Disclosure;
  })();

  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };

      this.nodes = {
        page: document.querySelector('#MainContent')
      };

      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }
      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });

        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function () {
          this.close();
        }.bind(this));

        // Close quickview
        document.addEventListener('closeDrawer', function () {
          if (this.config.id.indexOf('QuickShopModal') != -1) this.close();
        }.bind(this));

      },

      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.add(this.config.openClass);
        const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
        if (chatElement) {
          chatElement.style.setProperty("z-index", "25", "important");
        }
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

        this.bindEvents();
      },
      close: function (evt) {
        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }

        // deselect any focused form elements
        // document.activeElement.blur();

        theme.utils.prepareTransition(this.drawer, function () {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
        const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
        if (chatElement) {
          chatElement.style.setProperty("z-index", "9999", "important");
        }

        window.setTimeout(function () {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);

        this.isOpen = false;


        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });

        this.unbindEvents();
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function (evt) {
          this.close(evt)
          return;
        }.bind(this));

        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);

        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });

    return Drawers;
  })();

  theme.Modals = (function () {

    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector('.modal__inner');

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function () {
        this.close();
      }.bind(this));
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);
      const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (chatElement) {
        chatElement.style.setProperty("z-index", "25", "important");
      }

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
      const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (chatElement) {
        chatElement.style.setProperty("z-index", "9999", "important");
      }

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(function () {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });

      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on('keyup.modal', function (evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off('.modal');

      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };

    return Modal;
  })();

  theme.parallaxSections = {};

  theme.Parallax = (function () {
    var speed = 0.85;
    var reset = false;

    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;

      if (!this.container || !this.image) {
        return;
      }

      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function () {
          this.destroy();
        }.bind(this));

        document.addEventListener('unmatchSmall', function () {
          this.init(true);
        }.bind(this));
      }

      this.init(this.desktopOnly);
    }

    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function (desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }

        this.isInit = true;

        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }

        // Set position on page load
        this.setSizes();
        this.scrollHandler();

        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, { rootMargin: '200px 0px 200px 0px' });

        observer.observe(this.container);

        window.on('resize' + this.namespace, theme.utils.debounce(250, this.setSizes.bind(this)));

        document.addEventListener('shopify:section:reorder', theme.utils.debounce(250, this.onReorder.bind(this)));
      },

      onScroll: function () {
        if (!this.isVisible) {
          return;
        }

        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }

        requestAnimationFrame(this.scrollHandler.bind(this));
      },

      scrollHandler: function () {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },

      setSizes: function () {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },

      onReorder: function () {
        this.setSizes();
        this.onScroll();
      },

      destroy: function () {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });

    return parallax;
  })();

  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };

    function PriceRange(container, { onChange, onUpdate, ...sliderOptions } = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }

        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false
    };
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : '.add-to-cart';

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();
        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');

        status.loading = true;

        var data = theme.utils.serialize(this.form);
        var qtyparams = new URLSearchParams(data).get('quantity');

        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => response.json())
          .then(function (data) {
            if (data.status === 422) {
              this.error(data);
            } else {
              var product = data;
              this.success(product, qtyparams);
            }

            status.loading = false;
            this.addToCart.classList.remove('btn--loading');
            // Reload page if adding product from a section on the cart page
            if (document.body.classList.contains('template-cart')) {
              window.scrollTo(0, 0);
              location.reload();
            }
          }.bind(this));
      },

      success: function (product, qtyparams) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart,
            qtyparams: qtyparams
          }
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
              qtyparams: qtyparams
            }
          }));
        }
        if (theme.settings.cartType === 'cart-notification' || document.body.classList.contains('no-mini-cart-drawer')) {
          ShowCartNotification(product);
        }
        let status_promo_progress = theme.settings.select_promo_progress_bar;
        let promo_progress_bar = theme.settings.promo_progress_bar;
        let status_free_shipping_progress_bar = theme.settings.free_shipping_progress_bar;
        let status_static_message_bar = theme.settings.static_message_progress_bar;
        if ((status_promo_progress == true || status_free_shipping_progress_bar == true) && promo_progress_bar == true) {
          getCartItemCount();
        }
        if (status_static_message_bar == true && promo_progress_bar == true) {
          displayStaticContent();
        }
        //DWFT-3942 Cart scripts - BlueConic connection
        let enable_bluconic_connection = theme.settings.enable_bluconic_connection;
        if (enable_bluconic_connection == true) {
          getBluconicCartData();  //function calling here for shopping cart activity.
        }
        //DWFT-4881 BYOB -> Mini-cart behaviour
        let byob_progress_bar = theme.settings.byob_progress_bar;
        if (byob_progress_bar == true) {
          getCartItemCount();
        }
      },


      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };

      });

      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);

      theme.LibraryLoader.load('modelViewerUiStyles');
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector('#ModelJson-' + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener('mediaVisible', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener('mediaHidden', function () {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });

      model.container.addEventListener('xrLaunch', function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus',
      drawerqtyremove: '.cart-qty-removed'
    };

    var globalFocusSelector = null;

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
      this.maxValue = this.input.getAttribute('max');
      this.drawerqtyremove = el.previousElementSibling;
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    function cartRequestListener() {
      const originalFetch = window.fetch;

      window.fetch = async function (...args) {
        const requestUrl = args[0];

        if (typeof requestUrl === 'string' && requestUrl.includes('cart.js')) {
          const newButton = document.querySelector(globalFocusSelector);
          if (newButton) {
            newButton.focus();
          }
        }

        return originalFetch.apply(this, args);
      };
    }
    cartRequestListener();

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        var updatedQty;
        var beforeQty;

        // Initialize event listeners.
        document.addEventListener('click', function (event) {
          if (event.handled) return;

          const plusButton = event.target.closest('.js-qty__adjust--plus');
          const minusButton = event.target.closest('.js-qty__adjust--minus');
          const qtyInput = event.target.closest('.js-qty__num');
          const removeButton = event.target.closest('.cart__remove');
          let focusSelector = null;
          if (plusButton) {
            handleQuantityChange(plusButton, 1);
            focusSelector = '.js-qty__adjust--plus';
          } else if (minusButton) {
            handleQuantityChange(minusButton, -1);
            focusSelector = '.js-qty__adjust--minus';
          } else if (qtyInput) {
            beforeQty = qtyInput.value;
            focusSelector = '.js-qty__num';
          } else if (removeButton) {
            handleRemoveFromCart(removeButton);
          }

          event.handled = true;
          if (focusSelector) {
            globalFocusSelector = focusSelector;
            const observer = new MutationObserver(() => {
              const newButton = document.querySelector(focusSelector);
              if (newButton) {
                newButton.focus();
                observer.disconnect();
              }
            });
            observer.observe(document.body, { childList: true, subtree: true });
          }
        });

        document.addEventListener('focusout', function (event) {
          if (event.handled) return;

          const qtyInput = event.target.closest('.js-qty__num');
          if (qtyInput) {
            updatedQty = qtyInput.value;
            const itemDiv = qtyInput.closest('.cart__item');
            const cartItemUpdated = getItemDetails(itemDiv);
            _updateDatalayerWithQty(cartItemUpdated, updatedQty - beforeQty, beforeQty);
          }

          event.handled = true;
        });

        function handleQuantityChange(button, qtyChange) {
          updatedQty = qtyChange;
          const itemDiv = button.closest('.cart__item');
          const cartItemUpdated = getItemDetails(itemDiv);
          _updateDatalayerWithQty(cartItemUpdated, updatedQty);

          checkPromoProgress();
        }

        function handleRemoveFromCart(button) {
          beforeQty = parseInt(document.querySelector('.js-qty__num')?.value || 0);
          const itemDiv = button.closest('.cart__item');
          const cartItemUpdated = getItemDetails(itemDiv);
          _updateDatalayerWithQty(cartItemUpdated, -beforeQty, beforeQty);
        }

        function checkPromoProgress() {
          let status_promo_progress = theme.settings.select_promo_progress_bar;
          let promo_progress_bar = theme.settings.promo_progress_bar;
          let status_free_shipping_bar = theme.settings.free_shipping_progress_bar;

          if ((status_promo_progress === true || status_free_shipping_bar === true) && promo_progress_bar === true) {
            setTimeout(getCartItemCount, 1500);
          }
        }

        function _updateDatalayerWithQty(productUpdated, diffQty, beforeQty = 0) {
          if (productUpdated.id) {
            if (parseInt(beforeQty) < parseInt(beforeQty + diffQty)) {
              ga4AddToCartEvent(productUpdated, false, diffQty);
            } else {
              dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
              const item_Variant_Value = productUpdated.isBundleTag === 'true'
                ? `pd_bundle ${productUpdated.title}`
                : productUpdated.variantTitle;
              dataLayer.push({
                'event': "remove_from_cart",
                'ecommerce': {
                  'items': [{
                    'item_id': productUpdated.id,
                    'item_name': productUpdated.title,
                    'currency': window.theme.settings.currency,
                    'item_variant': item_Variant_Value,
                    'price': +calculatePriceDiscount(productUpdated.price, productUpdated.comparePrice, productUpdated.finalPrice).variantActualPrice,
                    'quantity': Math.abs(diffQty),
                  }]
                }
              });
            }
          }
        }

        // Add another set of event listeners.
        this.plus?.addEventListener('click', () => this._change(this._getQty() + 1));
        this.minus?.addEventListener('click', () => this._change(this._getQty() - 1));
        this.drawerqtyremove?.addEventListener('click', () => {
          var getRemovedItemQty = this._getQty();
          getdlcartdata(getRemovedItemQty);
          this._change(0);
        });
        this.input?.addEventListener('change', () => this._change(this._getQty()));
      },

      _getQty: function () {
        var qty = this.input.value;
        if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        if (this.maxValue) {
          if ((qty > this.maxValue && this.options.isCart) || (qty > 50 && this.options.isCart)) {
            if (this.maxValue > 50) {
              qty = 50;
            } else {
              qty = this.maxValue;
            }
          }
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');

        var variantIndex = el.dataset.variantIndex || '';
        theme.preloadProductModal(handle, productId, btn, variantIndex);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn, vIndex) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    if (vIndex != "") {
      var url = theme.routes.home + '/products/' + handle + '?variant=' + productId + '&view=modal';
    } else {
      var url = theme.routes.home + '/products/' + handle + '?view=modal';
    }

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');

    fetch(url).then(function (response) {
      return response.text();
    }).then(function (html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');

      if (!holder) {
        return;
      }

      holder.innerHTML = '';
      holder.append(div);

      var modalId = 'QuickShopModal-' + productId;
      productId = (vIndex != "") ? productId + '-' + vIndex : productId;

      if (theme.settings.quickViewStyle === "drawer") {
        // Setup quick view drawer
        var name = 'quick-drawer-' + productId;
        new theme.Drawers(modalId, name, true);
      } else {
        // Setup quick view modal
        var name = 'quick-modal-' + productId;
        new theme.Modals(modalId, name);
      }

      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);

      // Register collapsible elements
      theme.collapsibles.init();

      // Register potential video modal links (when video has sound)
      theme.videoModal();

      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };

    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };

    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        avoidReflow(el);
      }

      this.slideshow = new Flickity(el, this.args);
      // Flickity carousel is now ready, we can access its properties for testimonial slider
      var totalCount = this.slideshow.slides.length;
      var progressBars = document.querySelectorAll('.progress-bar-wrapper .progressbar');
      var slideshow = this.slideshow;  // Capture the context of `this` here
      progressBars.forEach(function (progressBar) {
        slideshow.on('change', function (slide) {
          // Get the index of the current slide
          let currentIndex = slide + 1;
          let prc = (currentIndex / totalCount) * 100 + '%';
          progressBar.style.width = prc;
        });
      });

      // Since the Flickity slider does not have options for specifying an HTML tag for the wrapper,
      // and the structure cannot be overwritten with its own after reinit, we use [role=“list”] for wrapper slides
      const flickityWrapper = el.querySelector('.flickity-slider');
      flickityWrapper && flickityWrapper.setAttribute('role', 'list');

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function () {
        this.resize();
      }.bind(this)));

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) { // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) { AOS.refresh() }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function () {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);

            // To refactor and fix DWFT-905 product image swipe issue.
            let elementClicked = false;
            const buttonRight = document.getElementById('carousel-image-zoom-right');
            buttonRight.addEventListener('click', function handleClick() {
              elementClicked = true;
            });
            const buttonLeft = document.getElementById('carousel-image-zoom-left');
            buttonLeft.addEventListener('click', function handleClick() {
              elementClicked = true;
            });

          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);

          link.addEventListener('click', function (evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function (evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function (evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach(a => {
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);

        if (!this.args.childNavScroller) {
          return;
        }

        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },

      arrowClick: function (evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: 'disabled'
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));

        // Set default state based on current selected variant
        this.setAvailability(null, this.currentVariantObject);
        // Remove non-existent size options from the current color
        this.checkAvailableSizes();
        // Change the range of sizes depends on the current color
        this.setVariantSizesRange();
      },

      checkAvailableSizes: () => {
        const selectedColor = document.querySelector('.variant-input-wrap.is-color .variant-item input:checked');
        const productSizes = document.querySelectorAll('.variant-input-wrap.size-fieldset .variant-item');
        const productSelect = document.querySelector('.product-variants-select');

        productSizes.forEach(sizeItem => {
          let variantTitle = `${selectedColor.value} / ${sizeItem.dataset.value}`.trim();
          let wasFound = false;

          Array.from(productSelect).forEach(option => {
            if (option.dataset.variantTitle.includes(variantTitle) && !wasFound) {
              wasFound = true;
            }
          })

          if (!wasFound) {
            sizeItem.style.display = 'none';
          } else {
            sizeItem.style.display = 'list-item';
          }
        })
      },

      selectAvaiableVariant: (variantSizes) => {
        let isVariantSelected = false;
        let isFirstClick = false;

        variantSizes.forEach(sizeItem => {
          const label = sizeItem.querySelector('label');
          if (!isFirstClick && window.getComputedStyle(sizeItem).getPropertyValue('display') != 'none') {
            // After the first click, the options update their disabled status 
            // for further functionality to understand the exact available status of a variant
            label.click();
            isFirstClick = true;
          }

          if (!label.classList.contains('disabled') && !isVariantSelected) {
            // This functionality finds the final required avaiable label and makes it active
            label.click();
            isVariantSelected = true;
          }
        });
      },

      setVariantSizesRange: () => {
        const variantSizes = Array.from(document.querySelectorAll('.variant-input-wrap.size-fieldset .variant-item'));
        const visibleSizes = variantSizes.filter(sizeItem => window.getComputedStyle(sizeItem).display !== 'none');

        const firstSizeValue = visibleSizes.length > 0 ? visibleSizes[0].dataset.value : null;
        const lastSizeValue = visibleSizes.length > 0 ? visibleSizes[visibleSizes.length - 1].dataset.value : null;

        const firstSizeElement = document.querySelector('.size-option-range .size-first-variant');
        const lastSizeElement = document.querySelector('.size-option-range .size-last-variant');

        if (firstSizeElement && lastSizeElement && firstSizeValue && lastSizeValue) {
          firstSizeElement.innerText = firstSizeValue;
          lastSizeElement.innerText = lastSizeValue;
        }
      },

      setAvailability: function (evt, variant) {
        this.checkAvailableSizes();
        this.setVariantSizesRange();

        if (evt) {
          var variant;

          if (evt.detail.variant) {
            variant = evt.detail.variant;
          } else {
            var urlParams = new URLSearchParams(window.location.search);
            var variantId = urlParams.get('variant');

            if (variantId) {
              variant = JSON.parse(document.querySelector(`.product-variants-select option[value="${variantId}"]`).innerText);
            }

            // We need setTimeout to make this function work only after the options are updated
            setTimeout(() => {
              const variantSizes = document.querySelectorAll('.variant-input-wrap.size-fieldset .variant-item');
              this.selectAvaiableVariant(variantSizes);
            }, 0);
          }
        }

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: []
        };

        var ignoreIndex = null;
        var availableVariants = this.variantsObject.filter(function (el) {
          if (!variant || variant.id === el.id) {
            return false;
          }

          if (variant.option2 === el.option2 && variant.option3 === el.option3) {
            return true;
          }

          if (variant.option1 === el.option1 && variant.option3 === el.option3) {
            return true;
          }

          if (variant.option1 === el.option1 && variant.option2 === el.option2) {
            return true;
          }
        });

        var variantObject = {
          variant: variant
        };

        var variants = Object.assign({}, { variant }, availableVariants);

        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property];
            if (!item) {
              return;
            }

            var value1 = item.option1;
            var value2 = item.option2;
            var value3 = item.option3;
            var soldOut = item.available === false;

            if (value1 && ignoreIndex !== 'option1') {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut
              });
            }
            if (value2 && ignoreIndex !== 'option2') {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut
              });
            }
            if (value3 && ignoreIndex !== 'option3') {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut
              });
            }
          }
        }

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + option + '"]');

        if (group != null) {
          // Loop through each option value
          values.forEach(obj => {
            this.enableVariantOption(group, obj);
          });
        }
      },

      enableVariantOptionByValue: function (array, index) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="' + index + '"]');

        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i]);
        }
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');

        if (this.type === 'dropdown') {
          group.querySelector('option[value="' + value + '"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');

          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);

          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
          }
        }
      },

      disableVariantGroup: function (group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }

    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;

    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }

    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });

    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });

    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });

    document.addEventListener('modalClose.VideoModal', closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match && match[7].length == 11) ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };



  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }

      document.addEventListener('matchSmall', function () {
        unload();
        initSlider();
      });

      document.addEventListener('unmatchSmall', function () {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      document.querySelector(`header.section-header`).classList.add("hide");
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
          document.querySelector(`header.section-header`).classList.add("hide");
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
          document.querySelector(`header.section-header`).classList.remove("hide");
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function () {
          newAddressForm.classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });

      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
            }
          }
        })
      });
    }
  };



  theme.CartDrawer = (function () {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener('ajaxProduct:added', function (evt) {
          document.dispatchEvent(new CustomEvent('closeDrawer'));
          this.cartForm.buildCart();
          this.open();
        }.bind(this));

        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },

      open: function () {
        this.drawer.open();
      },

      close: function () {
        this.drawer.close();
      }
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };

    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };

    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }

      accessibleDropdowns();
      searchDrawer();

      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderHeight();

      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }

      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
        el.on('mouseleave' + config.namespace, closeDropdowns);
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });

      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function () {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });

      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }

    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function () {
        container.classList.add('is-active');
      }.bind(this));

      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
      const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (chatElement) {
        chatElement.style.setProperty("z-index", "25", "important");
      }

      setTimeout(function () {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: container.querySelector('.site-header__search-input')
        });
      }, 100);

      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0, 0);
      }

      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);

      bindSearchEvents();
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }

            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
      const chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (chatElement) {
        chatElement.style.setProperty("z-index", "9999", "important");
      }

      window.setTimeout(function () {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function () {
        container.classList.remove('is-active');
      }.bind(this));

      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });

      theme.a11y.unlockMobileScrolling(config.namespace);

      unbindSearchEvents();
      theme.a11y.moveFocus('searchBtnClose');
    }

    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function (evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));

      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function (evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }

    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };

  theme.predictiveSearch = (function () {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';

    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',

      searchButton: '[data-predictive-search-button]'
    };

    var cache = {};
    var config = {
      imageSize: 'square'
    }

    var classes = {
      isActive: 'predicitive-active'
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };

    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      cache.wrapper = document.querySelector(selectors.wrapper);

      if (!cache.wrapper) {
        return;
      }

      config.imageSize = cache.wrapper.dataset.imageSize;

      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);

      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);

      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);

      cache.results = document.querySelector(selectors.resultDiv);
    }

    function reset() {
      cache.wrapper.classList.add('hide');
      cache.results.innerHTML = '';
      clearTimeout(searchTimeout);
    }

    function triggerSearch() {
      cache.form.submit();
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += '*';
      }

      var params = paramUrl(obj);

      window.location.href = '/search?' + params;
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
    }

    function search() {
      var keyword = cache.input.value;

      if (keyword === '') {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        'q': q,
        'resources[type]': theme.settings.predictiveSearchType,
        'resources[limit]': 4,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };

      var params = paramUrl(searchObj);

      fetch('/search/suggest.json?' + params)
        .then(response => response.json())
        .then(suggestions => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          cache.wrapper.classList.remove('hide');
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case 'products':
                data[type] = buildProducts(results);
                break;
              case 'collections':
                data[type] = buildCollections(results);
                break;
              case 'pages':
                data[type] = buildPages(results);
                break;
              case 'articles':
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = '';
          cache.results.innerHTML = output;
        });
    }

    function buildProducts(results) {
      var output = '';
      var products = [];

      results.forEach(product => {
         if (!product.available) {
            return;
          }
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          featured_image: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItemforSearch(products, 'small--one-half medium-up--one-quarter', 4, config.imageSize);

        output = `
          <div data-type-products>
            <ul class="grid grid--uniform">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = '';

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function buildPages(pages) {
      var output = '';

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = '';

      articles.forEach(article => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(article.image, '200x200_crop_center');
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <ul class="grid grid--uniform">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = '';

      if (data.products && data.products !== '') {
        output += data.products;
      }

      if (data.collections && data.collections !== '') {
        output += data.collections;
      }

      if (data.pages && data.pages !== '') {
        output += data.pages;
      }

      if (data.articles && data.articles !== '') {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }

      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj).map(function (key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }

    return {
      init: init
    };
  })();

  theme.buildProductGridItem = function (items, gridWidth, gridWidthForMob, rowOf, imageSize) {
    var output = '';
    items.forEach((product, prodIndex) => {
      var tags = product.tags;
      // checking core-product by using tags to block the product.
      if (tags.indexOf('core-product') !== -1) {
        return;
      }
      var flowtext = "";
      var flowimg = "";
      let mixedFlowTag = false;

      tags.forEach(element => {
        if (element.includes("abs")) {
          const alltag = element.split(":");
          let tags = alltag[1];
          if (tags == "light") {
            flowimg = theme.images.lightflow;
            flowtext = theme.strings.absorbencylight;
          }
          else if (tags == "moderate") {
            flowimg = theme.images.moderateflow;
            flowtext = theme.strings.absorbencymedium;
          }
          else if (tags == "heavy") {
            flowimg = theme.images.heavyflow;
            flowtext = theme.strings.absorbencyheavy;
          }
          else if (tags == "superheavy") {
            flowimg = theme.images.superheavyflow;
            flowtext = theme.strings.absorbencysuperheavy;
          }
          else if (tags == "overnight") {
            flowimg = theme.images.overnight;
            flowtext = theme.strings.absorbencyovernight;
          }
          else if (tags == "x" || tags == "ix") {
            flowimg = theme.images.mixedflow;
            flowtext = theme.strings.absorbencymix;
            mixedFlowTag = true;
          }
          else if (tags == "f") {
            flowimg = theme.images.multifluid;
            flowtext = theme.strings.absorbencymultifluid;
          }
        }
      });
      var variants = product.options;
      var colorlist = variants[0].values;

      const colorindex = [];
      var variantswatch = [];
      var colorfound = '';
      colorlist.forEach(colorlabels => {
        colorfound = colorlabels;
        colorindex.push(colorfound);
      });
      var img_local_url = product.featured_image.lastIndexOf("/files/") !== -1 ?
        product.featured_image.substring(0, product.featured_image.lastIndexOf("/files/")) :
        product.featured_image;

      let first_color_name = null;
      colorindex.forEach((colorvariants, index) => {
        var vs = colorvariants.replaceAll('/', '-').replaceAll(' ', '-').toLowerCase();

        if (index == 0) first_color_name = colorvariants;
        if (!colorvariants.toLowerCase().includes('default title')) {
          variantswatch.push(`
          <button data-url="${product.url}" class="color-swatch color-swatch--small color-swatch--noire color-swatch--with-image link-obfuscate" data-variant-id="${product.id}" data-variant-image="//cdn.shopify.com/s/files/1/0652/1677/4400/products/nana_culotte_menstruelle_flux_modere_hipster_noir_79f280be-5a92-4b3b-953d-352301d4ed44_400x.jpg?v=1670396374" aria-label="${product.title} - ${colorvariants}" style="background-color: ${colorvariants};  background-image: url(https:${img_local_url}/files/${vs}_50x50.png);">
          <span class="visually-hidden">${colorvariants}</span>
          </button>`);
        }
      });

      var alllist = variantswatch.toString().replaceAll(',', '');

      var multipleColorSwatchUrl = `https:${img_local_url}/files/multiplecolor_50x50.png`;
      
      var productDisplayTitle = product.title;
      if (product.display_title) {
        productDisplayTitle = product.display_title;
      }
      if (product.metafields && product.metafields.custom && product.metafields.custom.display_title) {
        productDisplayTitle = product.metafields.custom.display_title;
      }
      var price = theme.Currency.formatMoney(product.price, theme.settings.moneyFormat);
      var image = theme.buildProductImage(product, imageSize);
      var imageSecond = null;

      if (product.images[1]) {
        imageSecond = theme.buildProductImage(product, imageSize, true);
      }

      var discountPercentage = null;
      var priceValue = product.price_max;
      var comparePrice = product.compare_at_price_max;
      var cleanDiscountLabelText = function (value) {
        if (!value || value === 'undefined') {
          return '';
        }
        if (typeof value === 'string' && value.indexOf('translation missing') > -1) {
          return '';
        }
        return value;
      };
      var discount_Percentage_label = cleanDiscountLabelText(theme.strings.discountPercentage_label);
      var discount_Percentage_label_prefix = cleanDiscountLabelText(theme.strings.discountPercentage_label_prefix || theme.strings.discount_Percentage_label_prefix);

      if (comparePrice && comparePrice > priceValue) {
        discountPercentage = Math.ceil(((comparePrice - priceValue) / comparePrice) * 100);
      }

      // We use a different camel_case to match liquid,
      // since these variables perform identical functionality in .liquid files
      var ribbon_text = null; // custom tag ribbon item
      var ribbon_text_color = null; // color of text
      var ribbon_color = null; // bg color
      var mixed_flow_classes = product.tags.includes('abs:ix') || product.tags.includes('abs:x') ? 'mixed-flow' : '';

      var color_buttons = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-button-color-global'); // color of text secondary option
      var bg_buttons = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-badge-bg-color'); // bg color secondary option
      var colors_text = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-colors-text'); // In x colors text
      product.tags.forEach(tag => {
        if (tag.includes('ribtc:')) {
          ribbon_text_color = tag.replace('ribtc:', '');
        }

        if (tag.includes('ribc:')) {
          ribbon_color = tag.replace('ribc:', '');
        }

        if (tag.includes('rib:')) {
          ribbon_text = tag.replace('rib:', '');
        }
      });

      var hide_recent_flow = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-product-flow-icons');
      var hide_recent_variants = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-product-hide-variants');
      var hide_recent_flow_desktop = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-product-flow-icons-desktop');
      var hide_recent_variants_desktop = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-product-hide-variants-desktop');
      var hide_reviews_desktop = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-hide-reviews-desktop');
      var hide_reviews_mobile = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-hide-reviews-mob');
      var baazar_voice_review = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-bazaarvoice-review-show');
      var power_review = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-power-review-show');
      var save_html = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-save-html');
      var discount_text_enable = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-discount-badge');
      var sale_label = document.querySelector('[data-section-type="recently-viewed"]').getAttribute('data-sale-label');
      var discount_badge_text = null;

      if (discount_text_enable == 'true') {
        let hasDiscountedVariant = false;
        let allVariantsDiscounted = product.variants.length > 0;
        let referenceDiscount = null;
        let hasMixedDiscounts = false;

        product.variants.forEach((variant) => {
          const compareAtPrice = variant.compare_at_price || 0;

          if (compareAtPrice > variant.price) {
            hasDiscountedVariant = true;

            const discountRaw = ((compareAtPrice - variant.price) / compareAtPrice) * 100;
            const roundedDiscount = Math.floor((discountRaw + 2.5) / 5) * 5;

            if (referenceDiscount === null) {
              referenceDiscount = roundedDiscount;
            } else if (referenceDiscount !== roundedDiscount) {
              hasMixedDiscounts = true;
            }
          } else {
            allVariantsDiscounted = false;
          }
        });

        if (hasDiscountedVariant) {
          discount_text_enable = true;
          const discountPercentageText = `${discount_Percentage_label_prefix}${referenceDiscount}%`;
          discount_badge_text = allVariantsDiscounted && !hasMixedDiscounts
            ? [discountPercentageText, discount_Percentage_label.toUpperCase()].filter(Boolean).join(' ')
            : sale_label;
        } else {
          discount_text_enable = false;
        }
      } else {
        discount_text_enable = false;
      }
    
      var hideRecentFlowClass = "";
      var hideRecentVariantsClass = "";
      var hideRecentFlowClassDesktop = "";
      var hideRecentVariantsClassDesktop = "";
      var hideReviewsDesktopClass = "";
      var hideReviewsMobileClass = "";

      if (hide_recent_flow == 'true') {
        hideRecentFlowClass = "hide-mobile";
      }
      if (hide_recent_variants == 'true') {
        hideRecentVariantsClass = "hide-mobile";
      }
      if (hide_recent_flow_desktop == 'true') {
        hideRecentFlowClassDesktop = "hide-desktop";
      }
      if (hide_recent_variants_desktop == 'true') {
        hideRecentVariantsClassDesktop = "hide-desktop";
      }
      if (hide_reviews_desktop == 'true') {
        hideReviewsDesktopClass = "hide-web"
      }
      if (hide_reviews_mobile == 'true') {
        hideReviewsMobileClass = "hide-mobile"
      }
      const isAvailable = product.variants.some(variant => variant.available);
      if (!isAvailable) {
        return;
      }
      var markup = `
        <li class="grid__item rounded-corner grid-product swiper-slide swiper-slide-recently-viewed aos-animate" data-aos="row-of-${rowOf}" data-product-id="${product.id}" data-handle="${product.handle}">
          <div class="grid-product__content">
          <div class="ribbon-container">
              ${
                ribbon_text && !discount_text_enable
                  ? `<span class="ribbon-item" style="
                        color: ${ribbon_text_color ? ribbon_text_color : (color_buttons ? color_buttons : '')};
                        background-color: ${ribbon_color ? ribbon_color : (bg_buttons ? bg_buttons : '')};
                      ">
                        ${ribbon_text}
                    </span>`
                  : discount_badge_text && discount_text_enable
                  ? `<span class="ribbon-item" style="
                        color: ${ribbon_text_color ? ribbon_text_color : (color_buttons ? color_buttons : '')};
                        background-color: ${ribbon_color ? ribbon_color : (bg_buttons ? bg_buttons : '')};
                      ">
                        ${discount_badge_text}
                    </span>`
                  : ''
              }
            </div>
            <a href="${product.url}" 
              class="grid-product__link"
              data-product-handle="${product.handle}" 
              data-product-index="${prodIndex}"
              data-product-id="${product.id}"
              data-product-name="${product.title}"
              data-product-index="{{ prodOrder }}"
              data-product-title="${product.title}" 
              data-variant-price="${product.variants[0].price}" 
              data-variant-compare-price="${product.variants[0].compare_at_price || 0}" 
              data-product-final-price="${product.variants[0].price}" 
              data-variant-title="${product.variants[0].title}"
              onclick="productGridClick(event)"
              tabindex="0">
              <div class="grid-product__image-mask">
                ${image}
                ${imageSecond != null ? imageSecond : ''}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title grid-product__title--body">
                  <h3 class="h4">${productDisplayTitle}</h3>
                </div>
              </div>
            </a>
              
              ${String(baazar_voice_review) === 'true' ?
          `<div class="collection-page-product-review ${hideReviewsDesktopClass} ${hideReviewsMobileClass}">
                  <div
                    data-bv-show="inline_rating"
                    data-bv-product-id="${product.id}"
                    data-bv-redirect-url="${product.url}"
                    data-bv-seo="false"></div>
                  </div>`
          :
          ''
        }
               </div>

          </div>
                            <div class="recently-viewed flow ${hideRecentFlowClass} ${hideRecentFlowClassDesktop} ${mixed_flow_classes}">
                  ${flowimg ? `<img class="absorbency-image flow__image ${mixedFlowTag ? 'is--images' : ''}" src="${flowimg}" alt="Flux légers" width="15px" height="15px">` : ''}
                    <p class="flow__heading">${flowtext}</p>
                  </div>
              <div class="wrap-flow_swatches_price recently-reviewed">
                <div class="wrap-flow_swatches">
                ${variantswatch.length > 0 ? ` 
                  <div class="grid-product__colors recently-viewed grid-product__colors--${product.id} ${hideRecentVariantsClass} ${hideRecentVariantsClassDesktop}" data-swatch-size="${variantswatch.length}">
                  ${variantswatch.length === 1 ?
            alllist + `<span>${first_color_name}</span>` :
            `<button data-url="${product.url}" style="background-image: url(${multipleColorSwatchUrl});" class="color-swatch color-swatch--small color-swatch--multiple color-swatch--with-image-multiple link-obfuscate" aria-label="${product.title}">
              
            </button><div class="colors-label">${colors_text.replace('{{count}}', variantswatch.length)}</div>`
          } 
                  </div>`
          :
          '' // We need to add '' if false because if we don't add it, the frontend will display false string
        } ${String(power_review) === 'true' ?
          `<div class="power-reviews__container ${hideReviewsDesktopClass} ${hideReviewsMobileClass}">
                      <div id="pr-reviewsnippet-${product.id}-recently-viewed"></div>
                    </div>`
          :
          ''
        } 
                </div>
                <div class="grid-product__price">
                  ${product.compare_at_price > 0 && product.compare_at_price > product.price ?
          `<span class="grid-product__price--original">
                      <del>
                        ${product.compare_at_price > 0 && product.compare_at_price > product.price ?
            theme.Currency.formatMoney(product.compare_at_price, theme.settings.moneyFormat) :
            ''
          }
                        </del>
                    </span>`
          :
          ''
        }
          <span class="grid-product__price--wrapper">
            ${product.compare_at_price > 0 && product.compare_at_price > product.price ?
            `<span class="grid-product__price--savings">${save_html.replace('{{ saved_amount }}', theme.Currency.formatMoney(product.compare_at_price - product.price, theme.settings.moneyFormat))}</span>
            <span class="grid-product__price--savings mobile">-${theme.Currency.formatMoney(product.compare_at_price - product.price, theme.settings.moneyFormat)}</span>
            ` : ''
            }
            <span class="grid-product__price--after">${price}</span>
          </span>

          </div>
        </li>
      `;
      output += markup;
    });

    return output;
  }
  
  function fetchBottomRibbonHTML(productUrl) {
    return fetch(`${Shopify.routes.root}${productUrl.replace(/^\//, '')}`)
      .then(response => response.text())
      .then(htmlText => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const el = doc.querySelector('.product__ribbon-container .grid-product__bottom-ribbon');
        return el ? el.outerHTML : '';
      })
      .catch(error => {
        console.error('Error:', error);
        return '';
      });
  }

  theme.buildProductGridItemforSearch = function (items, gridWidth, rowOf, imageSize) {
    var output = '';
    items.forEach(product => {
      var productDisplayTitle = product.title;
      if (product.display_title) {
        productDisplayTitle = product.display_title;
      }
      if (product.metafields && product.metafields.custom && product.metafields.custom.display_title) {
        productDisplayTitle = product.metafields.custom.display_title;
      }
      var image = theme.buildProductImage(product, imageSize);
      var markup = `
        <li class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${productDisplayTitle}</div>
              </div>
            </a>
          </div>
        </li>
      `;

      output += markup;
    });

    return output;
  }
  theme.buildProductImage = function (product, imageSize, secondImage) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';
    var imageSource = product.featured_image;
    var classesWrapper = `grid__image-ratio grid__image-ratio--${size}`;

    if (secondImage === true && product.images[1]) {
      imageSource = product.images[1];
      classesWrapper = 'grid-product__secondary-image small--hide'
    }

    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image"
              src="${imageSource.replace('{width}', '540')}"
              srcset="
                ${imageSource.replace('{width}', '230')} 230w,
                ${imageSource.replace('{width}', '460')} 460w,
                ${imageSource.replace('{width}', '540')} 540w"
              sizes="(max-width: 768px) 39vw, (min-width: 769px) 20vw"
              alt="${product.title}">
        </div>`;
    } else {
      var classes = '';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
        <div class="${classesWrapper}">
          <img class="${classes}"
              src="${imageSource.replace('{width}', '540')}"
              srcset="
                ${imageSource.replace('{width}', '230')} 230w,
                ${imageSource.replace('{width}', '460')} 460w,
                ${imageSource.replace('{width}', '540')} 540w"
              sizes="(max-width: 768px) 39vw, (min-width: 769px) 20vw"
              alt="${product.title}">
        </div>
      `;
    }

    return output;
  }

  theme.buildCollectionItem = function (items) {
    var output = '';

    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  }

  theme.buildPageItem = function (items) {
    var output = '';

    items.forEach(page => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  }

  theme.buildArticleItem = function (items, imageSize) {
    var output = '';

    items.forEach(article => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;

      output += markup;
    });

    return output;
  }

  theme.buildPredictiveImage = function (obj) {
    var imageMarkup = '';
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  }


  theme.Maps = (function () {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {};

    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }

      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });

      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError);
    };

    window.mapError = function (error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };

    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;

      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };

      if (!this.key) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }

    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }

    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting;

      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function () {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {

              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      createMap: function () {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function (results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };

              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });

              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function () {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );

              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function (status) {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      onUnload: function () {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });

    return Map;
  })();

  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
      var templateName = this.container.getAttribute('data-prerequisite-templates');
      this.cookieName = 'newsletter-' + sectionId;

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }

      // popup display after visited page
      if (window.theme.settings.templateName === templateName) {
        sessionStorage.setItem('afterVisistedPage', 'true');
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode
      };

      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }

      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));

      if (!this.data.cookie || this.data.testMode === 'true') {
        this.initPopupDelay();
      }

    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (Shopify && Shopify.designMode) {
          return;
        }
        if (sessionStorage.getItem('afterVisistedPage')) {
          setTimeout(function () {
            this.modal.open(),
              document.dispatchEvent(new CustomEvent('NewsletterPopup:open', {
                detail: {
                  data: this.data
                }
              }));
          }.bind(this), this.data.secondsBeforeShow * 1000);
        }
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode

        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });

      },

      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      }
    });
    return NewsletterPopup;
  })();

  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector('#LoginModal')) {
          return;
        }

        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });

        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === 'false') {
        return;
      }

      if (container.dataset.hasSlideshow === 'true') {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },

      triggerClick: function (evt) {
        this.items = this.getImageData();

        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;

        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }
        }

        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

        this.gallery.init();
        this.gallery.listen('afterChange', this.afterChange.bind(this));
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      }
    });

    return Photoswipe;
  })();


  theme.preprocessProductRecommendations = (placeholder, div) => {
    // Desktop.
    const reviewWeb = placeholder && placeholder.dataset.reviewWeb === 'true';
    const flowWeb = placeholder && placeholder.dataset.flowWeb === 'true';
    const variantWeb = placeholder && placeholder.dataset.variantWeb === 'true';
    // Mobile.
    const review = placeholder && placeholder.dataset.review === 'true';
    const flow = placeholder && placeholder.dataset.flow === 'true';
    const variants = placeholder && placeholder.dataset.variants === 'true';

    // Product reviews.
    if (reviewWeb || review) {
      // Find all DOM element with "power-reviews__container" class.
      var powerReviewsContainers = div.querySelectorAll('.power-reviews__container');

      if (powerReviewsContainers.length > 0) {
        // Add the "hide-web" or "hide-mobile" class to all of it.
        powerReviewsContainers.forEach(function (container) {
          if (reviewWeb) {
            container.classList.add('hide-web');
          }
          if (review) {
            container.classList.add('hide-mobile');
          }
        });
      } else {
        // If there isn't "power-reviews__container" class, search for "collection-page-product-review" class items.
        var collectionPageProductReviews = div.querySelectorAll('.collection-page-product-review');

        // Add the "hide-web" or "hide-mobile" class to all of it.
        collectionPageProductReviews.forEach(function (container) {
          if (reviewWeb) {
            container.classList.add('hide-web');
          }
          if (review) {
            container.classList.add('hide-mobile');
          }
        });
      }
    }

    // Flow.
    if (flowWeb || flow) {
      // Find all DOM element with "flow" class.
      var flowContainers = div.querySelectorAll('.flow');

      if (flowContainers.length > 0) {
        // Add the "hide-web" or "hide-mobile" class to all of it.
        flowContainers.forEach(function (container) {
          if (flowWeb) {
            container.classList.add('hide-web');
          }
          if (flow) {
            container.classList.add('hide-mobile');
          }
        });
      }
    }

    // Variants.
    if (variantWeb || variants) {
      // Find all DOM element with "grid-product__colors" class.
      var gridProductColorsContainers = div.querySelectorAll('.grid-product__colors');

      if (gridProductColorsContainers.length > 0) {
        // Add the "hide-web" or "hide-mobile" class to all of it.
        gridProductColorsContainers.forEach(function (container) {
          if (variantWeb) {
            container.classList.add('hide-web');
          }
          if (variants) {
            container.classList.add('hide-mobile');
          }
        });
      }
    }

    return div;
  }

  theme.Recommendations = (function () {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }

    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;

      selectors.recommendations = 'Recommendations-' + this.sectionId;

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations);

        if (!section || section.dataset.enable === 'false') {
          return;
        }

        var id = section.dataset.productId;
        var limit = section.dataset.limit;

        var url = this.url + '?section_id=product-recommendations&limit=' + limit + '&product_id=' + id;

        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass)
          if (wrapper) {
            wrapper.innerHTML = '';
          }
        }

        fetch(url).then(function (response) {
          return response.text();
        }).then(function (html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }

          placeholder.innerHTML = '';

          if (!div) {
            this.container.classList.add('hide');
            return;
          }

          // Preprocess product recommendations.
          div = theme.preprocessProductRecommendations(placeholder, div);

          placeholder.appendChild(div);

          theme.reinitProductGridItem(section);

          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));

          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }

          const recommendedElement = document.querySelector(selectors.sectionClass);
          const recommendedSlides = recommendedElement.querySelectorAll('.swiper-slide');
          if (recommendedSlides.length < 4) {
            recommendedElement.classList.add('center-slides');
          }

          new Swiper(recommendedElement, {
            speed: 500,
            navigation: {
              nextEl: `.${recommendedElement.querySelector('.swiper-button-next').dataset.className}`,
              prevEl: `.${recommendedElement.querySelector('.swiper-button-prev').dataset.className}`,
            },
            keyboard: {
              enabled: true,
            },
            breakpoints: {
              769: {
                slidesPerView: 4,
                spaceBetween: 20
              },
              1: {
                slidesPerView: 2,
                spaceBetween: 19
              }
            }
          })
        }.bind(this));
      }
    });

    return Recommendations;
  })();

  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) { return }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }

    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');

        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }

        if (this.container.hasAttribute('data-parallax')) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(function (el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + '-parallax-' + i
            });
          }.bind(this));
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function () {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function (variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';

        var self = this;

        fetch(variantSectionUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }

            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;

            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }

            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }

            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: '.video-parent-section'
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add('loaded');

          var playPromise = document.querySelector('#' + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function () {
              // playback normal
            }).catch(function () {
              mp4Div.setAttribute('controls', '');
              parent.classList.add('video-interactable');
            });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });

    return videoSection;
  })();


  theme.BackgroundImage = (function () {

    var selectors = {
      parallaxContainer: '.parallax-container'
    };

    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }

      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }

    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function () {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true
          };

          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      },

      onUnload: function (evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });

    return backgroundImage;
  })();

  theme.Blog = (function () {

    function Blog(container) {
      this.tagFilters();
    }

    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function () {
        var filterBy = document.getElementById('BlogTagFilter');

        if (!filterBy) {
          return;
        }

        filterBy.addEventListener('change', function () {
          location.href = filterBy.value;
        });
      }
    });

    return Blog;
  })();

  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = '.collection-header';

      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);

        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector('.parallax-container');
          var args = {
            namespace: this.namespace + '-parallax'
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },

      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function () {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.onUnload();

        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
        theme.SortDrawer = new theme.Drawers('SortDrawer', 'sort-filters', true);
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },

      onDeselect: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },

      onUnload: function () {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });

    return CollectionSidebar;
  })();

  // Sort Sidebar
  theme.SortSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };

    function SortSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    SortSidebar.prototype = Object.assign({}, SortSidebar.prototype, {
      init: function () {
        // Do not load when no sidebar exists
        if (!this.container) {
          return;
        }

        this.onUnload();

        drawerStyle = this.container.dataset.style === 'drawer';
        theme.SortDrawer = new theme.Drawers('SortDrawer', 'sort-filters', true);
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.SortDrawer) {
          if (!drawerStyle) {
            theme.SortDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.SortDrawer.open();
          }
        }
      },

      onDeselect: function () {
        if (theme.SortDrawer) {
          theme.SortDrawer.close();
        }
      },

      onUnload: function () {
        if (theme.SortDrawer) {
          theme.SortDrawer.close();
        }
      }
    });

    return SortSidebar;
  })();

  theme.Collection = (function () {
    var isAnimating = false;

    var selectors = {
      sortSelect: '#SortBy',

      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
      productCardSwatch: '[data-product-card-swatch]',
      productCardPrice: '[data-product-card-price]',

      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };

    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = document.getElementById('CollectionAjaxResult')?.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
        preserveParams: ['sort_by'],
      });

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function () {
        this.initSort();
        this.colorSwatchHovering();
        this.productCardSwatchSelection();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
          this.initParams();
        }
      },

      initParams: function () {
        this.queryParams = {};
        this.searchString = "";
        if (location.search.length) {
          this.searchString = location.search;
          var aKeyValue;
          var aCouples = location.search.substr(1).split('&');
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              this.queryParams[
                decodeURIComponent(aKeyValue[0])
              ] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute('data-default-sortby');
      },

      onSortChange: function () {
        this.queryParams.sort_by = this.getSortValue();
        if (this.queryParams.page) {
          delete this.queryParams.page;
        }
        if (this.searchString.length > 0) {
          var arr = this.searchString.substr(1).split('&');
          if (arr[arr.length - 1].includes("sort_by=")) {
            arr[arr.length - 1] = "sort_by=" + this.queryParams.sort_by;
          }
          else {
            arr[arr.length] = "sort_by=" + this.queryParams.sort_by;
          }
          this.searchString = arr.join("&");
          window.location.search = new URLSearchParams(this.searchString);
        }
        else {
          window.location.search = new URLSearchParams(Object.entries(this.queryParams));
        }

      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }

        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          if (swatch.closest('[data-product-card-swatch]')) return;

          swatch.addEventListener('mouseenter', function () {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector('.grid-product__color-image--' + id);
            if(el == null) return;
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function () {
            var id = swatch.dataset.variantId;
            var el = document.querySelector('.grid-product__color-image--' + id);
            if (el && !el.classList.contains('is-selected')) {
              el.classList.remove('is-active');
            }
          });
        });
      },

      productCardSwatchSelection: function () {
        var updateProductCardFromSwatch = function (swatch) {
          var card = swatch.closest('.grid-product');
          if (!card) return;

          card.querySelectorAll(selectors.productCardSwatch).forEach(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
            var itemSwatch = item.classList && item.classList.contains('color-swatch') ? item : item.querySelector('.color-swatch');
            if (itemSwatch) itemSwatch.classList.remove('is-active');
          });

          swatch.classList.add('is-active');
          swatch.setAttribute('aria-pressed', 'true');
          var selectedSwatch = swatch.classList.contains('color-swatch') ? swatch : swatch.querySelector('.color-swatch');
          if (selectedSwatch) selectedSwatch.classList.add('is-active');

          var variantId = swatch.dataset.variantId;
          var variantImage = swatch.dataset.variantImage;
          var imageMask = card.querySelector('.grid-product__image-mask');
          if (imageMask) {
            imageMask.querySelectorAll(selectors.colorSwatchImage).forEach(image => {
              image.classList.remove('is-active', 'is-selected');
            });
          }

          if (variantId && variantImage) {
            var variantImageEl = card.querySelector('.grid-product__color-image--' + variantId);
            if (variantImageEl) {
              variantImageEl.style.backgroundImage = 'url(' + variantImage + ')';
              variantImageEl.classList.add('is-active', 'is-selected');
            }
          }

          var priceEl = card.querySelector(selectors.productCardPrice);
          var price = parseInt(swatch.dataset.variantPrice, 10);
          var comparePrice = parseInt(swatch.dataset.variantComparePrice, 10) || 0;
          if (priceEl && price) {
            var priceHtml = '';
            if (comparePrice > price) {
              priceHtml += '<span class="visually-hidden">' + (theme.strings.regularPrice || 'Regular price') + '</span>';
              priceHtml += '<span class="grid-product__price--original">' + theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat) + '</span> ';
              priceHtml += '<span class="visually-hidden">' + (theme.strings.salePrice || 'Sale price') + '</span>';
            }
            priceHtml += '<span class="grid-product__price--after">' + theme.Currency.formatMoney(price, theme.settings.moneyFormat) + '</span>';
            priceEl.innerHTML = priceHtml;
          }

          var url = swatch.dataset.url;
          var productLink = card.querySelector('.grid-product__link');
          if (url && productLink) {
            productLink.setAttribute('href', url);
          }
        };

        this.container.querySelectorAll(selectors.productCardSwatch).forEach(swatch => {
          if (swatch.dataset.productCardSwatchBound === 'true') return;
          swatch.dataset.productCardSwatchBound = 'true';

          swatch.addEventListener('click', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();

            updateProductCardFromSwatch(swatch);
          });
        });

        this.container.querySelectorAll('.grid-product').forEach(card => {
          if (card.dataset.productCardSwatchInitialized === 'true') return;

          var initialSwatch = Array.from(card.querySelectorAll(selectors.productCardSwatch)).find(swatch => {
            return swatch.dataset.variantImage && swatch.dataset.variantImage.trim() !== '';
          });

          if (initialSwatch) {
            updateProductCardFromSwatch(initialSwatch);
            card.dataset.productCardSwatchInitialized = 'true';
          }
        });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (window.theme.settings.check_newPlp_filter == false) {
          if (theme.config.stickyHeader) {
            this.setFilterStickyPosition();

            window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
          }
        }

        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });

        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },

      initPriceRange: function () {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },

      tagClick: function (evt) {
        var el = evt.currentTarget;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        const newUrl = new URL(el.href);
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      onFormSubmit: function (evt) {
        var el = evt.target;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData, el);
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function (parent, el) {
        const textEl = parent.querySelector('.tag__text');

        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            function createSvgCloseIcon() {
              const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
              svg.setAttribute("aria-hidden", "true");
              svg.setAttribute("focusable", "false");
              svg.setAttribute("role",
                "presentation");
              svg.setAttribute("class", "icon icon-close");
              svg.setAttribute("viewBox", "0 0 10 10");

              const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
              path.setAttribute("d",
                "M0.553277 8.38634C0.373035 8.56658 0.424784 8.91056 0.668862 9.15464C0.91294 9.39871 1.25692 9.45046 1.43716 9.27022L4.9999 5.70748L8.5627 9.27027C8.74294 9.45051 9.08692 9.39877 9.331 9.15469C9.57507 8.91061 9.62682 8.56663 9.44658 8.38639L5.88379 4.82359L9.26973 1.43765C9.44997 1.25741 9.39822 0.913428 9.15414 0.66935C8.91007 0.425273 8.56609 0.373524 8.38584 0.553766L4.9999 3.93971L1.61401 0.553818C1.43377 0.373576 1.08979 0.425325 0.845714 0.669402C0.601637 0.91348 0.549888 1.25746 0.73013 1.4377L4.11602 4.82359L0.553277 8.38634Z");

              svg.appendChild(path);

              return svg;
            }
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
              svg.setAttribute("style", "margin-top: 5px;");
              svg.setAttribute("aria-hidden", "true");
              svg.setAttribute("focusable", "false");
              svg.setAttribute("role",
                "presentation");
              svg.setAttribute("class", "icon icon-close");
              svg.setAttribute("viewBox", "0 0 64 64");

              const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
              path.setAttribute("d",
                "M19 17.61l27.12 27.13m0-27.12L19 44.74");

              svg.appendChild(path);

              newTag.classList.add('tag', 'tag--remove');
              newTagLink.innerText = textEl.innerText + ' | ';
              newTag.appendChild(newTagLink);
              newTag.appendChild(svg); // Append the SVG icon to the anchor
              list.appendChild(newTag);
            });
          }
        }
      },

      renderFromFormData: function (formData, sourceElement) {
        const searchParams = new URLSearchParams(formData);
        addAutomaticAvailabilityFilter(searchParams, sourceElement || lastClickedElement);
        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function (newDom, section) {
        var isMobile = window.innerWidth < 769; // Adjust the width as needed
        // Open collapsible filters based on fetched IDs
        this.fetchOpenCollasibleFilters().forEach(selector => {
          newDom.querySelectorAll(`[data-collapsible-id="${selector}"]`).forEach(this.openCollapsible);
        });
        // Update current section content (only after filter application on small screens)
        const currentSection = document.getElementById(section.nodeId);
        const newSection = newDom.getElementById(section.nodeId);
        const activeElement = document.activeElement;
        let focusSelector = null;
        const sideFilterForm = document.querySelector('#side-filter-form');

        if (activeElement && sideFilterForm?.contains(activeElement)) {
          const handleIndex = activeElement.getAttribute('data-handle');
          if (handleIndex !== null) {
            // Slider handle focused
            focusSelector = `.price-range__slider [data-handle="${handleIndex}"]`;
          } else if (activeElement.classList.contains('price-range__input')) {
            // Price input focused
            const name = activeElement.getAttribute('name');
            focusSelector = `input[name="${name}"]`;
          }
        }

        if (currentSection && newSection) {
          // Saving Sidebar Scroll Position
          let savedScrollTop = 0;
          let activeSelector = '.grid__item--sidebar';
          const wrapper = document.querySelector('.grid__item--sidebar');
          const inner = document.querySelector('.collection-sidebar');
          // Determine which element is scrolling
          if (wrapper && wrapper.scrollTop > 0) {
            savedScrollTop = wrapper.scrollTop;
            activeSelector = '.grid__item--sidebar';
          } else if (inner && inner.scrollTop > 0) {
            savedScrollTop = inner.scrollTop;
            activeSelector = '.collection-sidebar';
          }

          currentSection.innerHTML = newSection.innerHTML;
          this.colorSwatchHovering();
          this.productCardSwatchSelection();

          // Update quick-filter button visual states after DOM replacement
          try { updateQuickFilterButtonStates(); } catch (e) {}

          // Also re-sync quick-filter active state after every AJAX render
          try { document.querySelectorAll('.js-quick-filter').forEach(btn => {
            const group = btn.dataset.quickFilterGroup;
            if (!group) return;
            const groupEl = document.querySelector(`.collection-sidebar__group--item[data-quick-filter-group="${group}"]`);
            let hasActive = false;
            if (groupEl) {
              if (groupEl.querySelector('.tag--active')) hasActive = true;
              if (!hasActive && groupEl.querySelector('input[type="checkbox"]:checked')) hasActive = true;
            }
            btn.classList.toggle('is-active', hasActive);
          }); } catch (e) {}

          // If a normal Filter open was requested, clear any quick-filter state restored by AJAX
          try {
            const clearFlag = sessionStorage.getItem('clearQuickFilterGroup');
            if (clearFlag) {
              try { sessionStorage.removeItem('clearQuickFilterGroup'); } catch (e) {}
              window.currentQuickFilterGroup = null;
              const sidebar = document.querySelector('.collection-sidebar');
              if (sidebar) {
                try { sidebar.removeAttribute('data-active-filter-group'); } catch (e) {}
                // Reveal hidden groups/tags
                sidebar.querySelectorAll('.collection-sidebar__group--item, .collection-sidebar__group--item .tag, .tag.hide').forEach(el => {
                  try { el.classList.remove('hide'); } catch (e) {}
                  try { el.style.display = ''; } catch (e) {}
                });
              }
            }
          } catch (e) {}

          if (window.currentQuickFilterGroup) {
            const sidebar = document.querySelector('.collection-sidebar');
            if (sidebar) {
              sidebar.setAttribute('data-active-filter-group', window.currentQuickFilterGroup);
              const groupItem = sidebar.querySelector(`.collection-sidebar__group--item[data-quick-filter-group="${window.currentQuickFilterGroup}"]`);
              if (groupItem) {
                const content = groupItem.querySelector('.collapsible-content');
                const trigger = groupItem.querySelector('[aria-expanded]');
                if (content) {
                  content.classList.add('is-open');
                  content.style.height = 'auto';
                }
                if (trigger) {
                  trigger.classList.add('is-open');
                  trigger.setAttribute('aria-expanded', 'true');
                }
              }
            }
          }

          // Restoring Sidebar Scroll Position
          if (savedScrollTop > 0) {
            // Using setTimeout to ensure the DOM update is painted
            setTimeout(() => {
              const newScrollElement = document.querySelector(activeSelector);
              if (newScrollElement) {
                newScrollElement.scrollTop = savedScrollTop;
              }
            }, 0);
          }

          if (focusSelector) {
            setTimeout(() => {
              const newSideFilterForm = document.querySelector('#side-filter-form');
              const newFocusElement = newSideFilterForm?.querySelector(focusSelector);
              if (newFocusElement) {
                newFocusElement.focus();
                if (newFocusElement.setSelectionRange && newFocusElement.value) {
                  const len = newFocusElement.value.length;
                  newFocusElement.setSelectionRange(len, len);
                }
              }
            }, 100);
          }
          if (window.byobGlobalHandler) {
            RemoveUnMatchedProductFromDom(currentSection);
          }
          // filter button binding code here
          const filterButton = document.querySelector('.js-sidebar-open-collection-filters');
          const drawer = document.querySelector('.collection-sidebar');
          let overlay;

          if (filterButton && drawer) {
            filterButton.addEventListener('click', (event) => {
              event.stopPropagation();
              // If we injected the skip CSS to hide the sidebar after CTA navigation,
              // remove it so manual opening works normally.
              try {
                const injected = document.getElementById('skip-filter-hide');
                if (injected && injected.parentNode) injected.parentNode.removeChild(injected);
              } catch (e) {}
              try { sessionStorage.removeItem('skipOpenFilterSidebar'); } catch (e) {}
              drawer.classList.toggle('open');

              if (drawer.classList.contains('open')) {
                // Create/reapply overlay and prevent body scrolling
                overlay = overlay || document.createElement('div');
                overlay.classList.add('overlay');
                document.body.appendChild(overlay);
                document.body.classList.add('no-scroll', 'is--filter-open');
              } else {
                // Remove overlay and allow body scrolling
                overlay?.remove();
                document.body.classList.remove('no-scroll', 'is--filter-open');
              }

              // Open all collapsible menus in the filter form initially
              document.querySelectorAll('#side-filter-form div[data-collapsible-id]').forEach(div => {
                div.classList.add('is-open');
                div.style.height = 'auto';
              });
            });
            //  filter initialization end here
          }

          // Only auto-open the sidebar if this navigation was not initiated
          // by an absorbency CTA. The CTA sets a short-lived session flag
          // `skipOpenFilterSidebar` so we can suppress opening on redirect.
          const sidebarEl = document.querySelector('.collection-sidebar');
          const openedByAbsorbencyCTA = lastClickedElement && lastClickedElement.closest && lastClickedElement.closest('.btnboxtab');
          const skipFlag = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('skipOpenFilterSidebar');

          if (sidebarEl && !openedByAbsorbencyCTA && !skipFlag) {
            sidebarEl.classList.add('open');

            if (isMobile) {
              document.querySelectorAll('#side-filter-form div[data-collapsible-id]').forEach(div => {
                div.classList.add('is-open');
                div.style.height = 'auto';
              });
            }
          }


          const closeFilterButton = document.querySelector('button.collection-sidebar-header-icon');
          if (closeFilterButton) {
            closeFilterButton.addEventListener('click', (event) => {
              event.preventDefault(); // Prevent default behavior (if applicable)
              event.stopPropagation(); // Prevent event propagation
              document.querySelector('.collection-sidebar').classList.remove('open');
              document.body.classList.remove('no-scroll', 'is--filter-open');
              const overlay = document.querySelector('.overlay');

              if (overlay) {
                overlay.remove();
              }

              // Initialize the collection filter stickiness.
              initCollectionFilterStickiness();
            });
          }


          const applyFilterBtn = document.querySelector('button#apply-filter-btn');
          if (applyFilterBtn) {
            applyFilterBtn.addEventListener('click', (event) => {
              event.preventDefault(); // Prevent default behavior (if applicable)
              event.stopPropagation(); // Prevent event propagation
              document.querySelector('.collection-sidebar').classList.remove('open');
              const overlay = document.querySelector('.overlay');
              if (overlay) {
                overlay.remove();
              }
              document.body.classList.remove('no-scroll', 'is--filter-open');
              // Initialize the collection filter stickiness.
              initCollectionFilterStickiness();
            });
          }
          if (window.byobGlobalHandler) {
            window.attachEventListeners(currentSection);
            window.attachEventListeners2(currentSection);
            const productItems = document.querySelectorAll('[data-byob-product-id]');
            productItems.forEach(item => {
              const productId = item.dataset.byobProductId;
              const swiperContainer = item.querySelector(`.product-grid-swiper-${productId}`);
              if (!swiperContainer) return;
              const swiper = new Swiper(swiperContainer, {
                pagination: { el: swiperContainer.querySelector('.swiper-pagination'), clickable: true },
                navigation: {
                  nextEl: swiperContainer.querySelector('.swiper-button-next'),
                  prevEl: swiperContainer.querySelector('.swiper-button-prev'),
                },
                slidesPerView: 1,
              });

              const slides = swiperContainer.querySelectorAll('.swiper-slide');
              const variantPopup = item.querySelector(`#variant-popup-${productId}`);
              if (!variantPopup) return;
              variantPopup.querySelectorAll('.color-swatch').forEach((swatch) => {
                swatch.addEventListener('click', function () {
                  const swatchNameRaw = this.nextElementSibling?.textContent?.trim()?.toLowerCase();
                  const swatchName = swatchNameRaw?.replace(/\s+/g, '-'); // Convert spaces to hyphens

                  if (swatchName) {
                    for (let i = 0; i < slides.length; i++) {
                      const imgTag = slides[i].querySelector('img.grid-product__image');
                      const imgSrc = imgTag?.getAttribute('src')?.toLowerCase();

                      if (imgSrc && imgSrc.includes(swatchName)) {
                        swiper.slideTo(i);
                        break; // First match only
                      }
                    }
                  }
                });
              });
              //Get selected swatch tag from filter (active tag)
              const activeSwatchTags = document.querySelectorAll('.tag.tag--active .color-swatch--filter');

              const activeSwatchTag = document.querySelector('.tag.tag--active .color-swatch--filter');
              if (activeSwatchTags.length === 2) {
                const rawTitle = activeSwatchTag?.getAttribute('title')?.trim()?.toLowerCase();
                const normalizedTitle = rawTitle?.replace(/\s+/g, '-'); // e.g. "Vintage Pink" → "vintage-pink"

                if (normalizedTitle) {
                  for (let i = 0; i < slides.length; i++) {
                    const imgTag = slides[i].querySelector('img.grid-product__image');
                    const imgSrc = imgTag?.getAttribute('src')?.toLowerCase();

                    if (imgSrc && imgSrc.includes(normalizedTitle)) {
                      swiper.slideTo(i);
                      break; // First matched image
                    }
                  }
                }

                // Select matching swatch inside popup
                variantPopup.querySelectorAll('.color-swatch').forEach((swatch) => {
                  const swatchNameRaw = swatch.nextElementSibling?.textContent?.trim()?.toLowerCase();
                  const swatchName = swatchNameRaw?.replace(/\s+/g, '-');

                  if (swatchName === normalizedTitle) {
                    // If swatches are buttons
                    swatch.click();

                    // If they are radio inputs inside labels
                    const inputEl = swatch.closest('label')?.querySelector('input[type="radio"]');
                    if (inputEl) {
                      inputEl.checked = true;
                      inputEl.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                  }
                });
              }
              // Filter <select> Change Behavior
              const colorSelect = document.querySelector('select[name="filter.v.option.colour"]');
              if (colorSelect) {
                colorSelect.addEventListener('change', function () {
                  const selectedColorRaw = this.value?.trim()?.toLowerCase();
                  const normalizedColor = selectedColorRaw?.replace(/\s+/g, '-');

                  if (normalizedColor) {
                    for (let i = 0; i < slides.length; i++) {
                      const imgTag = slides[i].querySelector('img.grid-product__image');
                      const imgSrc = imgTag?.getAttribute('src')?.toLowerCase();
                      if (imgSrc && imgSrc.includes(normalizedColor)) {
                        swiper.slideTo(i);
                        break;
                      }
                    }
                  }
                });
              }
            });
          }
        }
        // Manage filter drawer and overlay

        // Handle last collapsible menu (if any)

        const lastCollapsibleMenuId = this.fetchOpenCollasibleFilters().pop();
        const lastMenuElement = document.querySelector(`#side-filter-form button[data-collapsible-id="${lastCollapsibleMenuId}"]`);

        if (lastMenuElement && !isMobile) {
          handleCollapsibleElements(lastMenuElement);
          const divsToHide = lastMenuElement.querySelector(`div[data-count-id="${lastCollapsibleMenuId}"]`);
          divsToHide.style.display = 'none';
        }

        const tags = document.querySelectorAll('.tag-list .tag--swatch .btn .tag__text');
        tags.forEach(tag => {
          const textLength = tag.textContent.trim().length;
          if (textLength > 9) {
            tag.parentElement.parentElement.parentElement.parentElement.classList.add('tag--long');
          }
        });

      },
      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }
        el.classList.add(classes.isOpen);
      },
      renderCollectionPage: function (searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-template');
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();

            isAnimating = false;

            // We need setTimeout for a smoother effect
            if (document.querySelector('.collection-sidebar.open') && window.innerWidth <= 768) {
              document.body.classList.add('no-scroll', 'is--filter-open');
            }

            if (window.byobGlobalHandler) {
              setTimeout(() => {
                const byobListWrapper = document.querySelector('.byob__widget-list');
                if (byobListWrapper) {
                  byobListWrapper.innerHTML = '';
                }
                window.byobGlobalHandler(true);
              }, 250);
            }

            checkFiltersHandler();
            productCardsOrderHandler();
            // DWFT-4066 FEMCARE PLP | Color filter issue on specific collections (v2 code)
            colorFiltersVisibilityHandler(true);
            productsCountHandler();
            // DWFT-5649 Femcare > all PLPs sorting | Hide 'availability' filter
            hideAvailabilityFilterHandler();
            // Sync CTAs with current filters/URL after AJAX render
            try { syncAbsorbencyCTAsFromForm(); } catch (e) {}
          });
      },

      bindBackButton: function () {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function (state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },

      updateScroll: function (animate) {
        var scrollTo;
        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters
          scrollTo = document.querySelector('[data-scroll-to]')?.offsetTop - 60;
        } else {
          scrollTo = document.getElementById('CollectionAjaxResult')?.offsetTop + 1;
        }

        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: scrollTo });
        }
      },
      setFilterStickyPosition: function () {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';

        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },

      forceReload: function () {
        this.init();
      },

      startLoading: function () {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });

    return Collection;
  })();

  function normalizeColourValue(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[–—]/g, '-')
      .replace(/[()]/g, '')
      .replace(/\s*\/\s*/g, '/')
      .replace(/[^a-z0-9/\s-]/g, '')
      .trim();
  }

  function getColourFiltersFromURL() {
    const results = [];
    const collectValue = (rawValue) => {
      const values = String(rawValue || '')
        .split(/[,;|]/)
        .map(v => normalizeColourValue(v))
        .filter(Boolean);

      values.forEach((value) => {
        if (!results.includes(value)) results.push(value);
      });
    };

    try {
      const urlParams = new URLSearchParams(window.location.search);
      for (const [key, value] of urlParams.entries()) {
        if (!String(key).startsWith('filter.v.option.')) continue;
        const isColorLike = /colour|color|couleur|farbe|farge|väri|färg/i.test(key);
        if (isColorLike) collectValue(decodeURIComponent(value.replace(/\+/g, ' ')));
      }
    } catch (e) {}

    try {
      const form = document.querySelector('#side-filter-form, #FilterDrawer .filter-form');
      if (form) {
        form.querySelectorAll('input:checked, select').forEach((el) => {
          const name = String(el.name || '');
          if (!name.startsWith('filter.v.option.')) return;
          const isColorLike = /colour|color|couleur|farbe|farge|väri|färg/i.test(name);
          if (!isColorLike) return;
          const labelText = el.closest('label') ? String(el.closest('label').textContent || '') : '';
          if (el.value) collectValue(el.value);
          if (labelText) collectValue(labelText);
        });
      }
    } catch (e) {}

    return results;
  }

  function RemoveUnMatchedProductFromDom(currentSection) {
    if (window.byobEnforceClientSideColorMatch !== true) return;

    const selectedColours = getColourFiltersFromURL();
    if (!selectedColours || !selectedColours.length) return;

    const lists = currentSection.querySelectorAll('ul.grid li.grid__item');
    if (!lists.length) return;

    const cardsWithColorData = Array.from(lists).filter((li) => {
      if (li.classList.contains('marketing-grid')) return false;
      return li.querySelector('span.color-name, [data-color-name], [data-color-title]');
    });

    if (!cardsWithColorData.length) return;

    cardsWithColorData.forEach((li) => {
      const colorCandidates = Array.from(li.querySelectorAll('span.color-name, [data-color-name], [data-color-title]'))
        .map((el) => normalizeColourValue(el.textContent || el.getAttribute('data-color-name') || el.getAttribute('data-color-title') || ''))
        .filter(Boolean);

      if (!colorCandidates.length) return;

      const hasMatchingColor = colorCandidates.some((color) => {
        const normalizedColor = normalizeColourValue(color);
        return selectedColours.some((selected) => {
          if (normalizedColor === selected) return true;
          return normalizedColor.includes(selected) || selected.includes(normalizedColor);
        });
      });

      if (!hasMatchingColor) {
        li.remove();
      }
    });
  }


  theme.FooterSection = (function () {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function () {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function () {

    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },

      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },

      onUnload: function () {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };

    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]',
      tabs: '[data-product-blocks].section-product-blocks'
    };

    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');

      this.inModal = (container.dataset.modal === 'true');
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }

      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',

        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',

        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        pricePerItem: '[data-pricePerItem]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        compareText: '[data-compare-price-text]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',

        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',

        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',

        availabilityContainer: '[data-store-availability-holder]'
      };

      this.cacheElements();

      this.firstProductImage = this.cache.mainSlider.querySelector('img');

      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }

      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }

      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {

        if (this.inModal) {
          if (theme.settings.quickViewStyle === "drawer") {
            this.container.classList.add(classes.isModal);
            document.addEventListener('drawerOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
            document.addEventListener('drawerClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
          } else {
            this.container.classList.add(classes.isModal);
            document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
            document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
          }
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },

      forceReload: function () {
        this.init();
      },

      onSelect: function () {
        if (theme.QuickviewDrawer) {
          if (!drawerStyle) {
            theme.QuickviewDrawer.close();
            return;
          }

          if (drawerStyle || theme.config.bpSmall) {
            theme.QuickviewDrawer.open();
          }
        }
      },

      onDeselect: function () {
        if (theme.QuickviewDrawer) {
          theme.QuickviewDrawer.close();
        }
      },

      onUnload: function () {
        if (theme.QuickviewDrawer) {
          theme.QuickviewDrawer.close();
        }
      },


      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),

          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          pricePerItem: this.container.querySelector(this.selectors.pricePerItem),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          compareText: this.container.querySelector(this.selectors.compareText),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;

        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
        var displayTitleEl = document.querySelector('.product-single__title');
        var displayTitle = displayTitleEl ? displayTitleEl.textContent.trim() : '';

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
          displayTitle: displayTitle
        };

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },

      initVariants: function () {


        var variantJson = this.container.querySelector(this.selectors.variantsJson);

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };

        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function (evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }

        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantChange' + this.settings.namespace, this.updateColorSwatches.bind(this));
        this.updateColorSwatches();
        this.container.on('variantChange' + this.settings.namespace, this.updateAmountSaveText.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }

        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);

          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
      initAjaxProductForm: function () {
        const bodyElement = document.body;
        const productFormDiv = document.querySelector('.product-form-default');
        let noMiniCart = false;
        const self = this;
        // Create a MutationObserver
        const observerForm = new MutationObserver(function (mutationsList) {
          // Check if the class attribute has changed
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              if (bodyElement.classList.contains('no-mini-cart-drawer')) {
                noMiniCart = true;
                productFormDiv.classList.remove('product-form-default');
                productFormDiv.classList.add('product_form_for_ABTesting', 'show-AB-testy-form');
                new theme.AjaxProduct(self.cache.form); // this.cache.form is not available here
              }
            }
          }
        });

        // Configuration for the observer (watching for attribute changes)
        const observerFormConfig = { attributes: true, attributeFilter: ['class'] };

        // Start observing the target element (body tag)
        observerForm.observe(bodyElement, observerFormConfig);

        if (theme.settings.cartType === 'drawer' && !noMiniCart || theme.settings.cartType === 'cart-notification') {
          new theme.AjaxProduct(this.cache.form);
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        const el = this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"]`);
        if (el) el.textContent = color;

      },

      updateAmountSaveText: function (evt) {
        var variant = evt.detail.variant;

        if (variant.compare_at_price > variant.price) {
          let saveAmount = variant.compare_at_price - variant.price;

          let formattedSave = theme.Currency.formatMoney(Math.round(saveAmount), theme.settings.moneyFormat);

          formattedSave = formattedSave.replace(/\.00/, '');

          if(this.cache.compareText) {
            this.cache.compareText.innerHTML = `${this.cache.compareText.dataset.text} ${formattedSave}`;
          }
        } else {
          if(this.cache.compareText) {
            this.cache.compareText.innerHTML = '';
          }
        }
        // DWFT-5692 PDP | Color Persistence Issue When Navigating Between Fluid Types
        absorbencyProductCtaHandler(variant.title);
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);

        if (variant) {
          if (typeof modelData !== 'undefined') {
            const modelBlock = document.querySelector('.model-info-metaobject');

            let modelLookup = modelData.filter((model) => {
              return model[variant.option1] && model[variant.option1] === variant.option2;
            });

            if (modelBlock) {
              if (modelLookup.length > 0 && modelLookup[0].height !== '') {
                modelBlock.classList.remove('visually-hidden');
                let modelCopy = `${modelLookup[0].height}${modelLookup[0].hip_size}${modelLookup[0].size}`;
                const metaDesc = document.querySelector('.meta-desc');
                if (metaDesc) metaDesc.innerText = modelCopy;
              } else {
                modelBlock.classList.add('visually-hidden');
              }
            }
          }
          if (variant.available) {
            // Available, enable the submit button and change text
            if (cartBtn) {
              cartBtn.classList.remove(classes.disabled);
              cartBtn.disabled = false;
            }
            if (cartBtnText) {
              var defaultText = cartBtnText.dataset.defaultText;
              cartBtnText.textContent = defaultText;
            }
          } else {
            // Sold out, disable the submit button and change text
            if (cartBtn) {
              cartBtn.classList.add(classes.disabled);
              cartBtn.disabled = true;
            }
            if (cartBtnText) cartBtnText.textContent = theme.strings.soldOut;
          }
          //call and find relative varients of main product
          if (typeof checkRelativeVariant == 'function') {
            checkRelativeVariant(variant);
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;
        if (variant) {
          //Value Benefit message for Multipack Product on change variant
          var pckQty = document.getElementById('packQty')?.value;
          if (pckQty) {
            var perItemPrice = variant.price / pckQty;
            this.cache.pricePerItem.innerHTML = theme.Currency.formatMoney(perItemPrice, theme.settings.moneyFormat);
            document.getElementById("defaultVariantPrice").style.display = 'none';
            document.getElementById("changedVariantPrice").style.display = 'block';
          }
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
          if (theme.settings.productDiscountStatus == 'true') {
            // For custom discount price and message change
            this.cache.price.innerHTML = theme.Currency.formatMoney(Math.round(variant.price - ((variant.price / 100) * theme.settings.productDiscountPercent)), theme.settings.moneyFormat);
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');
          } else {

            // Sale price, if necessary
            if (variant.compare_at_price > variant.price) {
              this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
              this.cache.priceWrapper.classList.remove(classes.hidden);
              this.cache.price.classList.add(classes.onSale);
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
              this.cache.priceA11y.setAttribute('aria-hidden', 'false');

              var savings = variant.compare_at_price - variant.price;

              if (theme.settings.saveType == 'percent') {
                savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
              } else {
                savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
              }

              this.cache.savePrice.classList.remove(classes.hidden);
              this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
            } else {
              if (this.cache.priceWrapper) {
                this.cache.priceWrapper.classList.add(classes.hidden);
              }
              this.cache.savePrice?.classList.add(classes.hidden);
              this.cache.price.classList.remove(classes.onSale);
              if (this.cache.comparePriceA11y) {
                this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
              }
              this.cache.priceA11y.setAttribute('aria-hidden', 'true');
            }
          }

        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
        });
      },

      getImageSetName: function (string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = '';

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === 'continue') {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          const elElement = document.querySelector(this.selectors.inventory);
          if (elElement) {
            if (quantity < 0) {
              elElement.setAttribute('data-qtyleft', 1);
            } else {
              elElement.setAttribute('data-qtyleft', quantity);
            }
          }

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          // added for zero inventory work BOLOSS
          if (quantity == 0) {
            showInventory = true;
          }
          // END for zero inventory work BOLOSS
          this.toggleInventoryQuantity(variant, showInventory, quantity);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (!showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);


          if (window.checkThresholdGlobal) {
            window.checkThresholdGlobal();
          }

          const qtyInput = document.querySelector('.product__quantity .js-qty__wrapper .js-qty__num');
          if (qtyInput && parseInt(qtyInput.value) >= quantity && quantity != 0) {
            if (quantity < 0) {
              qtyInput.value = 1;
            } else {
              qtyInput.value = quantity;
            }
          } else if (qtyInput && parseInt(qtyInput.value) >= quantity && quantity == 0) {
            qtyInput.value = 1;
          }
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      updateColorSwatches: function () {
        // We need this to overwrite logic
        setTimeout(() => {
          const productVariantSelector = document.querySelectorAll('.product-variants-select option');
          const colors = document.querySelectorAll('#content-accordion-color li.variant-item');

          colors.forEach(colorItem => {
            const colorValue = colorItem.dataset.value.trim();
            let colorAvailable = false;

            colorAvailable = Array.from(productVariantSelector).some(variantOptionItem => {
              const color = variantOptionItem.getAttribute('data-variant-title').split(' / ');
              return color[0].trim() === colorValue && variantOptionItem.dataset.available === 'true';
            });

            const label = colorItem.querySelector('label');
            const input = colorItem.querySelector('input');

            if (colorAvailable) {
              label.classList.remove('disabled');
              input.classList.remove('disabled');
            } else {
              label.classList.add('disabled');
              input.classList.add('disabled');
            }
          });
        }, 0);
      },

      toggleInventoryQuantity: function (variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');


        el.textContent = theme.strings.inStockLabel;


        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          if (parseInt(qty) < 1) {
            el.parentNode.classList.remove('inventory--low');
            el.parentNode.classList.add('inventory--zero');
            el.textContent = theme.strings.zeroStockLabel;
          }
          else {
            el.parentNode.classList.add('inventory--low');
            el.parentNode.classList.remove('inventory--zero');
            if (parseInt(qty) == 1) {
              el.textContent = theme.strings.stockLabelOne.replace('[count]', qty);
            }
            else {
              el.textContent = theme.strings.stockLabelOther.replace('[count]', qty);
            }
          }

        } else {
          if (parseInt(qty) == 0) {
            el.parentNode.classList.remove('inventory--low');
            el.parentNode.classList.add('inventory--zero');
            el.textContent = theme.strings.zeroStockLabel;
          } else {
            el.parentNode.classList.remove('inventory--low');
            el.parentNode.classList.remove('inventory--zero');
            el.textContent = theme.strings.inStockLabel;
          }


        }



        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (parseInt(qty) == 0) {
            salesPoint.classList.remove(classes.hidden);
          }
        }

      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest('.product-block');

        if (!el) {
          return;
        }

        var textEl = el.querySelector('.js-incoming-text');

        if (show) {
          var string = available ?
            theme.strings.willNotShipUntil.replace('[date]', date) :
            theme.strings.willBeInStockAfter.replace('[date]', date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);

        if (!productVideos.length) {
          return false;
        }

        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.youtubeId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== 'sound') {
          player.mute();
        }

        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },

      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute('data-video-type');
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise.then(function () {
            // Playing as expected
          })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute('controls', '');
              player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function (evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },

      getThumbIndex: function (target) {
        return target.dataset.index;
      },

      updateVariantImage: function (evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        if (this.flickity) {
          var imageIndex = this.getThumbIndex(newImage);
          // If there is no index, slider is not initalized
          if (typeof imageIndex === 'undefined') {
            return;
          }
        };

        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        } else if (typeof swiperGallery !== 'undefined' && swiperGallery.initialized) {
          let currentColour = `--${(
            variant.option1.replace('ä', 'a').replace('ø', 'o').replace('ö', 'o').replace('é', 'e').replace(/[^a-zA-Z0-9 ]/g, "-").replaceAll(" ", "-")).toLowerCase()}` || '';

          let filteredMedia = productMediaObject.filter(image => {
            const videoCurrentColour = currentColour.replaceAll('-', '').replace('--', '');

            const isImageMatch = image.url.includes(currentColour) || image.alt.includes(currentColour);
            
            const isVideo = image.url.includes('.mp4');
            let isVideoMatch = false;

            if (isVideo) {
              const normalizedMediaText = (image.alt + image.url).toLowerCase().replaceAll(/[^a-z0-9]/g, '');
              const isPresent = normalizedMediaText.includes(videoCurrentColour);

              if (isPresent) {
                const multiColorPrefixes = customPrefixesString
                    .split(',')
                    .map(prefix => prefix.trim().toLowerCase())
                    .filter(prefix => prefix.length > 0);
                
                let isConflicting = false;
                
                if (videoCurrentColour.length < 7) { 
                   
                   const relevantPrefixes = multiColorPrefixes.filter(prefix => prefix !== videoCurrentColour);

                   for (const prefix of relevantPrefixes) {
                       // Check if the media contains a multi-color name: [different prefix] + [current color]
                       if (normalizedMediaText.includes(prefix + videoCurrentColour)) {
                           isConflicting = true;
                           break;
                       }
                   }
                }
                
                isVideoMatch = !isConflicting;
              }
            }

            return isImageMatch || isVideoMatch;
          });

          var ribbonText = "";
          var currentPromotionText = variantArray.filter(x => x.variantId == variant.id)[0].text.substring(0, 16);
          if (currentPromotionText) {
            ribbonText = currentPromotionText;
          }
          else {
            ribbonText = productLevelText;
          }

          const selectedVariantData = document.querySelector(`.product-variants-select option[value="${variant.id}"]`);
          if(selectedVariantData) {
            const price = selectedVariantData.getAttribute('data-variant-price');
            const comparePrice = selectedVariantData.getAttribute('data-variant-compare-price');
            if(comparePrice > price && window.enable_automatic_discount == 'true') {
            const discountRaw = ((comparePrice - price) / comparePrice) * 100;
            const discount_value = Math.floor((discountRaw + 2.5) / 5) * 5;
            ribbonText = `${discount_Percentage_label_prefix}${discount_value}% ${window.discount_badge_text ? window.discount_badge_text : ''}`;
          }
          }

          const modelBlock = document.querySelector('.model-info-metaobject');
          if (!evt.target.classList.contains('product-pilot-bundle-pdp')) {
            if (typeof swiperGallery !== 'undefined' && typeof swiperGallery.removeAllSlides === 'function') {
              swiperGallery.removeAllSlides();
            }
            if (typeof swiperFeatured !== 'undefined' && typeof swiperFeatured.removeAllSlides === 'function') {
              swiperFeatured.removeAllSlides();
            }
          }

          let modelLookup = modelData.filter((model) => {
            return model[variant.option1] && model[variant.option1] === variant.option2;
          });

          if (modelBlock) {
            if (modelLookup.length > 0 && modelLookup[0].height !== '') {
              modelBlock.classList.remove('visually-hidden');

              let modelCopy = `${modelLookup[0].height}${modelLookup[0].hip_size}${modelLookup[0].size}`;

              const metaDesc = document.querySelector('.meta-desc');
              if (metaDesc) metaDesc.innerText = modelCopy;
            } else {
              modelBlock.classList.add('visually-hidden');
            }
          }

          for (let i = 0; i < filteredMedia.length; i++) {
            if (typeof swiperGallery !== 'undefined' && typeof swiperGallery.addSlide === 'function') {
              swiperGallery.addSlide(i,
              `<div class="swiper-slide">
                  ${filteredMedia[i].url.includes(".mp4") ?
                `<span class="product__thumb-icon">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        role="presentation"
                        class="icon icon-play"
                        viewBox="18.24 17.35 24.52 28.3"
                      >
                        <path fill="#323232" d="M22.1 19.151v25.5l20.4-13.489-20.4-12.011z"/>
                      </svg>
                    </span>`
                : ''}
                  <img src="${filteredMedia[i].url.includes(".mp4") ? filteredMedia[i].thumbnail : filteredMedia[i].url}" alt="Brazilian Moderate" srcset="${filteredMedia[i].url.includes(".mp4") ? filteredMedia[i].thumbnail : filteredMedia[i].url}" width="76" height="76" loading="eager" style="opacity: 100; height: 100%;" class="animation-delay-${(i * 3)}">
              </div>`
            );
            swiperFeatured.addSlide(i,
              `
              <div class="swiper-slide swiper-slide-active" data-product-photos="">
                <div class="product-main-slide" data-index="${i}">
                  <div data-product-image-main="" class="product-image-main">
                   ${ribbonText && ribbonText.trim() !== '' ? `
                    <div class="ribbon-container">
                      <div class="ribbon-alt ribbon-alt_pdp">
                        <span>
                          ${ribbonText}
                        </span>
                      </div>
                    </div>` : ''}
                    ${filteredMedia[i].url.includes(".mp4") ?
                `<div data-video-type="mp4" class="product__video-wrapper" data-video-style="muted" style="padding-bottom: 100.0%;">
                       <video playsinline="" loop="" muted="" controlslist="nodownload" poster="${filteredMedia[i].thumbnail}" data-video-type="mp4" data-video-style="muted" class="product__video"><source src="${filteredMedia[i].url}" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>
                        </div>`
                : `<div class="image-wrap">
                  <img src="${filteredMedia[i].url}?width=1080" alt="Brazilian Moderate" srcset="${filteredMedia[i].url}?width=360 360w, ${filteredMedia[i].url}?width=560 560w, ${filteredMedia[i].url}?width=900 900w, ${filteredMedia[i].url}?width=1080 1080w" width="1080" height="1080" loading="lazy" sizes="(min-width: 1440px) 1080px, (min-width: 769px) 548px, (max-width: 768px) calc(100vw - 80px)" style="opacity: 100;" class=" photoswipe__image" data-photoswipe-src="${filteredMedia[i].url}" data-photoswipe-width="1080" data-photoswipe-height="1080">
                  <img src="${filteredMedia[i].url}?width=767" alt="Brazilian Moderate" srcset="${filteredMedia[i].url}?width=360 360w, ${filteredMedia[i].url}?width=560 560w, ${filteredMedia[i].url}?width=767 767w" width="767" height="767" loading="lazy" sizes="(max-width: 767px) calc(100vw - 80px)" style="opacity: 100;" class=" photoswipe__image show-mobile" data-photoswipe-src="${filteredMedia[i].url}" data-photoswipe-width="767" data-photoswipe-height="767">
                </div>`}
                  </div>
                </div>
              </div>`
              );
            }
          };
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }

        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }

        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        if (!this.flickity) return;

        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]');

        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
          this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
          this.cache.mainSlider.querySelector('.product-main-slide[data-index="' + index + '"]');

        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);

        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);

        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);

        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },

      _slideIndex: function (el) {
        return el.getAttribute('data-index');
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/


      openModalProduct: function () {
        var initialized = false;
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;
          fetch(url).then(function (response) {
            return response.text();
          }).then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);

            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              if (val.indexOf('pwr-snippets') != -1) {
                el.setAttribute('id', val + '-' + this.productId);
              } else {
                el.setAttribute('id', val + '-modal');
              }

              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }

              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });

            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            var formId = form.getAttribute('id');
            blocks.querySelectorAll('[form]').forEach(el => {
              el.setAttribute('form', formId);
            });

            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);

            // Add description block if available
            var tabs = doc.querySelector(selectors.tabs);
            if (tabs != undefined) {
              tabs.querySelectorAll('#pr-reviewdisplay').forEach(el => {
                // Update input `id`
                var val = el.getAttribute('id');
                el.setAttribute('id', val + '-' + this.productId);

              });
              this.blocksHolder.append(tabs);
            }

            this.blocksHolder.classList.add('product-form-holder--loaded');

            this.cacheElements();

            this.formSetup();
            this.updateModalProductInventory();

            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                sectionId: this.sectionId,
                productId: this.productId
              }
            }));
          }.bind(this));

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required

          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function (evt) {

                if (evt.detail.sectionId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;

        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};

          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          'shopify_xr_launch',
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
              ':not(.' +
              self.classes.hidden +
              ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function () {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });

        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function (evt) {
              this.mediaLoaded(evt);
            }.bind(this));

            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function (evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });

    return Product;
  })();

  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.gridItemWidthForMob = this.container.getAttribute('data-grid-item-mob-class');
      this.rowOf = this.container.getAttribute('data-row-of');

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }

        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));

        Promise.all(promises).then(function (result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch('/products/' + handle + '.js').then(function (response) {
              return response.text();
            }).then(function (product) {
              resolve(product);
            });
          }
        });

          // If filtering by color yields no media (can happen when model data is present
          // or media naming doesn't match color tokens), fall back to showing all media
          // so the PDP never becomes blank.
          if (!filteredMedia || filteredMedia.length === 0) {
            filteredMedia = productMediaObject.slice();
          }
      },

      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');

        var i = 0;

        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);

          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }

          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }

          i++;

          // New or formatted properties
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
          if (theme.recentlyViewed.recent[product.handle] && theme.recentlyViewed.recent[product.handle].displayTitle) {
            product.display_title = theme.recentlyViewed.recent[product.handle].displayTitle;
          }

          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';

            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }

            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }

          allProducts.unshift(product);
        }.bind(this));

        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.gridItemWidthForMob, this.rowOf);

        this.outputContainer.innerHTML = productMarkup;

        const recentlyViewedElement = document.querySelector('.recently-viewed-swiper.swiper');
        const recentlyViewedSlides = recentlyViewedElement.querySelectorAll('.swiper-slide');

        if (recentlyViewedSlides.length < 4) {
          recentlyViewedElement.classList.add('center-slides');
        }

        new Swiper(recentlyViewedElement, {
          speed: 500,
          navigation: {
            nextEl: `.${recentlyViewedElement.querySelector('.swiper-button-next').dataset.className}`,
            prevEl: `.${recentlyViewedElement.querySelector('.swiper-button-prev').dataset.className}`,
          },
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            769: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            1: {
              slidesPerView: 2,
              spaceBetween: 19
            }
          }
        })

        const recentlyViewedProducts = document.querySelectorAll('.swiper-slide-recently-viewed');

        recentlyViewedProducts.forEach(item => {
          fetchBottomRibbonHTML(`/products/${item.dataset.handle}`).then(bottomRibbonHTML => {
            const imageMask = item.querySelector('.grid-product__image-mask');
            if (imageMask && bottomRibbonHTML) {
              imageMask.insertAdjacentHTML('beforeend', bottomRibbonHTML);
            }
          });
        });

        if (AOS) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function (products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },

      onUnload: function () {
        init = false;
      }
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function () {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: false
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
      if (!this.slideshow) { return }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function () {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function () {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {

        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });

    return Testimonials;
  })();


  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (AOS) { AOS.refreshHard() }

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) { SPR.initDomEls(); SPR.loadBadges() }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-template', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

  window.addEventListener('scroll', function () {
    var height = window.scrollY || document.documentElement.scrollTop;
    var backToTopButton = document.getElementById('back-to-top');

    if (height > 150) {
      backToTopButton.style.display = 'flex';
      backToTopButton.style.opacity = '1';
      backToTopButton.style.transition = 'opacity 0.3s ease';
    } else {
      backToTopButton.style.opacity = '0';
      backToTopButton.style.transition = 'opacity 0.3s ease';
      backToTopButton.addEventListener('transitionend', function hideButton() {
        if (window.scrollY <= 150) {
          backToTopButton.style.display = 'none';
        }
        backToTopButton.removeEventListener('transitionend', hideButton);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function (e) {

    document.getElementById("back-to-top")?.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });

    // SEO hack for obfuscating links
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const newButtons = mutation.target.querySelectorAll('.link-obfuscate');
          newButtons.forEach(button => {
            if (button.matches('[data-product-card-swatch]')) return;
            button.addEventListener('click', (event) => {
              event.preventDefault();
              const dataUrl = button.dataset.url;
              window.location.href = dataUrl;
            });
          });
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const genderOptions = document.querySelectorAll('.gender-options input[type="radio"]');
    genderOptions.forEach(radio => {
      radio.addEventListener('click', () => {
        var isChecked = Array.from(genderOptions).some(radio => radio.checked);

        if (theme.settings.enable_gender_mandatory === 'false') {
          isChecked = true;
        }

        if ((document.getElementById('gdpr_compliance2')?.checked ||
          document.getElementById('popup_gdpr_compliance2')?.checked) && isChecked) {

          document.querySelector(".section-newsletter #mc-embedded-subscribe")?.removeAttribute("disabled");
          document.querySelector(".popup-cta #custom-mc-subscribe")?.removeAttribute("disabled");
        }
      });
    });

    if (document.getElementById('gdpr_compliance')?.value && document.getElementById('gdpr_compliance2')?.value) {
      document.querySelector("button.btn.shopify-newsletter-bottom-btn")?.setAttribute("disabled", "disabled");
      document.querySelector(".popup-cta #mc-embedded-subscribe")?.setAttribute("disabled", "disabled");
      document.getElementById("shopify-newsletter-bottom-btn")?.setAttribute("disabled", "disabled");
      document.querySelector(".footermailchinpform #mc-embedded-subscribe")?.setAttribute("disabled", "disabled");
    }

    if (document.querySelector(".contact-form div.note--success")) {
      let newsletter_popup_terms = document.querySelector(".newsletter-popup__terms");
      if (newsletter_popup_terms) {
        newsletter_popup_terms.style.display = "none";
      }

      let footer_newsletter_checkbox = document.querySelector("label.text-label.footer-newsletter-checkbox");
      if (footer_newsletter_checkbox) {
        footer_newsletter_checkbox.style.display = "none";
      }
    }

    // CDP consent functionality validation code goes in If condition both checkbox will be optional, in elseif first optional & second mandatory, In else existing validation functionality
    if (theme.settings.cdp_status == 'true' && theme.settings.cdp_validation_status == 'true') {
      // Newsletter Footer & signup page CDP validation code
      document.querySelector(".section-newsletter #mc-embedded-subscribe")?.removeAttribute("disabled");

      // Newsletter popup CDP validation code
      document.querySelector(".popup-cta #custom-mc-subscribe")?.removeAttribute("disabled");
    }
    else if (theme.settings.cdp_status == 'true') {
      // Newsletter Footer & signup page CDP validation code
      const elementBtn = document.getElementById('gdpr_compliance2');
      if (elementBtn) {
        elementBtn.addEventListener('click', () => {
          var isChecked = document.querySelector('.gender-options input[type="radio"]:checked') !== null;

          if (theme.settings.enable_gender_mandatory === 'false') {
            isChecked = true;
          }

          const subscribeButton = document.querySelector(".section-newsletter #mc-embedded-subscribe");
          if (subscribeButton) {
            if (elementBtn.checked && isChecked) {
              subscribeButton.removeAttribute("disabled");
            } else {
              subscribeButton.setAttribute("disabled", "disabled");
            }
          }
        });
      }

      // Newsletter popup CDP validation code
      const elemBtn = document.getElementById('popup_gdpr_compliance2');
      if (elemBtn) {
        elemBtn.addEventListener('click', () => {
          var isChecked = document.querySelector('.gender-options input[type="radio"]:checked') !== null;

          if (theme.settings.enable_gender_mandatory === 'false') {
            isChecked = true;
          }

          const popupSubscribeButton = document.querySelector(".popup-cta #custom-mc-subscribe");
          if (popupSubscribeButton) {
            if (elemBtn.checked && isChecked) {
              popupSubscribeButton.removeAttribute("disabled");
            } else {
              popupSubscribeButton.setAttribute("disabled", "disabled");
            }
          }
        });
      }

    }
    else {
      document.querySelectorAll(".gdpr_compliance").forEach(element => {
        element.addEventListener("click", function () {
          var checked = document.querySelectorAll("input[name=gdpr_compliance]:checked").length;
          var isChecked = document.querySelector('.gender-options input[type="radio"]:checked') !== null;

          if (theme.settings.enable_gender_mandatory === 'false') {
            isChecked = true;
          }

          const toggleElements = [
            "button.btn.shopify-newsletter-bottom-btn",
            ".popup-cta #mc-embedded-subscribe",
            ".footermailchinpform #mc-embedded-subscribe",
            "#shopify-newsletter-bottom-btn",
            ".section-newsletter #mc-embedded-subscribe",
            ".popup-cta #custom-mc-subscribe"
          ];

          toggleElements.forEach(selector => {
            const element = document.querySelector(selector);
            if (element) {
              if (checked === 2 && isChecked) {
                element.removeAttribute("disabled");
              } else {
                element.setAttribute("disabled", "disabled");
              }
            }
          });
        });
      });
    }

    // PDP zoom image datalayer event-label code
    document.querySelectorAll(".custom-zoom-btn").forEach(button => {
      button.addEventListener("click", function () {
        var curr_img = document.querySelector('.is-selected img')?.getAttribute('data-photoswipe-src');
        if (curr_img) {
          this.setAttribute("data-event-label", curr_img);
        }
      });
    });

    // PDP zoom close image datalayer event-label code
    document.getElementById("carousel-image-zoom-close")?.addEventListener("click", function () {
      var current_img = document.querySelector('.is-selected img')?.getAttribute('data-photoswipe-src');
      if (current_img) {
        this.setAttribute("data-event-label", current_img);
      }
    });

    // PDP carousel image zoom left button datalayer event-label code
    document.getElementById("carousel-image-zoom-left")?.addEventListener("click", function () {
      var current_img = document.querySelector('.is-selected img')?.getAttribute('data-photoswipe-src');
      if (current_img) {
        this.setAttribute("data-event-label", current_img);
      }
    });

    // PDP carousel image zoom right button datalayer event-label code
    document.getElementById("carousel-image-zoom-right")?.addEventListener("click", function () {
      var current_img = document.querySelector('.is-selected img')?.getAttribute('data-photoswipe-src');
      if (current_img) {
        this.setAttribute("data-event-label", current_img);
      }
    });

    // Quick View Rating position move
    document.querySelectorAll(".quick-product__btn").forEach(button => {
      button.addEventListener("click", function () {
        var productId = "QuickShopHolder-" + this.getAttribute("data-event-label")
          .toLowerCase()
          .replace(/[^\w ]+/g, '')
          .replace(/ +/g, '-');

        var productMeta = document.querySelector(`#${productId} .product-single__meta`);
        if (productMeta) {
          var priceBlock = productMeta.querySelector(".product-block.product-block--price");
          var powerReviews = productMeta.querySelector(".power-reviews__container");
          var bazaarVoice = productMeta.querySelector(".bazaarvoice__badge-container[data-bv-show=rating_summary]");
          var productType = productMeta.querySelector(".grid-wrapper .product-single__type");

          if (powerReviews && priceBlock) {
            priceBlock.appendChild(powerReviews);
          }
          if (bazaarVoice && priceBlock) {
            priceBlock.appendChild(bazaarVoice);
          }
          if (priceBlock) {
            priceBlock.classList.add("quickview_price_rating");
          }
          if (productType) {
            productType.style.display = "none";
          }
        }
      });
    });

    // To fix product DWFT-958 Image-swipe datalayer fired on quick view.
    sessionStorage.setItem('quickBtnStatus', 'false');
    document.querySelectorAll(".quick-product__btn").forEach(button => {
      button.addEventListener("click", function () {
        sessionStorage.setItem('quickBtnStatus', 'true');
      });
    });

  });

  // Quick View Events
  // Activate PowerReview sections if applicable
  document.addEventListener('quickview:loaded', function (e) {

    var productId = e.detail.productId;
    var sectionId = e.detail.sectionId;

    let pr_category_snippet_total = document.querySelector("[data-section-id='" + sectionId + "'] .product-single__meta .product-block.product-block--price .pr-category-snippet__total");
    if (pr_category_snippet_total) {
      pr_category_snippet_total.style.display = "none";
    }

    let product_single_type = document.querySelector("[data-section-id='" + sectionId + "'] .product-single__meta .grid-wrapper .product-single__type");
    if (product_single_type) {
      product_single_type.style.display = "none";
    }

    const ratingContainer = document.querySelector("[data-product-id='" + productId + "'] .product-single__meta .bazaarvoice__badge-container[data-bv-show=rating_summary]");
    const priceBlock = document.querySelector("[data-product-id='" + productId + "'] .product-single__meta .product-block.product-block--price");

    if (ratingContainer && priceBlock) {
      priceBlock.appendChild(ratingContainer);
    }

    // Quick View reviews display on Tab
    if (theme.settings.pr_merchant_api_key != '' && window.pwr) {
      window.pwr = window.pwr || function () {
        (pwr.q = pwr.q || []).push(arguments);
      };

      //check if OneTrust Group C0002 accepted
      var OneTrustC0002 = window.OnetrustActiveGroups.indexOf('C0002') != -1;

      pwr("render", {
        api_key: theme.settings.pr_merchant_api_key,
        locale: theme.settings.language,
        merchant_group_id: theme.settings.pr_merchant_group_id,
        merchant_id: theme.settings.pr_merchant_id,
        page_id: productId,
        sm_data: OneTrustC0002 ? "ENABLED" : "DISABLED",
        enable_front_end_iovation_validation: OneTrustC0002,
        review_wrapper_url: '/pages/write-a-review/?pr_page_id=' + productId,
        on_render: function (config, data) {
          if (config.component == 'ReviewSnippet') {
            document.querySelector(`[data-product-id='${productId}'] .product-single__meta .product-block.product-block--price`).classList.add("quickview_price_rating");
            var review = document.querySelector(`[data-product-id="${productId}"].is-modal .p-w-r`);
            var priceBlock = document.querySelector(`[data-product-id="${productId}"].is-modal .product-single__meta .product-block.product-block--price`);

            if (priceBlock.querySelector('.product__price-savings').classList.contains('hide')) {
              //move reviews inline with price
              priceBlock.append(review);
            } else {
              //move reviews below price if on sale
              priceBlock.after(review)
            }

          }
        },
        components: {
          ReviewSnippet: `pwr-snippets-${productId}`,
          ReviewDisplay: `pr-reviewdisplay-${productId}`
        }
      });
    }
  });


  // track  add to cart event globally
  document.addEventListener('ajaxProduct:added', function (e) {
    // Extract collection name from URL if product added from qiock view
    const currentUrl = window.location.href;
    let item_list_name = '';
    if (currentUrl.includes('collections')) {
      item_list_name = currentUrl.split('/').pop();
    }

    // track TikTok add to cart event
    if (window.ttq != undefined) {
      ttq.track('AddToCart', {
        content_id: e.detail.product.product_id,
        content_type: 'product',
        content_name: e.detail.product.title,
        quantity: e.detail.qtyparams,
        price: e.detail.product.price / 100.00,
        currency: window.theme.settings.currency,
      });
    }
  });

  function ShowCartNotification(product) {
    var notification = document.querySelector(".notification-root");
    const overlayDiv = document.querySelector('.notification-overlay');
    if (notification) {
      notification.style.display = "block"; // Make the notification visible
      const container = document.getElementById("cart-notification-product");

      // Create a new image element
      const newImg = document.createElement('img');
      newImg.classList.add('lazyautosizes', 'lazyloaded');
      newImg.setAttribute('data-widths', '[180, 360, 540]');
      newImg.setAttribute('data-sizes', 'auto');
      newImg.setAttribute('alt', '');
      newImg.setAttribute('sizes', '150px');
      newImg.setAttribute('srcset', product.image);

      const existingImg = container.querySelector("#notificationImage img");
      existingImg.parentNode.replaceChild(newImg, existingImg);

      container.querySelector("#notificationImage").href = product.image;

      container.querySelector("#notificationImage img").alt = product.handle;
      container.querySelector("#notificationTitle").innerText = product.product_title;
      var html = "";
      product.options_with_values.forEach(x => {
        html += `<div>${x.name} <span id="notificationColor">${x.value}</span></div>`;
      });
      container.querySelector(".cart__item--variants").innerHTML = html;

      // Select the span element
      const bubbleNumElement = document.querySelector('.cart-link__bubble-num');
      // Check if the element exists
      if (bubbleNumElement) {
        bubbleNumElement.parentElement?.classList.add('cart-link__bubble--visible');
        // Get the current number value or set it to 0 if it's empty
        let currentNum = parseInt(bubbleNumElement.innerText.trim()) || 0;
        // Increment the number
        currentNum++;
        // Update the span element with the new number
        bubbleNumElement.innerText = currentNum;
      }

      var closeButton = document.querySelector('.js-drawer-close');
      // Check if the close button exists
      if (closeButton) {
        // Trigger a click event on the close button
        closeButton.click();
      }
      setTimeout(function () {
        notification.style.opacity = "1"; // Fade in the notification
        overlayDiv.style.display = "block";
        var closeButton = document.querySelector('.js-drawer-close');
        if (closeButton) {
          closeButton.click();
        }
        window.scrollTo({
          // top: 0,
          // behavior: "smooth" // Add smooth scrolling behavior
        });
        document.body.style.overflow = 'hidden'; // Disable scrolling
      }, 1000); // A slight delay for the transition to work properly
    }
  }

  //Start code here DWFT-3181 Shopping cart-Promo progress bar functionality
  function getCartItemCount() {

    fetch('/cart.js')
      .then(response => response.json())
      .then(res => {
        let status_promo_progress = theme.settings.select_promo_progress_bar;
        let status_free_shipping_progress_bar = theme.settings.free_shipping_progress_bar;
        let cartTotalValue = res.total_price / 100.00;
        let promo_progressBar = theme.settings.promo_progress_bar;
        let byob_progress_bar = theme.settings.byob_progress_bar;

        if (status_promo_progress === true && promo_progressBar === true) {
          let storeMultibuyQty = 0;

          res.items.forEach(maindata => {
            if (maindata.line_level_discount_allocations.length > 0) {
              maindata.line_level_discount_allocations.forEach(data => {
                if (data.discount_application.type === 'script') {
                  storeMultibuyQty += maindata.quantity;
                }
              });
            }
          });

          let res_item_count = storeMultibuyQty;
          let tier_qty1 = theme.settings.multibuy_tier1_qty;
          let tier_qty2 = theme.settings.multibuy_tier2_qty;
          let tier_qty3 = theme.settings.multibuy_tier3_qty;
          let multibuy_tier1_msg = theme.settings.multibuy_message_tier1_msg;
          let multibuy_tier2_msg = theme.settings.multibuy_message_tier2_msg;
          let multibuy_tier3_msg = theme.settings.multibuy_message_tier3_msg;
          let multibuy_emptycart_message = theme.settings.multibuy_emptycart_message;
          const greatestTier = Math.max(tier_qty1, tier_qty2, tier_qty3);
          let smallestTier = Math.min(tier_qty1, tier_qty2, tier_qty3);
          let caclculate_bar_width = 100 / greatestTier;
          let final_bar_width = caclculate_bar_width * res_item_count;
          if (final_bar_width > 100) { final_bar_width = 100; }
          if (res_item_count >= tier_qty3) {
            document.querySelector(".custom-progress-bar-wrap p").innerHTML = multibuy_tier3_msg;
            let progressBar_drawer = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBar_drawer.style.width = final_bar_width + '%';
            if (window.location.href.indexOf('/cart') !== -1) {
              document.querySelector(".progress-bar-cart p").innerHTML = multibuy_tier3_msg;
              let progressBar = document.querySelector('.progress-bar-cart .promo-inner-bar');
              progressBar.style.width = final_bar_width + '%';
            }
          } else if (res_item_count < tier_qty3 && res_item_count >= tier_qty2) {
            document.querySelector(".custom-progress-bar-wrap p").innerHTML = multibuy_tier2_msg;
            let progressBar_drawer = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBar_drawer.style.width = final_bar_width + '%';
            if (window.location.href.indexOf('/cart') !== -1) {
              document.querySelector(".progress-bar-cart p").innerHTML = multibuy_tier2_msg;
              let progressBar = document.querySelector('.progress-bar-cart .promo-inner-bar');
              progressBar.style.width = final_bar_width + '%';
            }
          } else if (res_item_count < tier_qty2 && res_item_count >= tier_qty1) {
            document.querySelector(".custom-progress-bar-wrap p").innerHTML = multibuy_tier1_msg;
            let progressBar_drawer = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBar_drawer.style.width = final_bar_width + '%';
            if (window.location.href.indexOf('/cart') !== -1) {
              document.querySelector(".progress-bar-cart p").innerHTML = multibuy_tier1_msg;
              let progressBar = document.querySelector('.progress-bar-cart .promo-inner-bar');
              progressBar.style.width = final_bar_width + '%';
            }
          } else if (res_item_count == 0 || res_item_count < smallestTier) {
            document.querySelector(".custom-progress-bar-wrap p").innerHTML = multibuy_emptycart_message;
            let progressBar_drawer = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBar_drawer.style.width = '0%';
            if (window.location.href.indexOf('/cart') !== -1) {
              document.querySelector(".progress-bar-cart p").innerHTML = multibuy_emptycart_message;
              let progressBar = document.querySelector('.progress-bar-cart .promo-inner-bar');
              progressBar.style.width = '0%';
            }
          }

        }
        else if (status_free_shipping_progress_bar == true && promo_progressBar == true) {
          let shippingValueLimit = theme.settings.free_shipping_value_limit; //get shipping value limit from customizer
          let shippingInprogressMsg = theme.settings.free_shipping_inprogress_msg.replace(/<[^>]*>/g, '');  //get shipping In progress msg from customizer
          let shippingCompletedMsg = theme.settings.free_shipping_completed_msg; //get shipping completed msg from customizer
          let findFinalMoneyFormatStr = theme.settings.moneyFormat
            .toUpperCase()
            .match(/[$£€]|KR/g)
            ?.join("")
            .toLowerCase() || ''; //get moneyFormat and filter the currency sign
          if (cartTotalValue == 0) {
            let shippingValueLimitString = shippingValueLimit.toString();
            if (findFinalMoneyFormatStr.includes("kr")) {
              shippingValueLimitString = '<strong>' + shippingValueLimitString + ' ' + findFinalMoneyFormatStr + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            } else if (findFinalMoneyFormatStr.includes("€")) {
              shippingValueLimitString = '<strong>' + shippingValueLimitString + findFinalMoneyFormatStr + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            }
            else {
              shippingValueLimitString = '<strong>' + findFinalMoneyFormatStr + shippingValueLimitString + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            }
            let progressBarMiniCart = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBarMiniCart.style.width = '0%';
          }
          else if (cartTotalValue < shippingValueLimit) {
            let finalShippingValue = shippingValueLimit - cartTotalValue;
            finalShippingValue = Math.floor(finalShippingValue * 100) / 100;
            let shippingValueLimitString = finalShippingValue.toString();
            if (shippingValueLimitString.includes('.') && shippingValueLimitString.split('.')[1].length === 1) {
              shippingValueLimitString += '0';
            }
            let getShopDomainName = theme.settings.shopdomain.toLowerCase();
            if (getShopDomainName.includes("tena.de") || getShopDomainName.includes("tena.fr") || getShopDomainName.includes("fr-tena") || getShopDomainName.includes("de-tena")) {
              shippingValueLimitString = shippingValueLimitString.replace(".", ",");
            }
            if (findFinalMoneyFormatStr.includes("kr")) {
              shippingValueLimitString = '<strong>' + shippingValueLimitString + ' ' + findFinalMoneyFormatStr + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            } else if (findFinalMoneyFormatStr.includes("€")) {
              shippingValueLimitString = '<strong>' + shippingValueLimitString + findFinalMoneyFormatStr + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            }
            else {
              shippingValueLimitString = '<strong>' + findFinalMoneyFormatStr + shippingValueLimitString + '</strong>';
              document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingValueLimitString + ' ' + shippingInprogressMsg;
            }
            let progressBarMiniCart = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            let calculateBarWidth = cartTotalValue / shippingValueLimit * 100;
            progressBarMiniCart.style.width = calculateBarWidth + '%';
          }
          else if (cartTotalValue >= shippingValueLimit) {
            document.querySelector(".custom-progress-bar-wrap .custom-shipping-message").innerHTML = shippingCompletedMsg;
            let progressBarMiniCart = document.querySelector('.custom-progress-bar-wrap .promo-inner-bar');
            progressBarMiniCart.style.width = '100%';
          }
        }
        //DWFT-4881 BYOB -> Mini-cart behaviour functionality
        if (byob_progress_bar === true) {
          var finalMultibuyQty = 0;
          const listItems = document.querySelectorAll('li.cart__item');
          listItems.forEach((item, index) => {
            const quantity = parseInt(item.dataset.quantity, 10);
            const bundleProductTag = item.dataset.byobProductTag;
            const bundleVariantMetafields = item.dataset.byobVariantMetafields;
            if (bundleProductTag === "true" && bundleVariantMetafields === "false" && !isNaN(quantity)) {
              finalMultibuyQty += quantity;
            }
          });

          let finalCount = finalMultibuyQty;
          const { byob_tier1_qty, byob_tier2_qty, byob_tier3_qty } = theme.settings;
          const messageContainer = document.querySelector('.byob-minicart-progressbar-message h3');
          function getTierMessage(count, tier1, tier2, tier3) {
            // checking out empty or undefined tiers
            const tiers = [tier1, tier2, tier3].filter(n => typeof n === 'number' && n > 0).sort((a, b) => a - b);
            if (count === 0 && tiers[0]) {
              let byob_empty_message_text = theme.settings.byob_empty_message_text;
              return byob_empty_message_text.replace(/<\/?p>/gi, '');
            }

            if (count < tiers[0]) {
              const nextTier = tiers[0];
              const x = nextTier - count;
              let byob_inprogress_msg = theme.settings.byob_inprogress_msg;
              byob_inprogress_msg = byob_inprogress_msg.replace("X", x);
              return byob_inprogress_msg.replace(/<\/?p>/gi, '');
            }

            if (count >= tiers[0] && count < (tiers[1] || Infinity)) {
              const nextTier = tiers[1];
              const x = nextTier - count;
              let byob_message_tier1_msg = theme.settings.byob_message_tier1_msg;
              const messageResult = tierMessageHandler(byob_message_tier1_msg);
              let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
              let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
              tier_message_part2 = tier_message_part2.replace("X", x);
              const styledPart1 = `<span class="minicart-tier-msg-partone">${tier_message_part1}</span>`;
              return styledPart1 + tier_message_part2;
            }

            if (tiers[1] && count >= tiers[1] && count < (tiers[2] || Infinity)) {
              const nextTier = tiers[2];
              const x = nextTier - count;
              let byob_message_tier2_msg = theme.settings.byob_message_tier2_msg;
              const messageResult = tierMessageHandler(byob_message_tier2_msg);
              let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
              let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
              tier_message_part2 = tier_message_part2.replace("X", x);
              const styledPart1 = `<span class="minicart-tier-msg-partone">${tier_message_part1}</span>`;
              return styledPart1 + tier_message_part2;
            }

            if (tiers[2] && count >= tiers[2]) {
              let byob_message_tier3_msg = theme.settings.byob_message_tier3_msg;
              const messageResult = tierMessageHandler(byob_message_tier3_msg);
              let tier_message_part1 = messageResult.tier_msg_part1.replace(/<\/?p>/gi, '');
              let tier_message_part2 = messageResult.tier_msg_part2.replace(/<\/?p>/gi, '');
              const styledPart1 = `<span class="minicart-tier-msg-partone">${tier_message_part1}</span>`;

              return styledPart1 + tier_message_part2;
            }

            return '';
          }
          function tierMessageHandler(tierMessage) {
            let tier_msg_split = tierMessage.split("%");
            let tier_before_percent = tier_msg_split[0];

            let tier_after_percent = tierMessage
              .replace(tier_before_percent, '')
              .replace('%', '');

            let tier_space_split = tier_after_percent.trim().split(" ");
            let tier_first_word = tier_space_split[0]; // "Only"

            // first part of the message
            let tier_msg_part1 = tier_before_percent + "%" + tier_first_word + " ";

            // second part of the message
            let tier_msg_part2 = tierMessage.replace(tier_msg_part1, '');

            return {
              tier_msg_part1: tier_msg_part1,
              tier_msg_part2: tier_msg_part2
            };
          }

          const message = getTierMessage(finalCount, byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);

          if (messageContainer) {
            messageContainer.innerHTML = message;
          }

          //progress bar handler code goes here
          const progressbarWrapper = document.getElementById('byob-minicart-bar-wrapper');
          progressbarWrapper.innerHTML = '';

          const {
            byob_tier1_discount,
            byob_tier2_discount,
            byob_tier3_discount
          } = theme.settings;

          const currentCount = finalMultibuyQty;

          const barLength = Math.max(byob_tier1_qty, byob_tier2_qty, byob_tier3_qty);
          const tiers = [
            { qty: byob_tier1_qty, discount: byob_tier1_discount },
            { qty: byob_tier2_qty, discount: byob_tier2_discount },
            { qty: byob_tier3_qty, discount: byob_tier3_discount }
          ];
          const isTenaStore = document.body.classList.contains('tena-store');

          for (let i = 1; i <= barLength; i++) {
            const barInnerWrap = document.createElement('div');
            barInnerWrap.className = 'byob-minicart-bar-inner-wrap';

            const percentageBar = document.createElement('div');
            percentageBar.className = 'minicart-percentage';

            const bar = document.createElement('div');
            bar.className = 'minicart-byob-bar';

            // Checking if it's tier bar
            const tier = tiers.find(t => t.qty === i);

            if (tier) {
              percentageBar.innerText = `${tier.discount}%`;

              if (i <= currentCount) {
                percentageBar.style.opacity = '1';
                bar.style.opacity = '1';
              } else {
                percentageBar.style.opacity = '0.3';
                bar.style.opacity = '0.3';
              }

              if (isTenaStore) {
                bar.style.background = '#003A81';
              } else {
                bar.style.background = '#d11788';
              }
            } else {
              percentageBar.innerHTML = '&nbsp;';

              if (i <= currentCount) {
                if (isTenaStore) {
                  bar.style.backgroundColor = '#439EDD';
                } else {
                  bar.style.backgroundColor = '#2e2e2e';
                }
                bar.style.opacity = '1';
              } else {
                if (isTenaStore) {
                  bar.style.backgroundColor = '#D8D8D8';
                } else {
                  bar.style.backgroundColor = '#d7d3d3';
                }
              }
            }

            barInnerWrap.appendChild(percentageBar);
            barInnerWrap.appendChild(bar);
            progressbarWrapper.appendChild(barInnerWrap);
          }
        }

      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  function displayStaticContent() {
    let static_message_text = theme.settings.static_message_text;
    document.querySelector(".custom-progress-bar-wrap p").innerHTML = static_message_text;

  }

  //Start code here DWFT-3247
  document.body.addEventListener('click', function (event) {
    const qtyremTarget = event.target.closest('.text-link.cart-qty-removed');
    if (qtyremTarget) {
      const qtyremTargetSvg = qtyremTarget.querySelector('svg');
      const closeitemDiv = event.target.closest('.cart__item');
      if (closeitemDiv && qtyremTargetSvg) {
        let status_promo_progress = theme.settings.select_promo_progress_bar;
        let promo_progress_bar = theme.settings.promo_progress_bar;
        let status_free_shipping_bar = theme.settings.free_shipping_progress_bar;
        if ((status_promo_progress == true || status_free_shipping_bar == true) && promo_progress_bar == true) {
          function handleDataAttributeChange(mutationList, observer) {
            mutationList.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                getCartItemCount();
              }
            });
          }
          const checkingelement = document.getElementById('CartDrawer');
          const observer = new MutationObserver(handleDataAttributeChange);
          const config = { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] };
          observer.observe(checkingelement, config);
        }
      }
    }
  });

  function ga4AddToCartEvent(product, quick_buy, quantity) {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    const item_list_name = getItemListName();
    dataLayer.push({
      'event': "add_to_cart",
      'quick_buy': quick_buy,
      'ecommerce': {
        'items': [
          {
            'item_id': product.id,
            'item_name': product.title,
            'currency': window.theme.settings.currency,
            'discount': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).discount,
            'index': +product.index,
            'item_list_name': item_list_name,
            'item_variant': product.variantTitle,
            'price': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).variantActualPrice,
            'quantity': quantity,
          },
        ],
      }
    });
  }


})();

const newsLetterTextArr = ['newsletter', 'nyhetsbrev', 'nyhedsbrev', 'uutiskirjeet'];
const isNewsLetterPage = newsLetterTextArr.find(nlText => (window.location.origin + window.location.pathname).includes(nlText))

function getUpdatedNewsletterFormId(formId) {
  let updatedFormId = formId;
  if (formId == 'newsletter-newsletter-popup' || formId == 'mc-popup-form' || formId == 'hubspot-popup-form') {
    updatedFormId = 'newsletter-popup';
  }
  else if ((formId == 'newsletter-newsletter-newsletter' || formId == 'mc-embedded-subscribe-form' || formId == 'hubspot-embedded-subscribe-form') && !isNewsLetterPage) {
    updatedFormId = 'newsletter-footer';
  }
  else if (formId == 'newsletter-newsletter-newsletter-page' || formId == 'mc-embedded-subscribe-form' || formId == 'hubspot-embedded-subscribe-form') {
    updatedFormId = 'newsletter-page';
  }

  return updatedFormId;
}
// ga4_form_visible event
document.addEventListener("DOMContentLoaded", function (e) {
  // Get all forms in the document
  var forms = document.querySelectorAll('form');
  // Loop through each form and initiate intersection observer on each form
  forms.forEach(function (form) {
    const visibleFields = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
    if (visibleFields.length > 0) {
      theme.initWhenVisible({
        element: form,
        callback: () => {
          let formId = form.getAttribute('id') || '';
          const formName = form.getAttribute('name') || '';

          //DWFT-3068 Preventing form_visible event fire except login, sign-up and newsletter forms
          const forms_Ids = ['customer_login', 'create_customer', 'newsletter-newsletter-popup', 'mc-popup-form', 'newsletter-newsletter-newsletter', 'newsletter-newsletter-newsletter-page', 'mc-embedded-subscribe-form', 'hubspot-embedded-subscribe-form', 'hubspot-popup-form'];
          const checkingformsIds = forms_Ids.find(formIdName => (formId).includes(formIdName))
          if (checkingformsIds) {
            const updatedFormId = getUpdatedNewsletterFormId(formId)

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "event": "ga4_form_visible",
              "ga4_data": {
                "form_name": formName,
                "form_id": updatedFormId
              }
            })
          }
        },
        threshold: 0.9
      });
    }
  })
})

// GA4 view_item event when quick view pop up opens
function ga4ViewItemEvent(product) {

  const item_list_name = getItemListName();

  dataLayer.push({
    'event': 'view_item',
    'ecommerce': {
      'items': [
        {
          'item_id': product.id,
          'item_name': product.title,
          'currency': window.theme.settings.currency,
          'discount': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).discount,
          'index': +product.index,
          'item_list_name': item_list_name,
          'item_variant': product.variantTitle,
          'price': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).variantActualPrice
        },
      ],
    }
  });

};

function handleCollapsibleElements(el) {
  // Select the form element
  const form = document.querySelector('#side-filter-form');

  if (form) {
    // Select all buttons and divs with the data-collapsible-id attribute within the form
    const buttons = form.querySelectorAll('button[data-collapsible-id]');
    const divs = form.querySelectorAll('div[data-collapsible-id]');

    // Convert NodeList to Array
    const buttonsArray = Array.from(buttons);
    const divsArray = Array.from(divs);

    // Helper to check for ANY active filter (Checkbox OR Price Range)
    const checkActive = (element) => {
      if (!element) return false;
      // 1. Check for checked checkboxes
      if (element.querySelector('input:checked')) return true;
      // 2. Check for active price range inputs
      const priceInputs = element.querySelectorAll('.price-range__input');
      for (let i = 0; i < priceInputs.length; i++) {
        if (priceInputs[i].value && priceInputs[i].value.trim() !== '') {
          return true;
        }
      }
      return false;
    };

    // Loop through each button
    buttonsArray.forEach(button => {
      const contentDiv = form.querySelector(`div[data-collapsible-id="${button.dataset.collapsibleId}"]`);
      const hasActiveFilter = checkActive(contentDiv);

      // Logic for buttons that are NOT the one currently being clicked
      if (button.dataset.collapsibleId !== el.dataset.collapsibleId) {

        // If it has an active filter, let it stay open or closed based on user's previous choice.
        if (hasActiveFilter) return;

        // If no active filter, enforce standard accordion behavior (close it)
        button.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');

        const counterDiv = button.querySelector('div[filterIndex]');
        if (counterDiv && counterDiv.innerHTML.trim()) {
          counterDiv.style.display = 'block';
        }

      } else {
        // Logic for the currently clicked button
        // Toggle the counter visibility based on current state
        const counterDiv = button.querySelector('div[filterIndex]');
        if (button.classList.contains('is-open') && counterDiv.innerHTML.trim()) {
          counterDiv.style.display = 'block'; // It was open, now closing -> show counter
        } else {
          counterDiv.style.display = 'none'; // It was closed, now opening -> hide counter
        }
      }
    });

    // Loop through each div
    divsArray.forEach(div => {
      const hasActiveFilter = checkActive(div);

      // Logic for divs that are NOT the one currently being clicked
      if (div.dataset.collapsibleId !== el.dataset.collapsibleId) {

        // If it has active filter, leave it alone.
        if (hasActiveFilter) return;

        // Otherwise, close it.
        div.classList.remove('is-open');
        div.style.height = '0px';
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  let formSubmitEventCount = 0;

  document.querySelectorAll("form").forEach(form => {
    form.addEventListener("submit", function (event) {
      let formId = event.currentTarget.getAttribute("id") || "";
      const formName = event.currentTarget.getAttribute("name") || "";

      // DWFT-3068 Preventing form_visible event fire except login, sign-up and newsletter forms
      const forms_Ids = [
        "customer_login", "create_customer", "newsletter-newsletter-popup",
        "mc-popup-form", "newsletter-newsletter-newsletter",
        "newsletter-newsletter-newsletter-page", "mc-embedded-subscribe-form",
        "hubspot-embedded-subscribe-form", "hubspot-popup-form"
      ];

      const checkingformsIds = forms_Ids.find(formIdName => formId.includes(formIdName));
      const excludedForms = [
        "hubspot-embedded-subscribe-form",
        "hubspot-popup-form"
      ];

      if (checkingformsIds) {
        const updatedFormId = getUpdatedNewsletterFormId(formId);

        if (formId === "customer_login" || formId === "create_customer") {
          localStorage.setItem("form_id", formId);
          localStorage.setItem("form_name", formName);
        } else if(checkingformsIds && checkingformsIds !== "hubspot-embedded-subscribe-form" && checkingformsIds !== "hubspot-popup-form"){
          const ga4FormSubmit = () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              "event": "ga4_form_submit",
              "ga4_data": {
                "form_name": formName,
                "form_id": updatedFormId
              }
            });
          };

          const mcResponseDiv = document.getElementById("mce-responses");

          if (mcResponseDiv) {
            const mutationCallback = (mutationsList, observer) => {
              for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                  if (mutation.target.id === "mce-success-response" && formSubmitEventCount === 0) {
                    formSubmitEventCount++;
                    ga4FormSubmit();
                  }
                }
              }
            };

            const observer = new MutationObserver(mutationCallback);
            const observerConfig = { childList: true, subtree: true };
            observer.observe(mcResponseDiv, observerConfig);
          } else {
            ga4FormSubmit();
            formSubmitEventCount++;
          }
        }
      }
    });

    form.addEventListener("keyup", function (event) {
      let formId = event.currentTarget.getAttribute("id") || "";
      const formName = event.currentTarget.getAttribute("name") || "";

      // DWFT-3068 Preventing form_visible event fire except login, sign-up and newsletter forms
      const forms_Ids = [
        "customer_login", "create_customer", "newsletter-newsletter-popup",
        "mc-popup-form", "newsletter-newsletter-newsletter",
        "newsletter-newsletter-newsletter-page", "mc-embedded-subscribe-form",
        "hubspot-embedded-subscribe-form", "hubspot-popup-form"
      ];

      const checkingformsIds = forms_Ids.find(formIdName => formId.includes(formIdName));

      if (checkingformsIds) {
        const updatedFormId = getUpdatedNewsletterFormId(formId);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "event": "ga4_form_start",
          "ga4_data": {
            "form_name": formName,
            "form_id": updatedFormId
          }
        });

        // Remove `keyup` event listener from the form
        form.removeEventListener("keyup", arguments.callee);
      }
    }, { once: true }); // the event should be run only once.
  });
});

// GA4 ga4_click event when user clicks on external link
document.addEventListener("click", function (e) {
  const productCardSwatch = e.target.closest("[data-product-card-swatch]");
  if (productCardSwatch) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var card = productCardSwatch.closest('.grid-product');
    if (!card) return;

    card.querySelectorAll('[data-product-card-swatch]').forEach(item => {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
      var itemSwatch = item.classList && item.classList.contains('color-swatch') ? item : item.querySelector('.color-swatch');
      if (itemSwatch) itemSwatch.classList.remove('is-active');
    });

    productCardSwatch.classList.add('is-active');
    productCardSwatch.setAttribute('aria-pressed', 'true');
    var selectedSwatch = productCardSwatch.classList.contains('color-swatch') ? productCardSwatch : productCardSwatch.querySelector('.color-swatch');
    if (selectedSwatch) selectedSwatch.classList.add('is-active');

    var variantId = productCardSwatch.dataset.variantId;
    var variantImage = productCardSwatch.dataset.variantImage;
    var imageMask = card.querySelector('.grid-product__image-mask');
    if (imageMask) {
      imageMask.querySelectorAll('.grid-product__color-image').forEach(image => {
        image.classList.remove('is-active', 'is-selected');
      });
    }

    if (variantId && variantImage) {
      var variantImageEl = card.querySelector('.grid-product__color-image--' + variantId);
      if (variantImageEl) {
        variantImageEl.style.backgroundImage = 'url(' + variantImage + ')';
        variantImageEl.classList.add('is-active', 'is-selected');
      }
    }

    var priceEl = card.querySelector('[data-product-card-price]');
    var price = parseInt(productCardSwatch.dataset.variantPrice, 10);
    var comparePrice = parseInt(productCardSwatch.dataset.variantComparePrice, 10) || 0;
    if (priceEl && price) {
      var priceHtml = '';
      if (comparePrice > price) {
        priceHtml += '<span class="visually-hidden">' + (theme.strings.regularPrice || 'Regular price') + '</span>';
        priceHtml += '<span class="grid-product__price--original">' + theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat) + '</span> ';
        priceHtml += '<span class="visually-hidden">' + (theme.strings.salePrice || 'Sale price') + '</span>';
      }
      priceHtml += '<span class="grid-product__price--after">' + theme.Currency.formatMoney(price, theme.settings.moneyFormat) + '</span>';
      priceEl.innerHTML = priceHtml;
    }

    var url = productCardSwatch.dataset.url;
    var productLink = card.querySelector('.grid-product__link');
    if (url && productLink) {
      productLink.setAttribute('href', url);
    }

    return;
  }

  const target = e.target.closest("a, button.link-obfuscate");
  if (!target) return;

  let href = target.getAttribute("href");
  const selfhost = window.location.hostname;

  if (target.classList.contains("link-obfuscate")) {
    href = target.dataset.url;
  }

  // Check for absolute URL without the current host included
  if ((href.includes("://") || href.startsWith("//")) && !href.includes(selfhost)) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4_click",
      "ga4_data": {
        "link_url": href,
        "link_domain": new URL(href).hostname.replace("www.", ""),
        "link_text": target.innerText.trim() || "",
        "outbound": true
      }
    });
  }
});

function initializeProductCardSelectedSwatches(root) {
  root = root || document;
  root.querySelectorAll('.grid-product').forEach(card => {
    if (card.dataset.productCardSwatchInitialized === 'true') return;

    const initialSwatch = Array.from(card.querySelectorAll('[data-product-card-swatch]')).find(swatch => {
      return swatch.dataset.variantImage && swatch.dataset.variantImage.trim() !== '';
    });

    if (initialSwatch) {
      initialSwatch.click();
      card.dataset.productCardSwatchInitialized = 'true';
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeProductCardSelectedSwatches(document);
});

// GA4 select_item event
async function ga4SelectItemEvent(product) {
  const item_list_name = getItemListName();
  dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
  const itemVariantValue = window.theme.settings.templateSuffix.includes("bundle")
    ? 'pd_bundle ' + product?.title
    : product?.variantTitle;

  const selectItemObj = {
    'event': "select_item",
    'ecommerce': {
      'items': [
        {
          'item_id': product?.id,
          'item_name': product?.title,
          'currency': window.theme.settings.currency,
          'discount': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).discount,
          'index': +product.index,
          'item_list_name': item_list_name,
          'item_variant': itemVariantValue,
          'price': +calculatePriceDiscount(product.price, product.comparePrice, product.finalPrice).variantActualPrice,
        },
      ],
    }
  }
  dataLayer.push(selectItemObj);
}


// Select all cart items for click event
document.querySelectorAll(".cart__image, .cart__item-name").forEach(element => {
  element.addEventListener("click", async function () {
    const targetNode = this.closest(".cart__item");
    if (targetNode) {
      const itemSelected = getItemDetails(targetNode);
      await ga4SelectItemEvent(itemSelected);
    }
  });
});

// GA4 ga4_phone_click event
document.addEventListener("click", function (e) {
  const target = e.target.closest("a[href^='tel:']");
  if (target) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4_phone_click"
    });
  }
});

// GA4 ga4_email_click event
document.addEventListener("click", function (e) {
  const target = e.target.closest("a[href^='mailto:']");
  if (target) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "event": "ga4_email_click"
    });
  }
});

// function to calculate discount & price of line level items for GA4 events
function calculatePriceDiscount(variantPrice, variantComparePrice, variantFinalPrice) {
  let variantActualPrice = +variantComparePrice || 0;
  if (!variantActualPrice || variantActualPrice < variantPrice) {
    variantActualPrice = +variantPrice || 0;
  }
  const discount = variantActualPrice && variantActualPrice - variantFinalPrice || 0
  return {
    variantActualPrice: (variantActualPrice / 100).toFixed(2),
    discount: (discount / 100).toFixed(2)
  }
}

function getItemDetails(el) {
  return {
    id: el.dataset.productId,
    title: el.dataset.productTitle,
    variantTitle: el.dataset.variantTitle,
    index: el.dataset.productIndex,
    price: el.dataset.variantPrice,
    comparePrice: el.dataset.variantComparePrice,
    finalPrice: el.dataset.productFinalPrice,
    quantity: el.dataset.quantity,
    isBundleTag: el.dataset.bundleProductTag
  };
}


// GA4 ga4_select_promotion event
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".section-hero ol li").forEach(item => {
    item.addEventListener("click", function () {
      const promotionName = this.querySelector("h1.hero__title")?.innerText.trim().replace(/(\r\n|\n|\r)/gm, ' ') || "Promotion";

      if (promotionName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "event": "ga4_select_promotion",
          "ga4_data": {
            "creative_name": "Hero Banner",
            "promotion_name": promotionName
          }
        });
      }
    });
  });
});

// GA4 ga4_share event
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("div.social-sharing a").forEach(link => {
    link.addEventListener("click", function () {
      const methodText = this.querySelector(".visually-hidden")?.innerText || "";

      let shareMethod;
      const socialPlatforms = ["Facebook", "Twitter", "Pinterest"];

      for (let item of socialPlatforms) {
        if (methodText.toLowerCase().includes(item.toLowerCase())) {
          shareMethod = item;
          break;
        }
      }

      if (shareMethod) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "event": "ga4_share",
          "ga4_data": {
            "method": shareMethod
          }
        });
      }
    });
  });
});

function getItemListName() {
  let getItemPathName = window.location.pathname;
  let itemListName = "";
  if (getItemPathName.startsWith('/collections')) {
    itemListName = getItemPathName.split('/')[2];
  }

  return itemListName;
}

function productGridClick(event) {
  let targetElement = event.currentTarget;
  let gridProduct = targetElement;

  if (targetElement.classList.contains("quick-product__label")) {
    gridProduct = targetElement.closest(".grid-product");
  }

  const itemSelected = getItemDetails(gridProduct);

  ga4SelectItemEvent(itemSelected);

  if (targetElement.classList.contains("quick-product__label")) {
    ga4ViewItemEvent(itemSelected);
  }
}

// GA4 ga4_file_download event
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("a").forEach(link => {
    link.addEventListener("click", function (e) {
      const hrefUrl = this.getAttribute("href");

      if (hrefUrl && hrefUrl.toLowerCase().includes(".pdf")) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          "event": "ga4_file_download",
          "ga4_data": {
            "file_extension": "PDF",
            "file_name": hrefUrl.split("/").pop()?.split("?")[0],
            "link_text": this.innerText.trim(),
            "link_url": hrefUrl,
            "link_domain": new URL(hrefUrl).hostname.replace("www.", "")
          }
        });
      }
    });
  });
});

// GA4 ga4_chat event
function ga4ChatEvent(interactionType = "") {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "event": "ga4_chat",
    "ga4_data": {
      "action_type": interactionType
    }
  })
}

let chatInitiateEvent = 0;
let chatCloseEvent = 0;
let chatTypeEvent = 0;
let chatSubmitEvent = 0;

document.addEventListener("DOMContentLoaded", function () {
  const parentElement = document.body;
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const addedNodes = Array.from(mutation.addedNodes) || [];
      const shadowRootElement = addedNodes.find(node => node?.id === 'ShopifyChat');
      if (shadowRootElement) {
        if (shadowRootElement.shadowRoot) {
          const observer = new MutationObserver((mutations) => {
            const chatAppDiv = shadowRootElement.shadowRoot.querySelector('div.chat-app');
            if (chatAppDiv) {
              console.log('Chat app div found in Shadow DOM' + chatAppDiv);
              // DWFT-4264 and DWFT-4263 accessibility
              chatAppDiv.setAttribute('aria-label', theme.strings.shopifyinboxchat);
              chatAppDiv.setAttribute('role', 'dialog');
              // DWFT-4272 Accessibility focus
              let intervalId;
              function handleButtonEvents() {
                const chatToggleButton = chatAppDiv.querySelector('button.chat-toggle');
                const chatCloseButton = chatAppDiv.querySelector('button.chat-app--close-button');
                if (chatToggleButton) {
                  chatToggleButton.addEventListener('click', () => {
                    let chatCtaElement = chatAppDiv.querySelector('.composer-bar__footer-button');
                    let chatCtaImageElement = chatAppDiv.querySelector('.composer-bar__footer-message .composer-bar__footer-button');
                    if (chatCtaElement) {
                      chatCtaElement.setAttribute('aria-label', theme.strings.shopifyinboxsendmsg);
                    }
                    if (chatCtaImageElement) {
                      chatCtaImageElement.setAttribute('aria-label', theme.strings.shopifyinboximgupload);
                    }
                    intervalId = setInterval(() => {
                      const chatHeaderBack = chatAppDiv.querySelector('.chat-ui .chat-header .chat-header__info button');
                      let chatCtaImageElement = chatAppDiv.querySelector('.composer-bar__footer-message .composer-bar__footer-button');
                      let chatCtaElement = chatAppDiv.querySelector('.composer-bar__footer-button');

                      // Check for null before adding event listeners for chatHeaderBack
                      if (chatHeaderBack) {
                        chatHeaderBack.addEventListener('focus', () => {
                          chatHeaderBack.style.outline = '1px solid blue';
                        });

                        chatHeaderBack.addEventListener('focus', () => {
                          if (chatHeaderBack === document.activeElement && !chatHeaderBack.matches(':focus-visible')) {
                            chatHeaderBack.style.outline = 'none'; // Ensure mouse click doesn't trigger focus-visible
                          }
                        });

                        chatHeaderBack.addEventListener('blur', () => {
                          chatHeaderBack.style.outline = 'none'; // Remove the outline when losing focus
                        });
                      }

                      // Check for null before adding event listeners for chatCtaImageElement
                      if (chatCtaImageElement) {
                        chatCtaImageElement.addEventListener('focus', () => {
                          chatCtaImageElement.style.outline = '1px solid blue';
                        });

                        chatCtaImageElement.addEventListener('focus', () => {
                          if (chatCtaImageElement === document.activeElement && !chatCtaImageElement.matches(':focus-visible')) {
                            chatCtaImageElement.style.outline = 'none';
                          }
                        });

                        chatCtaImageElement.addEventListener('blur', () => {
                          chatCtaImageElement.style.outline = 'none';
                        });
                      }

                      // Check for null before adding event listeners for chatCtaElement
                      if (chatCtaElement) {
                        chatCtaElement.addEventListener('focus', () => {
                          chatCtaElement.style.outline = '1px solid blue';
                        });

                        chatCtaElement.addEventListener('focus', () => {
                          if (chatCtaElement === document.activeElement && !chatCtaElement.matches(':focus-visible')) {
                            chatCtaElement.style.outline = 'none';
                          }
                        });

                        chatCtaElement.addEventListener('blur', () => {
                          chatCtaElement.style.outline = 'none';
                        });
                      }

                      let chatButtons = chatAppDiv.querySelectorAll('button');

                      // Loop through all buttons and add event listeners
                      chatButtons.forEach(button => {
                        // Check for null before adding event listeners
                        if (button) {
                          button.addEventListener('focus', () => {
                            button.style.outline = '1px solid blue'; // Add outline on focus
                          });

                          button.addEventListener('focus', () => {
                            if (button === document.activeElement && !button.matches(':focus-visible')) {
                              button.style.outline = 'none'; // Ensure mouse click doesn't trigger focus-visible
                            }
                          });

                          button.addEventListener('blur', () => {
                            button.style.outline = 'none'; // Remove the outline when losing focus
                          });
                        }
                      });
                    }, 2000);
                    if (chatInitiateEvent == 0) {
                      ga4ChatEvent("Initiate");
                      chatInitiateEvent++;
                    }

                    handleButtonEvents();
                    setupFormEventListeners();
                  });
                } else if (chatCloseButton) { // Corrected conditional logic
                  chatCloseButton.addEventListener('click', () => {
                    if (chatCloseEvent == 0) {
                      ga4ChatEvent("Close");
                      chatCloseEvent++;
                    }
                    // Clear the interval when the chat is closed
                    clearInterval(intervalId);
                    handleButtonEvents();

                  });

                  setTimeout(() => {

                    setupFormEventListeners();
                  }, 1500);
                }
              }

              function setupFormEventListeners() {
                const formElement = chatAppDiv.querySelector('form');
                formElement.addEventListener('submit', function (event) {
                  if (chatSubmitEvent == 0) {
                    ga4ChatEvent("Send message");
                    chatSubmitEvent++;
                  }
                });

                formElement.addEventListener('keyup', function (event) {
                  if (event.key === 'Enter' && chatSubmitEvent == 0) {
                    ga4ChatEvent("Send message");
                    chatSubmitEvent++;
                  } else if (chatTypeEvent == 0) {
                    ga4ChatEvent("Start typing");
                    chatTypeEvent++;
                  }
                });
              }
              handleButtonEvents();
            }
          });

          observer.observe(shadowRootElement.shadowRoot, { childList: true }); // Observe Shadow DOM changes
        }
      }

    });
  });
  const config = { childList: true, subtree: true };
  observer.observe(parentElement, config);
})

// GA4 ga4_product_media event
function ga4ProductMedia(actionType = "", prodId, prodTitle) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "event": "ga4_product_media",
    "ga4_data": {
      "action_type": actionType,
      "single_item_id": prodId,
      "single_item_name": prodTitle
    }
  });
}

let ga4ProdMediaEventCount = 0;

document.addEventListener("click", function (e) {
  const targetEl = e.target.closest(".product__photos");
  if (!targetEl) return;

  const prodSection = targetEl.closest(".product-section");
  const itemSelected = getItemDetails(prodSection);
  let actionType;

  if (e.target.tagName === "SVG" || e.target.classList.contains("product__thumb-arrow")) {
    actionType = "Arrow click";
  } else if (e.target.tagName === "BUTTON") {
    actionType = "Open image";
  } else if (e.target.tagName === "IMG" || e.target.tagName === "A") {
    actionType = "Select image";
  }

  if (typeof ga4ProdMediaEventCount !== "undefined" && ga4ProdMediaEventCount === 0 && actionType) {
    ga4ProductMedia(actionType, itemSelected.id, itemSelected.title);
    ga4ProdMediaEventCount++;
  }
});

document.addEventListener("DOMContentLoaded", function (e) {
  const bodyElement = document.body;
  const modelImage = document.querySelectorAll('.grid-product__image.model-image');
  const modelHover = document.querySelectorAll('.grid-product_secondary_image.model-image');
  const observerForm = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (bodyElement.classList.contains('no-product-image')) {
          if (modelImage.length > 0) {
            modelImage.forEach(modimage => {
              modimage.classList.add('show-AB-testy-model-image');
            });
            if (modelHover.length > 0) {
              modelHover.forEach(modelHover => {
                modelHover.classList.add('show-AB-testy-hover-model-image');
                if (modelHover.previousElementSibling && modelHover.previousElementSibling.tagName === 'IMG') {
                  // Set display to none
                  modelHover.previousElementSibling.style.display = 'none';
                }
              });
            }
          }
          const imageContainer = document.querySelector('.grid__image-ratio');  // Select the container element
          if (imageContainer.querySelector('.show-AB-testy-model-image')) {
            // If the second image has the class "show-AB-testy-model-image"
            imageContainer.querySelector('.grid-product__image:not(.show-AB-testy-model-image)').style.display = 'none';
          }
        }
      }
    }
  });
  // Configuration for the observer (watching for attribute changes)
  const observerFormConfig = { attributes: true, attributeFilter: ['class'] };
  // Start observing the target element (body tag)
  observerForm.observe(bodyElement, observerFormConfig);
});

// DWFT-3371 Begin checkout datalayer on the cart page
if (window.theme.settings.enable_checkout2_begin_checkout === true) {
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("cart__checkout")) {
      fetch("/cart.js")
        .then(response => response.json())
        .then(res => {
          let lineItemsData = [];
          let indexItem = 0;

          for (const cartLineItem of res.items) {
            lineItemsData.push({
              item_id: cartLineItem.product_id,
              item_name: cartLineItem.product_title,
              currency: window.theme.settings.currency,
              discount: cartLineItem.total_discount / 100.00,
              index: indexItem,
              item_variant: cartLineItem?.variant_title,
              price: cartLineItem.final_price / 100.00,
              quantity: cartLineItem.quantity
            });
            indexItem++;
          }

          dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          dataLayer.push({
            "event": "begin_checkout",
            "ecommerce": {
              "items": lineItemsData
            }
          });
        })
        .catch(error => console.error("Error fetching cart data:", error));
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth < 769; // Adjust the width as needed
  const collectionFiltersButtons = document.querySelectorAll('.js-sidebar-open-collection-filters, .js-drawer-open-collection-filters');
  const collectionFiltersButton = collectionFiltersButtons[0] || null;
  let collectionFiltersOverlay;
  let currentQuickFilterGroup = window.currentQuickFilterGroup || null;

  function getCollectionFiltersDrawer() {
    return document.querySelector('.collection-sidebar');
  }

  function getCloseFilterButton() {
    return document.querySelector('button.collection-sidebar-header-icon');
  }

  function updateDrawerHeaderTitle(newTitle) {
    const titleEl = document.querySelector('.collection-sidebar .section-header__title.h4');
    if (!titleEl) return;

    const filterSizeEl = titleEl.querySelector('.filter-size');
    const titleText = String(newTitle || '').trim();

    if (titleText) {
      const textNode = Array.from(titleEl.childNodes).find(node => node.nodeType === 3);
      if (textNode) {
        textNode.textContent = titleText;
      } else {
        titleEl.insertBefore(document.createTextNode(titleText), titleEl.firstChild);
      }
    }

    if (filterSizeEl && !titleEl.contains(filterSizeEl)) {
      titleEl.appendChild(filterSizeEl);
    }
  }

  function applyCurrentQuickFilterGroup() {
    const collectionFiltersDrawer = getCollectionFiltersDrawer();
    if (!collectionFiltersDrawer || !currentQuickFilterGroup) return;
    collectionFiltersDrawer.setAttribute('data-active-filter-group', currentQuickFilterGroup);
    const groupItem = collectionFiltersDrawer.querySelector(`.collection-sidebar__group--item[data-quick-filter-group="${currentQuickFilterGroup}"]`);
    if (groupItem) {
      const content = groupItem.querySelector('.collapsible-content');
      const trigger = groupItem.querySelector('[aria-expanded]');
      if (content) {
        content.classList.add('is-open');
        content.style.height = 'auto';
      }
      if (trigger) {
        trigger.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    }
    // Update header title to reflect the active quick filter
    try {
      const titleEl = document.querySelector('.collection-sidebar .section-header__title.h4');
      if (titleEl) {
        const drawer = getCollectionFiltersDrawer();
        const attr = `data-quick-filter-title-${currentQuickFilterGroup}`;
        const txt = drawer && drawer.getAttribute(attr) ? drawer.getAttribute(attr) : drawer && drawer.getAttribute('data-quick-filter-default-title') ? drawer.getAttribute('data-quick-filter-default-title') : titleEl.innerText;
        updateDrawerHeaderTitle(txt);
      }
    } catch (e) {}
  }
 
  function updateQuickFilterButtonStates() {
    try {
      document.querySelectorAll('.js-quick-filter').forEach(btn => {
        const group = btn.dataset.quickFilterGroup;
        if (!group) return;
        const groupEl = document.querySelector(`.collection-sidebar__group--item[data-quick-filter-group="${group}"]`);
        let hasActive = false;
        if (groupEl) {
          if (groupEl.querySelector('.tag--active')) hasActive = true;
          if (!hasActive && groupEl.querySelector('input[type="checkbox"]:checked')) hasActive = true;
        }
        btn.classList.toggle('is-active', hasActive);
      });
    } catch (e) {}
  }

  function openFilterSidebar(groupName) {
    const collectionFiltersDrawer = getCollectionFiltersDrawer();
    if (!collectionFiltersDrawer || !groupName) return;

    currentQuickFilterGroup = groupName;
    window.currentQuickFilterGroup = groupName;
    applyCurrentQuickFilterGroup();
    try { console.log('openFilterSidebar set currentQuickFilterGroup=', groupName); } catch (e) {}

    if (!collectionFiltersDrawer.classList.contains('open')) {
      collectionFiltersDrawer.classList.add('open');
      toggleOverlayAndScroll();
    }

    const closeFilterButton = getCloseFilterButton();
    if (closeFilterButton) {
      try { closeFilterButton.focus(); } catch (e) {}
    }

    theme.a11y.trapFocus({
      container: collectionFiltersDrawer,
      namespace: 'drawer_focus'
    });
  }

  function clearQuickFilterState() {
    currentQuickFilterGroup = null;
    try { window.currentQuickFilterGroup = null; } catch (e) {}
    document.querySelectorAll('.collection-sidebar').forEach(sb => {
      try { sb.removeAttribute('data-active-filter-group'); } catch (e) {}
    });
    // Reveal any groups or tags hidden by quick-filter logic or injected CSS
    document.querySelectorAll('.collection-sidebar__group--item, .collection-sidebar__group--item .tag, .tag.hide').forEach(el => {
      try { el.classList.remove('hide'); } catch (e) {}
      try { el.style.display = ''; } catch (e) {}
    });
    try {
      const injected = document.getElementById('skip-filter-hide');
      if (injected && injected.parentNode) injected.parentNode.removeChild(injected);
    } catch (e) {}
    try { console.log('clearQuickFilterState ran, currentQuickFilterGroup cleared'); } catch (e) {}
    // Restore header title to default while preserving the active count badge.
    try {
      const titleEl = document.querySelector('.collection-sidebar .section-header__title.h4');
      const drawer = getCollectionFiltersDrawer();
      if (titleEl && drawer) {
        const def = drawer.getAttribute('data-quick-filter-default-title');
        if (def) updateDrawerHeaderTitle(def);
      }
    } catch (e) {}
    try { updateQuickFilterButtonStates(); } catch (e) {}
  }

  document.body.addEventListener('click', (event) => {
    const quickFilterButton = event.target.closest('.js-quick-filter');
    if (!quickFilterButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openFilterSidebar(quickFilterButton.dataset.quickFilterGroup);
  });

  // Initial pass to set quick-filter button visuals on page load
  try { updateQuickFilterButtonStates(); } catch (e) {}

  // Capture-phase delegated handler to catch any clicks on the normal Filter button(s)
  document.body.addEventListener('click', (event) => {
    const filterBtn = event.target.closest('.js-sidebar-open-collection-filters, .js-drawer-open-collection-filters');
    if (!filterBtn) return;
    try { console.log('Filter button clicked (capture) - clearing quick-filter state'); } catch (e) {}
    try { sessionStorage.setItem('clearQuickFilterGroup', '1'); } catch (e) {}
    clearQuickFilterState();
    // allow other handlers to run
  }, true);

  const collectionFiltersDrawer = getCollectionFiltersDrawer();
  if (collectionFiltersButton && collectionFiltersDrawer) {
    // Toggle drawer and manage overlay/scroll on filter button click
    collectionFiltersButton.addEventListener('click', (event) => {
      event.stopPropagation();
      // Remove injected CSS and session flag if present so manual open works
      try {
        const injected = document.getElementById('skip-filter-hide');
        if (injected && injected.parentNode) injected.parentNode.removeChild(injected);
      } catch (e) {}
      try { sessionStorage.removeItem('skipOpenFilterSidebar'); } catch (e) {}
      const liveDrawer = getCollectionFiltersDrawer();
      if (!liveDrawer) return;

      const isDrawerOpening = !liveDrawer.classList.contains('open');
      if (isDrawerOpening) {
        // Aggressively clear any quick-filter state so the standard Filter shows all groups
        try { sessionStorage.setItem('clearQuickFilterGroup', '1'); } catch (e) {}
        clearQuickFilterState();
        liveDrawer.removeAttribute('data-active-filter-group');
      }
      liveDrawer.classList.toggle('open');
      // If opening via the standard Filter button, ensure all filter groups are expanded
      if (isDrawerOpening) {
        // Open all collapsible menus in the filter form initially (matches original behavior)
        document.querySelectorAll('#side-filter-form div[data-collapsible-id]').forEach(div => {
          div.classList.add('is-open');
          div.style.height = 'auto';
        });
        document.querySelectorAll('#side-filter-form button[data-collapsible-id]').forEach(btn => {
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        });
        // Ensure any groups hidden by quick-filter state are revealed
        document.querySelectorAll('.collection-sidebar__group--item').forEach(group => {
          group.classList.remove('hide');
          group.style.display = '';
        });
      }
      const closeBtn = getCloseFilterButton();
      if (closeBtn) {
        try { closeBtn.focus(); } catch (e) {}
      }
      toggleOverlayAndScroll();

      if (isDrawerOpening) {
        theme.a11y.trapFocus({
          container: liveDrawer,
          namespace: 'drawer_focus'
        });
      }

    });
    // Close drawer and manage overlay/scroll on click outside drawer
    document.body.addEventListener('click', (event) => {
      const liveDrawer = getCollectionFiltersDrawer();
      if (!liveDrawer || !liveDrawer.classList.contains('open')) return; // Exit if drawer is already closed

      const target = event.target;
      if (target !== liveDrawer && !liveDrawer.contains(target)) {
        liveDrawer.classList.remove('open');
        toggleOverlayAndScroll();
      }
    });


    const closeBtn = getCloseFilterButton();
    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default behavior (if applicable)
        event.stopPropagation(); // Prevent event propagation

        const liveDrawer = getCollectionFiltersDrawer();
        if (liveDrawer) liveDrawer.classList.remove('open');
        collectionFiltersButton.focus();
        toggleOverlayAndScroll();

      });
    }

    const applyFilterBtn = document.querySelector('button#apply-filter-btn');
    if (applyFilterBtn) {
      applyFilterBtn.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default behavior (if applicable)
        event.stopPropagation(); // Prevent event propagation
        const liveDrawer = getCollectionFiltersDrawer();
        if (liveDrawer) liveDrawer.classList.remove('open');
        const overlay = document.querySelector('.overlay');
        if (overlay) {
          overlay.remove();
        }

      });
    }

    const handleSmallScreens = () => {

      const buttons = document.querySelectorAll('#side-filter-form button[data-collapsible-id]');
      buttons.forEach(button => {
        button.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');

        const counterDiv = button.querySelector('div[filterIndex]');
        if (counterDiv && counterDiv.innerHTML.trim()) {
          counterDiv.style.display = 'block';
        }
      });

      const divs = document.querySelectorAll('#side-filter-form div[data-collapsible-id]');
      divs.forEach(div => {
        div.classList.add('is-open');
        div.style.height = 'auto';
      });
    }
    const screenWidth = window.innerWidth;
    if (screenWidth < 769) {
      handleSmallScreens();
    }
  }
  // Function to manage overlay and scroll state based on drawer state
  function toggleOverlayAndScroll() {
    const collectionFiltersDrawerElement = document.querySelector('.collection-sidebar');
    if (collectionFiltersDrawerElement.classList.contains('open')) {
      // Ensure overlay is created/reapplied every time drawer opens
      if (!collectionFiltersOverlay) {
        collectionFiltersOverlay = document.createElement('div');
        collectionFiltersOverlay.classList.add('overlay');
        document.body.appendChild(collectionFiltersOverlay);
      }
      document.body.classList.add('no-scroll', 'is--filter-open');
    } else {
      if (collectionFiltersOverlay) {
        collectionFiltersOverlay.remove();
      }
      document.body.classList.remove('no-scroll', 'is--filter-open');
    }
  }
  const tags = document.querySelectorAll('.tag-list .tag--swatch .btn .tag__text');
  tags.forEach(tag => {
    const textLength = tag.textContent.trim().length;
    if (textLength > 9) {
      tag.parentElement.parentElement.parentElement.parentElement.classList.add('tag--long');
    }
  });
});

// DWFT-3852 GA4 view_cart on miniCart
const miniCartTargetElement = document.querySelector('#CartDrawer');
let hasRun = false;

// Here is MutationObserver code
const miniCartObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.target.classList.contains('drawer--is-open')) {
      if (!hasRun) {
        hasRun = true;

        fetch("/cart.js")
          .then(response => response.json())
          .then(resp => {
            let miniCartLineItems = [];
            for (const miniCartLineItem of resp.items) {
              let calcPerItemDiscount = miniCartLineItem.total_discount / 100.00;
              calcPerItemDiscount = calcPerItemDiscount / miniCartLineItem.quantity;
              calcPerItemDiscount = Math.floor(calcPerItemDiscount * 100) / 100;

              let itemTitle;
              const isPredefinedBundle = miniCartLineItem.properties?._is_Predefined_Bundle?.toLowerCase() === "true";
              if (isPredefinedBundle) {
                itemTitle = 'pd_bundle ' + miniCartLineItem.product_title;
              }
              else {
                itemTitle = miniCartLineItem?.variant_title;
              }

              miniCartLineItems.push({
                item_id: miniCartLineItem.product_id,
                item_name: miniCartLineItem.product_title,
                currency: window.theme.settings.currency,
                discount: calcPerItemDiscount,
                item_variant: itemTitle,
                price: miniCartLineItem.original_price / 100.00,
                quantity: miniCartLineItem.quantity
              });
            }

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
              "event": "view_cart",
              "ecommerce": {
                "currency": window.theme.settings.currency,
                "value": resp.total_price / 100.00,
                "items": miniCartLineItems
              }
            });
          })
          .catch(error => console.error("Error fetching cart data:", error));

      }
    } else if (mutation.type === 'attributes' && !mutation.target.classList.contains('drawer--is-open')) {
      hasRun = false;
    }
  }
});

// Here is the Configuration for the MiniCart observer
const miniCartConfig = {
  attributes: true
};

// Start MiniCart observing the target element
if (miniCartTargetElement) {
  miniCartObserver.observe(miniCartTargetElement, miniCartConfig);
}

//DWFT-3942 Cart scripts - BlueConic connection
function getBluconicCartData() {
  fetch("/cart.js")
    .then(response => response.json())
    .then(bluconicResp => {
      let bluconicLineItems = bluconicResp.items.map(item => item.product_id.toString());

      // Egyedi termék ID-k kiszűrése
      let blueconicUniqueItems = [...new Set(bluconicLineItems)];

      // Publikálás a BlueConic rendszer felé
      blueConicClient.event.publish("shoppingcart", {
        productIds: blueconicUniqueItems,
        storeId: theme.settings.bluconic_connection_storeid
      });
    })
    .catch(error => console.error("Error fetching cart data:", error));
}

document.addEventListener("DOMContentLoaded", function () {
  let productBlock = document.querySelector('.product-section .product-block.product-block--tab.product-block--tab-tab');
  if (productBlock) {
    let button = productBlock.querySelector('.collapsible-trigger');
    // Set the button class to 'is-open' and set aria-expanded to true
    if (button) {
      button.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
    // Find the div with the id that starts with 'Product-content'
    let collapsibleContent = productBlock.querySelector('[id^="Product-content"]');
    if (collapsibleContent) {
      collapsibleContent.classList.add('is-open');
      collapsibleContent.style.height = 'auto';
    }
  }
});

//DWFT-3975_remove_from_miniCart
var getUpdatedQty = 0;
function getdlcartdata(ele) {
  getUpdatedQty = ele;
  return ele;
}
document.body.addEventListener('click', function (event) {
  const qtyRemoveTarget = event.target.closest('.text-link.cart-qty-removed');
  if (qtyRemoveTarget) {
    const qtyRemoveTargetSvg = qtyRemoveTarget.querySelector('svg');
    const itemDiv = event.target.closest('.cart__item');
    if (itemDiv && qtyRemoveTargetSvg) {
      // GA4 remove_from_Minicart event
      const updatedVariantValue = itemDiv.dataset.bundleProductTag === 'true' ? `pd_bundle ${itemDiv.dataset.productTitle}` : itemDiv.dataset.variantTitle;
      dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      dataLayer.push({
        'event': "remove_from_cart",
        'ecommerce': {
          'items': [
            {
              'item_id': itemDiv.dataset.productId,
              'item_name': itemDiv.dataset.productTitle,
              'currency': window.theme.settings.currency,
              'item_variant': updatedVariantValue,
              'price': itemDiv.dataset.variantPrice / 100,
              'quantity': getUpdatedQty,
            },
          ],
        }
      });
    }
  }
});

function overrideCookies() {
  // DWFT-4208 Accessibility
  const cookieObserver = new MutationObserver(mutations => {
    const accordionItem = document.querySelectorAll('.ot-accordion-layout');

    accordionItem.forEach((el) => {
      const accHeader = el.querySelector('.ot-cat-header');
      const accContent = el.querySelector('.ot-acc-txt');

      accContent.setAttribute("role", "region");
      accContent.setAttribute("aria-labelledby", accHeader.id);
    })
  });
  cookieObserver.observe(document.body, { childList: true, subtree: true });
}

// DWFT-4210 Accessibility
function overrideButtonStyle(targetId) {
  const cookieObserver = new MutationObserver(mutations => {
    const element = document.getElementById(targetId);
    const element1 = document.getElementById('onetrust-reject-all-handler');
    const element2 = document.getElementById('onetrust-pc-btn-handler');
    const primary_btn = theme.settings.primary_button_color;
    const btn_hover_color = theme.settings.button_hover_color;

    const linkAttribute = document.querySelector('.ot-cookie-policy-link');
    if (linkAttribute) {
      linkAttribute.removeAttribute('aria-label');
    }

    if (element || element1 || element2) {
      const style = document.createElement('style');
      style.innerHTML = `
        .theme-styling--bodyform #${targetId}, .theme-styling--bodyform #onetrust-reject-all-handler, .theme-styling--bodyform #onetrust-pc-btn-handler{
          color: ${primary_btn} !important;
          border: 1px solid ${primary_btn} !important;
        }
        .theme-styling--bodyform #onetrust-consent-sdk #onetrust-banner-sdk a[href]{color: ${primary_btn};}
        .theme-styling--bodyform #${targetId}:hover, .theme-styling--bodyform #onetrust-reject-all-handler:hover, .theme-styling--bodyform #onetrust-pc-btn-handler:hover{
          color: ${btn_hover_color} !important;
          background-color: transparent !important;
          border-color: ${btn_hover_color} !important;
        }
      `;
      document.head.appendChild(style);
      cookieObserver.disconnect();
    }
  });

  cookieObserver.observe(document.body, { childList: true, subtree: true });
}
overrideCookies();
overrideButtonStyle('onetrust-accept-btn-handler');

// DWFT-4253 Accessibility
const newsletterObserver = new MutationObserver(mutations => {
  const errorDiv = document.querySelector('#mc_embed_signup div.mce_inline_error');
  if (errorDiv) {
    errorDiv.id = 'email-error-msg';
    newsletterObserver.disconnect(); // Stop observing once the element is found and modified
  }
});

newsletterObserver.observe(document.body, { childList: true, subtree: true });

/**
 * Get hidden DOM element's height, like jQuery height() method does.
 */
function getHiddenElementHeight(el) {
  if (!el) return 0;

  // Store the original styles.
  const originalDisplay = el.style.display;
  const originalVisibility = el.style.visibility;
  const originalPosition = el.style.position;

  // Display the element temporarily.
  el.style.display = 'block';
  el.style.visibility = 'hidden';
  el.style.position = 'absolute';

  // Get the height of the element.
  const height = el.offsetHeight;

  // Remove paddings' values from the height.
  const computedStyle = window.getComputedStyle(el);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);

  const contentHeight = height - paddingTop - paddingBottom;

  // Restore the original style.
  el.style.display = originalDisplay;
  el.style.visibility = originalVisibility;
  el.style.position = originalPosition;

  return contentHeight;
}

window.addEventListener('load', () => {
  const cookieSubmitButton = document.querySelector('button.save-preference-btn-handler.onetrust-close-btn-handler');
  const cookieSubmitButtonSecondary = document.querySelector('#accept-recommended-btn-handler');
  cookieSubmitButton && cookieSubmitButton.addEventListener('click', () => {
    location.reload();
  })

  cookieSubmitButtonSecondary && cookieSubmitButtonSecondary.addEventListener('click', () => {
    location.reload();
  })
})

window.addEventListener('load', () => {
  const timeout = 30000; // 30 seconds
  const startTime = Date.now();
  const targetNode = document.body;
  const observerConfig = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    let chatElement = document.querySelector('#shopify-chat inbox-online-store-chat');
    if (chatElement) {
      chatElement.style.setProperty("z-index", "9999", "important");
      observer.disconnect(); // Stop observing once the element is found and updated
    }

    if (Date.now() - startTime >= timeout) {
      observer.disconnect(); // Stop observing if timeout is reached
    }
  });

  observer.observe(targetNode, observerConfig);
});

// Manage bundle card in cart
document.body.addEventListener('click', (e) => {
  const target = e.target;
  const bundleButton = target.closest('.bundle__item-btn');
  if (bundleButton) {
    e.preventDefault();
    const cartItem = bundleButton.closest('.cart__item');
    if (cartItem) {
      cartItem.classList.toggle('show-more');

      const textSpan = bundleButton.querySelector('span');
      if (textSpan) {
        const label = bundleButton.dataset.text || textSpan.textContent;
        textSpan.textContent = label;
      }
    }
  }
});

// DWFT-5177 Newsletter Signup Fields Form
const hubspotForm = document.querySelector('#hubspot-embedded-subscribe-form');
const hubspotFormPopup = document.querySelector('#hubspot-popup-form');
const mailchimpFormPopup = document.querySelector('#custom-popup-cta #mc-popup-form');

function isValidEmail(email) {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;
  return regex.test(email);
}

function formEventsHandler(hubspotForm, className, errorClassName, isEmailCheck) {
  if (hubspotForm) {
    const requiredFields = hubspotForm.querySelectorAll('input[data-required="true"]');

    function checkValidFields() {
      let isValid = true;
      requiredFields.forEach(field => {
        const mainWrapper = field.closest(`.${className}`);
        if (field.value.trim().length > 0) {
          mainWrapper.querySelector(`.${errorClassName}`).style.display = 'none';
          field.classList.remove('input-is-error');
        } else {
          mainWrapper.querySelector(`.${errorClassName}`).style.display = 'block';
          field.classList.add('input-is-error');
          isValid = false;
        }
      });

      return isValid;
    }

    requiredFields.forEach(field => {
      const mainWrapper = field.closest(`.${className}`);

      field.addEventListener('change', () => {
        if (field.value.trim().length > 0) {
          mainWrapper.querySelector(`.${errorClassName}`).style.display = 'none';
          field.classList.remove('input-is-error');
        } else {
          mainWrapper.querySelector(`.${errorClassName}`).innerText = theme.settings.newsletter_error_msg_default;
          mainWrapper.querySelector(`.${errorClassName}`).style.display = 'block';
          field.classList.add('input-is-error');
        }

        if (field.getAttribute('type') == 'email' && isEmailCheck && field.value.trim().length > 0) {
          if (isValidEmail(field.value)) {
            mainWrapper.querySelector(`.${errorClassName}`).style.display = 'none';
            field.classList.remove('input-is-error');
          } else {
            mainWrapper.querySelector(`.${errorClassName}`).innerText = theme.settings.newsletter_error_msg;
            mainWrapper.querySelector(`.${errorClassName}`).style.display = 'block';
            field.classList.add('input-is-error');
          }
        }
      })
    });

    hubspotForm.addEventListener('submit', (e) => {
      if (!checkValidFields()) {
        e.preventDefault();
        if (className !== 'mc-field-group') {
          e.stopImmediatePropagation();
        }
      }
    })
  }
}

formEventsHandler(hubspotForm, 'hubspot-field-group', 'hubspot_inline_error', true);
formEventsHandler(hubspotFormPopup, 'hubspot-field-group', 'hubspot_inline_error', true);
formEventsHandler(mailchimpFormPopup, 'mc-field-group', 'mce_popup_inline_error-c');

var lastClickedElement;
document.body.addEventListener('click', (e) => {
  lastClickedElement = e.target;
})
// Track clicks on absorbency CTAs so we can suppress auto-opening the filter sidebar
document.body.addEventListener('click', (e) => {
  try {
    const cta = e.target && e.target.closest && e.target.closest('.btnboxtab');
    if (!cta) return;

    // Always set the skip-flag to avoid auto-opening the sidebar on redirect
    try { sessionStorage.setItem('skipOpenFilterSidebar', '1'); } catch (err) {}
    setTimeout(() => { try { sessionStorage.removeItem('skipOpenFilterSidebar'); } catch (err) {} }, 3000);

    // If the CTA exposes a filter param/value we will handle it as a multi-select
    const filterParam = cta.getAttribute('data-filter-param') || cta.dataset.filterParam;
    const filterValue = cta.getAttribute('data-filter-value') || cta.dataset.filterValue;

    if (filterParam && filterValue) {
      // Prevent navigation — we'll apply the filter via the existing form/AJAX flow
      e.preventDefault();

      const form = document.querySelector('#side-filter-form');
      // If form isn't present, fall back to navigation
      if (!form) {
        window.location.href = cta.href;
        return;
      }

      // Find matching input(s) by name and value. Try exact match first.
      let matchedInput = form.querySelector(`input[name="${filterParam}"][value="${filterValue}"]`);

      if (!matchedInput) {
        // Normalize the filterValue for comparisons (decode + replace pluses)
        const normalizedTarget = decodeURIComponent(filterValue || '').replace(/\+/g, ' ').trim().toLowerCase();
        const inputs = Array.from(form.querySelectorAll(`input[name="${filterParam}"]`));
        matchedInput = inputs.find(i => {
          if (!i) return false;
          if (i.value && i.value.toLowerCase() === (filterValue || '').toLowerCase()) return true;
          const labelText = i.closest('label')?.textContent?.trim()?.toLowerCase();
          if (labelText && labelText.includes(normalizedTarget)) return true;
          // If the filter values themselves are encoded differently, try decoding them
          try {
            const decoded = decodeURIComponent(i.value || '').replace(/\+/g, ' ').toLowerCase();
            if (decoded === normalizedTarget) return true;
          } catch (err) {}
          return false;
        });
      }

      if (!matchedInput) {
        // No matching input found — fall back to performing a normal navigation
        window.location.href = cta.href;
        return;
      }

      // Toggle checked state and dispatch events so existing listeners run AJAX
      matchedInput.checked = !matchedInput.checked;
      matchedInput.dispatchEvent(new Event('input', { bubbles: true }));
      matchedInput.dispatchEvent(new Event('change', { bubbles: true }));

      // Update UI classes: tag active state and CTA active state
      try {
        const li = matchedInput.closest('li.tag');
        if (li) li.classList.toggle('tag--active', matchedInput.checked);
        cta.classList.toggle('btn--active', matchedInput.checked);
      } catch (err) {}

      return;
    }

    // If no data-filter attributes, nothing else to do here — skip flag already set.
  } catch (err) { }
});

function checkFiltersHandler() {
  if (window.location.search.includes('filter.p.m.custom') || window.location.search.includes('filter.v.option')) {
    if (!window.location.search.includes('filter.v.availability')) {
      const inStockFilter = document.querySelector('.filter-form input[name="filter.v.availability"][value="1"]');
      if (inStockFilter) {
        const label = inStockFilter.closest('label.tag__checkbox-wrapper');
        let oldLabel = null;
        if (lastClickedElement) {
          oldLabel = lastClickedElement.closest('label.tag__checkbox-wrapper');
        }
        const isOldLabelAvailable = oldLabel?.querySelector('input[name="filter.v.availability"][value="1"]');

        if (!isOldLabelAvailable) {
          // Do not click the label (it opens the drawer). Instead set the
          // availability input and dispatch events so the Collection form
          // input listener runs the AJAX update without opening the UI.
          const availabilityInput = label?.querySelector('input[name="filter.v.availability"][value="1"]') || inStockFilter;
          if (availabilityInput) {
            availabilityInput.checked = true;
            availabilityInput.dispatchEvent(new Event('input', { bubbles: true }));
            availabilityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    }
  }
}

function addAutomaticAvailabilityFilter(searchParams, sourceElement) {
  if (!searchParams || typeof searchParams.has !== 'function') return;

  const hasFilterNeedingAvailability = Array.from(searchParams.keys()).some(key => (
    key.indexOf('filter.p.m.custom') !== -1 || key.indexOf('filter.v.option') !== -1
  ));

  if (!hasFilterNeedingAvailability || searchParams.has('filter.v.availability')) return;

  const availabilityInput = document.querySelector('.filter-form input[name="filter.v.availability"][value="1"]');
  if (!availabilityInput) return;

  const sourceLabel = sourceElement?.closest && sourceElement.closest('label.tag__checkbox-wrapper');
  const sourceIsAvailabilityFilter = sourceLabel?.querySelector('input[name="filter.v.availability"]');
  if (sourceIsAvailabilityFilter) return;

  searchParams.append('filter.v.availability', '1');
}
// Keep CTA buttons in sync with filter drawer inputs (useful when user toggles filters in the drawer)
function syncAbsorbencyCTAsFromForm() {
  try {
    const form = document.querySelector('#side-filter-form');

    const ctas = document.querySelectorAll('.btnboxtab[data-filter-param][data-filter-value]');
    if (!ctas || !ctas.length) return;

    const urlParams = new URLSearchParams(window.location.search);

    ctas.forEach(cta => {
      const param = cta.getAttribute('data-filter-param');
      const value = cta.getAttribute('data-filter-value');
      if (!param || !value) return;

      let isChecked = false;

      if (form) {
        const input = form.querySelector(`input[name="${param}"][value="${value}"]`);
        if (input) {
          isChecked = !!input.checked;
        }
      }

      // Fallback to URL if form/input not present or not checked
      if (!isChecked) {
        const values = urlParams.getAll(param).map(v => decodeURIComponent(v || '').replace(/\+/g, ' ').toLowerCase());
        const target = decodeURIComponent(value || '').replace(/\+/g, ' ').toLowerCase();
        if (values.length && values.indexOf(target) !== -1) {
          isChecked = true;
        }
      }

      // hide the CTA so users only see actionable options.
      let isValueAvailable = false;
      if (form) {
        const matchInput = form.querySelector(`input[name="${param}"][value="${value}"]`);
        if (matchInput) isValueAvailable = true;
      }
      if (!isValueAvailable) {
        // If the value is currently selected via URL, keep it visible.
        const urlVals = urlParams.getAll(param).map(v => decodeURIComponent(v || '').replace(/\+/g, ' ').toLowerCase());
        const targetVal = decodeURIComponent(value || '').replace(/\+/g, ' ').toLowerCase();
        if (urlVals.length && urlVals.indexOf(targetVal) !== -1) isValueAvailable = true;
      }

      if (isValueAvailable) {
        cta.style.display = '';
        try { cta.removeAttribute('aria-hidden'); } catch (e) {}
      } else {
        // Hide non-actionable CTA. Also ensure it's not marked active.
        cta.style.display = 'none';
        try { cta.setAttribute('aria-hidden', 'true'); } catch (e) {}
        cta.classList.remove('btn--active');
        try { cta.setAttribute('aria-pressed', 'false'); } catch (e) {}
        return; // skip further toggles for hidden CTAs
      }
      cta.classList.toggle('btn--active', isChecked);
      try { cta.setAttribute('aria-pressed', isChecked ? 'true' : 'false'); } catch (e) {}
    });
  } catch (err) {
    // swallow errors — non-critical
  }
}

// Attach change listener to the side filter form so CTAs update when user interacts in the drawer
document.addEventListener('DOMContentLoaded', function () {
  const sideForm = document.querySelector('#side-filter-form');
  if (sideForm) {
    sideForm.addEventListener('change', function () {
      syncAbsorbencyCTAsFromForm();
    });
  }
  // Initial sync on load
  syncAbsorbencyCTAsFromForm();
  // Ensure keyboard users can toggle CTAs via Enter/Space when focused
  document.addEventListener('keydown', function (e) {
    try {
      const active = document.activeElement;
      if (!active) return;
      const cta = active.matches && active.matches('.btnboxtab') ? active : active.closest && active.closest('.btnboxtab');
      if (!cta) return;

      // Space or Enter
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        // Prevent scrolling on Space
        e.preventDefault();
        // Trigger the same click handling path
        cta.click();
      }
    } catch (err) {}
  });
});
window.addEventListener('load', () => {
  checkFiltersHandler();
  // If this page load came from an absorbency CTA, ensure the filter
  // sidebar is closed and any overlay/body classes removed.
  try {
    const skipFlag = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('skipOpenFilterSidebar');
    if (skipFlag) {
      try { sessionStorage.removeItem('skipOpenFilterSidebar'); } catch (e) { }
      const sb = document.querySelector('.collection-sidebar');
      if (sb) sb.classList.remove('open');
      document.body.classList.remove('no-scroll', 'is--filter-open');
      const ov = document.querySelector('.overlay');
      if (ov) ov.remove();
    }
  } catch (err) { }
})

function productCardsOrderHandler() {
  // Check if variants should be shown and the URL includes sorting by ascending price
  if (window.show_variants && window.location.search.includes('sort_by=price-ascending')) {
    // Get all product card elements from the grid
    const productCards = Array.from(document.querySelectorAll('.collection-grid__wrapper .grid .grid__item'));

    // Temporary array to collect cards that have a valid price
    const sortableCards = [];

    // First pass: collect cards that have a valid data-price
    productCards.forEach(card => {
      const priceElement = card.querySelector('.grid-product__price');
      const priceAttr = priceElement?.getAttribute('data-price');
      const price = priceAttr ? parseFloat(priceAttr) : null;

      if (price !== null) {
        sortableCards.push({ card, price });
      }
    });

    // Sort cards with valid prices in ascending order
    sortableCards.sort((a, b) => a.price - b.price);

    // Create a Map to store the sorted order for quick lookup
    const sortedMap = new Map();
    sortableCards.forEach((item, index) => {
      sortedMap.set(item.card, index);
    });

    // Second pass: assign CSS order to each card in DOM order
    let orderIndex = 0;
    productCards.forEach(card => {
      if (sortedMap.has(card)) {
        // If the card has a valid price, use its sorted index
        card.style.order = sortedMap.get(card);
        orderIndex = sortedMap.get(card) + 1;
      } else if (card.classList.contains('marketing-grid')) {
        // If it's a marketing card, assign the next available index immediately
        card.style.order = orderIndex++;
      } else {
        // For all other cards without price or marketing class, assign next index
        card.style.order = orderIndex++;
      }
    });
  }
}

productCardsOrderHandler();

function handleOverlayElement(element) {
  element.removeAttribute('role');
  element.setAttribute('aria-hidden', 'true');
}

const observerGiftBoxOverlay = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('gb-overlay')) {
          handleOverlayElement(node);
        }
        // Also check descendants in case .gb-overlay is nested
        if (node.nodeType === 1) {
          const overlays = node.querySelectorAll('.gb-overlay');
          overlays.forEach(handleOverlayElement);
        }
      });
    }
  }
});

observerGiftBoxOverlay.observe(document.body, {
  childList: true,
  subtree: true
});

// DWFT-4066 FEMCARE PLP | Color filter issue on specific collections (v2 code)
window.availableColors = [];
async function collectAvailableColorsFromAllPages(url, foundColors = new Set()) {
  try {
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const products = doc.querySelectorAll('.collection-grid__wrapper li.grid__item');

    products.forEach(productItem => {
      if (!productItem.classList.contains('marketing-grid')) {
        const color = productItem.querySelector('span.color-swatch');
        if (color && color.dataset.title) {
          foundColors.add(color.dataset.title.trim());
        }
      }
    });

    const nextPageElement = doc.querySelector('.paginate-item--next a');
    if (nextPageElement && nextPageElement.href) {
      return await collectAvailableColorsFromAllPages(nextPageElement.href, foundColors);
    } else {
      return foundColors;
    }
  } catch (error) {
    console.error('Error while collecting colors from pages:', error);
    return foundColors;
  }
}

async function colorFiltersVisibilityHandler(ajaxLoad) {
  if (!window.exclusive_only) return;

  const colorFilters = document.querySelectorAll('.collection-sidebar__group span.color-swatch.color-swatch--filter');

  if (!ajaxLoad) {
    try {
      const url = window.location.origin + window.location.pathname;
      const foundColorsSet = await collectAvailableColorsFromAllPages(url);
      window.availableColors = Array.from(foundColorsSet);

      colorFilters.forEach(filterColor => {
        const filterTitle = filterColor.getAttribute('title').trim();
        if (!foundColorsSet.has(filterTitle)) {
          filterColor.closest('li.tag').style.display = 'none';
        }
      });
    } catch (error) {
      console.error('Error during color filter visibility check:', error);
    }
  }

  if (ajaxLoad && window.availableColors) {
    colorFilters.forEach(filterColor => {
      const title = filterColor.getAttribute('title').trim();
      if (!window.availableColors.includes(title)) {
        filterColor.closest('li.tag').style.display = 'none';
      }
    });
  }
}

function updateApplyFilterButtonCount(visibleCount) {
  try {
    const applyFilterBtn = document.querySelector('button#apply-filter-btn');
    if (!applyFilterBtn) return;

    const baseLabel = applyFilterBtn.dataset.applyBtnLabel
      || applyFilterBtn.textContent
        .replace(/\s*\(\d{1,3}(?:[,\d]*)?\)\s*$/, '')
        .trim();

    applyFilterBtn.textContent = `${baseLabel} (${visibleCount})`;
  } catch (err) {
    // swallow — non critical
  }
}

function productsCountHandler() {
  try {
    const productsCountInput = document.getElementById('products-hidden-count');
    const collectionProductsCount = document.querySelectorAll('.collection-filter__item.collection-filter__item--count');
    if (!collectionProductsCount || !collectionProductsCount.length) return;

    // Compute visible product cards in the current collection content.
    // This counts rendered product grid items (variants or products) and
    // ignores marketing cards or hidden items.
    // Exclude marketing cards which also carry `grid-product` class.
    const productNodes = document.querySelectorAll('#CollectionAjaxContent .grid__item.grid-product:not(.marketing-grid)');
    const visibleProductNodes = Array.from(productNodes).filter(n => {
      try {
        return n.offsetParent !== null && getComputedStyle(n).display !== 'none';
      } catch (e) {
        return true;
      }
    });
    const visibleCount = visibleProductNodes.length;

    if (visibleCount >= 0) {
      updateApplyFilterButtonCount(visibleCount);

      // Replace the numeric portion of existing localized text so we keep
      // translations like "Showing X items" but update X dynamically.
      collectionProductsCount.forEach(item => {
        const currentText = (item.textContent || '').trim();
        if (!currentText) {
          // fallback to hidden input value if present
          if (productsCountInput) {
            item.textContent = productsCountInput.value;
          }
          return;
        }

        // Replace first integer (with commas) in the string with visibleCount
        const newText = currentText.replace(/\d{1,3}(?:[,\d]*)?/, visibleCount.toString());
        item.textContent = newText;
      });
    } else if (productsCountInput) {
      // No product nodes found — fallback to server-rendered hidden input
      collectionProductsCount.forEach(item => {
        item.textContent = productsCountInput.value;
      });
    }
  } catch (err) {
    // swallow — non critical
  }
}

if (document.body.classList.contains('template-collection')) {
  colorFiltersVisibilityHandler(false);
  productsCountHandler();
}

// DWFT-5649 Femcare > all PLPs sorting | Hide 'availability' filter
function hideAvailabilityFilterHandler() {
  if (!window.hide_available_filter) return;

  const inStockFilter = document.querySelector(
    '#side-filter-form input[name="filter.v.availability"][value="1"]'
  );

  if (!inStockFilter) return;

  const parentGroup = inStockFilter.closest('.collection-sidebar__group--item');
  if (parentGroup) {
    parentGroup.style.display = 'none';
  }
}

hideAvailabilityFilterHandler();

// DWFT-5692 PDP | Color Persistence Issue When Navigating Between Fluid Types
function absorbencyProductCtaHandler(variantTitle) {
  const buttonInputs = document.querySelectorAll('.product-section .absorbency_cta_filter_products_data');
  const buttons = document.querySelectorAll('.product-section .absorbency_product_cta');
  const selectedVariantTitle =
    variantTitle || document.querySelector('.product-variants-select')?.getAttribute('data-selected-variant-title');
  if (selectedVariantTitle) {
    buttonInputs.forEach((input, index) => {
      const values = input.value.trim().split(',').map(v => v.trim()).filter(Boolean);
      let variantId = null;

      // try to find exact match first
      const exactMatch = values.find(valueItem => valueItem.includes(selectedVariantTitle));
      if (exactMatch) {
        variantId = exactMatch.split('-')[1] ?? null;
      }

      const button = buttons[index];
      if (!button) return;

      try {
        const url = new URL(button.href);

        if (variantId !== null) {
          url.searchParams.set('variant', variantId);
        } else {
          const colorName = selectedVariantTitle.trim().split(' / ')[0];

          // 1) find first item that contains colorName and true:: marker
          let matchedValue = values.find(valueItem =>
            valueItem.includes(colorName) && valueItem.includes('true::')
          );

          // 2) if not found, fallback to first item that contains colorName and false:: marker
          if (!matchedValue) {
            matchedValue = values.find(valueItem =>
              valueItem.includes(colorName) && valueItem.includes('false::')
            );
          }

          if (matchedValue) {
            const id = matchedValue.split('-')[1] ?? null;
            variantId = id;
          }

          if (variantId) {
            url.searchParams.set('variant', variantId);
          } else {
            url.searchParams.delete('variant');
          }
        }

        button.href = url.toString();
      } catch (e) {
        // invalid href: attempt to remove variant param conservatively
        try {
          const u = new URL(button.href);
          u.searchParams.delete('variant');
          button.href = u.toString();
        } catch {
          // cannot fix invalid href
        }
      }
    });
  }
}


absorbencyProductCtaHandler();

//DWFT-5805 PDP Flickering effect
document.addEventListener("DOMContentLoaded", function () {
  function applyCustomClass() {
    const swatches = document.querySelectorAll(
      'li.variant-item .variant__button-label.color-swatch:not(.disabled)'
    );
    swatches.forEach((swatch) => {
      swatch.classList.add("custom-swatch-cls");
      const li = swatch.closest("li.variant-item");
      if (li) {
        const colorName = li.querySelector(".color-name");
        if (colorName) {
          colorName.classList.add("custom-color-cls");
        }
      }
    });
  }
  applyCustomClass();
  // Observe dynamic on variant change
  const observer = new MutationObserver(() => {
    applyCustomClass();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const protectCustomClass = () => {
    const protectedEls = document.querySelectorAll(".variant__button-label.custom-swatch-cls");
    protectedEls.forEach(el => {
      if (el.classList.contains("disabled")) {
        el.classList.remove("disabled");
      }
    });
  };
  protectCustomClass();
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.target && m.target.classList) {
        if (m.target.classList.contains("custom-swatch-cls") &&
            m.target.classList.contains("disabled")) {
          m.target.classList.remove("disabled");
        }
      }
    });
    protectCustomClass();
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class"]
  });
});

//DWFT-5979 GiftBox App|Fix the unlimited code applying
const itemsSelector = '.cart__item';
const GIFT_HANDLE_PART = 'free-gift';
const FORCE_QTY = 1;

function isGiftItem(item) {
  const title = (item.getAttribute('data-product-title') || '').toLowerCase();
  const linkHref = (
    item.querySelector('.cart__item-name')?.getAttribute('href') || ''
  ).toLowerCase();
  return title.startsWith('free gift') || linkHref.includes(GIFT_HANDLE_PART);
}
function getQtyInput(item) {
  return (
    item.querySelector('input[name="updates[]"]') ||
    item.querySelector('input[name^="updates"]') ||
    item.querySelector('input[type="number"]')
  );
}
function getLineIndex(item) {
  const fromAttr =
    item.getAttribute('data-line') ||
    item.getAttribute('data-line-item') ||
    item.querySelector('[data-line]')?.getAttribute('data-line') ||
    item.querySelector('input[data-line]')?.getAttribute('data-line') ||
    item.querySelector('a[data-line]')?.getAttribute('data-line');
  if (fromAttr && !isNaN(parseInt(fromAttr, 10))) return parseInt(fromAttr, 10);
  const allItems = Array.from(document.querySelectorAll(itemsSelector));
  const idx = allItems.indexOf(item);
  return idx >= 0 ? idx + 1 : null;
}
async function forceCartChange(line, quantity) {
  if (!line) return;
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      }),
      credentials: 'same-origin',
    });
  } catch (e) {}
}
function setQtyToOne(item) {
  const input = getQtyInput(item);
  if (!input) return;
  const current = parseInt(input.value, 10);
  if (current === FORCE_QTY) return;
  input.value = String(FORCE_QTY);
  input.setAttribute('value', String(FORCE_QTY));
  input.dispatchEvent(new Event('input', {
    bubbles: true
  }));
  input.dispatchEvent(new Event('change', {
    bubbles: true
  }));
  if (!item.__gbForceQtyTimer) {
    item.__gbForceQtyTimer = setTimeout(() => {
      const line = getLineIndex(item);
      forceCartChange(line, FORCE_QTY);
      item.__gbForceQtyTimer = null;
    }, 150);
  }
}
function lockGiftUI(item) {
  const qtyWrapper = item.querySelector('.qty-wrapper.js-qty__wrapper');
  if (qtyWrapper) qtyWrapper.style.display = 'none';
  const qtyActions = item.querySelectorAll('.qty-actions, .qty-actions *');
  qtyActions.forEach(el => {
    el.style.pointerEvents = 'none';
    el.style.opacity = '0.25';
  });
  const removeIconBtn = item.querySelector('.cart__item--remove_icon button');
  if (removeIconBtn) {
    removeIconBtn.style.pointerEvents = 'none';
    removeIconBtn.style.opacity = '0.25';
  }
  const input = getQtyInput(item);
  if (input) {
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('aria-readonly', 'true');
    input.style.pointerEvents = 'none';
  }
}
function applyGiftRules(root = document) {
  const items = root.querySelectorAll(itemsSelector);
  items.forEach(item => {
    if (!isGiftItem(item)) return;
    setQtyToOne(item);
    lockGiftUI(item);
  });
}
function initGiftObservers() {
  if (window.__giftQtyObserverInitialized) return;
  window.__giftQtyObserverInitialized = true;
  const containers = document.querySelectorAll('[data-products], .cart__page, form[action^="/cart"]');
  containers.forEach(container => {
    const observer = new MutationObserver(() => {
      applyGiftRules(container);
    });
    observer.observe(container, {
      childList: true,
      subtree: true
    });
    applyGiftRules(container);
  });
  window.__giftQtyInterval = window.__giftQtyInterval || setInterval(() => {
    applyGiftRules(document);
  }, 100);
}
initGiftObservers();


/* DWFT-6048 OOS datalayer */
(function () {
  window.dataLayer = window.dataLayer || [];

  let productData = null;
  const firedOOSVariants = new Set();
  const MAX_RETRIES = 10;
  const RETRY_DELAY = 200;

  function safeValue(value) {
    return value !== null && value !== undefined && value !== ''
      ? value
      : 'N/A';
  }

  function getOOSInventoryElement() {
    return document.querySelector(
      '#stock_inventory[data-product-inventory]'
    );
  }

  function isOOSVisible() {
    const el = getOOSInventoryElement();
    if (!el) return false;

    const qtyLeft = el.getAttribute('data-qtyleft');
    const isVisible = el.offsetParent !== null;

    return qtyLeft === '0' && isVisible;
  }

  function getMetaAttribute(attr) {
    const meta = document.querySelector(`meta[${attr}]`);
    return meta ? meta.getAttribute(attr) : null;
  }

  function fireOOSPush(variant, product) {
    window.dataLayer.push({
      event: 'ga4_out_of_stock',
      ecommerce: {
        items: [
          {
            item_id: safeValue(variant.id || variant.sku),
            item_name: safeValue(product.title),
            item_variant: safeValue(variant.title),
            absorbency_level: getMetaAttribute('absorbency_level'),
            style_type: getMetaAttribute('style_type')
          }
        ]
      }
    });
  }

  function waitForOOSUI(variant, product, retry = 0) {
    const variantIsOOS = variant.available === false;
    const uiShowsOOS = isOOSVisible();

    if (variantIsOOS && uiShowsOOS) {
      if (!firedOOSVariants.has(variant.id)) {
        fireOOSPush(variant, product);
        firedOOSVariants.add(variant.id);
      }
      return;
    }

    if (!variantIsOOS && firedOOSVariants.has(variant.id)) {
      firedOOSVariants.delete(variant.id);
      return;
    }

    if (retry < MAX_RETRIES) {
      setTimeout(function () {
        waitForOOSUI(variant, product, retry + 1);
      }, RETRY_DELAY);
    }
  }

  // This endpoint exists for product pages (`/products/<handle>.js`) but not collection pages.
  if (/^\/products\//.test(window.location.pathname)) {
    fetch(`${window.location.pathname}.js`)
      .then(res => res.ok ? res.json() : null)
      .then(product => {
        if (product) productData = product;
      })
      .catch(() => {
        // Keep silent: OOS tracking should not break page behavior if product JSON is unavailable.
      });
  }

  document.addEventListener('variant:change', function (event) {
    if (!event.detail?.variant || !productData) return;

    const variant = event.detail.variant;

    requestAnimationFrame(function () {
      waitForOOSUI(variant, productData);
    });
  });
})();

/* DWFT-6411 PDP remove default size */
if (theme.settings.remove_default_size_pre_sel == 'true') {
  document.addEventListener("DOMContentLoaded", function () {

    const currentParams = new URLSearchParams(window.location.search || '');
    const isByobVariantNavigation = !!currentParams.get('variant') && (
      currentParams.get('byob') === '1' ||
      (document.referrer && /\/collections\/build-your-own-bundle/i.test(document.referrer))
    );

    const sizeFieldset = document.querySelector('fieldset.size-fieldset');
    const colorFieldset = document.querySelector('fieldset.is-color');

    if (!sizeFieldset) return;

    const sizeName = sizeFieldset.getAttribute("name");  
    const colorName = colorFieldset?.getAttribute("name"); 

    const sizeInputs = document.querySelectorAll(`input[name="${sizeName}"]`);
    const colorInputs = colorName
      ? document.querySelectorAll(`input[name="${colorName}"]`)
      : [];

    const addToCartBtn = document.querySelector('#addtobag');
    const sizeErrorMsg = document.querySelector('#size-error-msg');
    const variantlabelHide = document.querySelector('.active-variant-label');
    const stockMessageHandle = document.querySelector('.product-inventory');
    const seeSimilarBtn = document.querySelector('.see-similar-product');

    if (!sizeInputs.length || !addToCartBtn) return;

    let sizeSelected = false;
    let selectedSizeIsOOS = false;
    const optionHandle = sizeFieldset.dataset.handle;
    function cameFromPLPWithSizeFilter() {
      if (!document.referrer) return false;

      try {
        const refUrl = new URL(document.referrer);
        const optionFilters = [];
        refUrl.searchParams.forEach((value, key) => {
          if (key.startsWith("filter.v.option.")) {
            optionFilters.push({ key, value });
          }
        });

        if (!optionFilters.length) return false;
        const sizeValues = Array.from(sizeInputs).map(input => input.value);

        return optionFilters.some(filter =>
          sizeValues.includes(filter.value)
        );

      } catch (e) {
        return false;
      }
    }

    function keepButtonVisible() {
      addToCartBtn.style.display = "block";
      addToCartBtn.style.visibility = "visible";
      addToCartBtn.style.opacity = "1";
    }
    function controlSeeSimilarVisibility() {
      if (!seeSimilarBtn) return;
      if (!sizeSelected) {
        seeSimilarBtn.classList.add('hide-see-similar-cta');
        seeSimilarBtn.style.display = "none";
      } else if (selectedSizeIsOOS) {
        seeSimilarBtn.classList.remove('hide-see-similar-cta');
        seeSimilarBtn.style.display = "";
      } else {
        seeSimilarBtn.classList.add('hide-see-similar-cta');
        seeSimilarBtn.style.display = "none";
      }
    }

    function resetSizeSelection() {
      sizeInputs.forEach(input => input.checked = false);

      sizeSelected = false;
      selectedSizeIsOOS = false;
      addToCartBtn.disabled = true;
      keepButtonVisible();
      controlSeeSimilarVisibility();

      if (sizeErrorMsg && variantlabelHide) {
        variantlabelHide.classList.add('size-show-error');
        sizeErrorMsg.style.display = "block";
        if (stockMessageHandle) stockMessageHandle.style.display = "none";
      }
    }
    function hideErrorMessage() {
      if (sizeErrorMsg && variantlabelHide) {
        variantlabelHide.classList.remove('size-show-error');
        sizeErrorMsg.style.display = "none";
        if (stockMessageHandle) stockMessageHandle.style.display = "block";
      }
    }
    function isOOS(input) {
      return (
        input.classList.contains("disabled") ||
        input.disabled ||
        input.closest(".variant-input")?.classList.contains("disabled")
      );
    }

    sizeInputs.forEach(input => {
      input.addEventListener("change", function () {
        if (!this.checked) return;
        selectedSizeIsOOS = isOOS(this);
        sizeSelected = true;
        if (selectedSizeIsOOS) {
          addToCartBtn.disabled = true;
          keepButtonVisible();
          hideErrorMessage();
          controlSeeSimilarVisibility();
          return;
        }

        selectedSizeIsOOS = false;
        hideErrorMessage();
        controlSeeSimilarVisibility();
        setTimeout(() => {
          keepButtonVisible();
        }, 50);
      });
    });

    colorInputs.forEach(input => {
      input.addEventListener("change", function () {

        if (!sizeSelected) {
          setTimeout(() => {
            addToCartBtn.disabled = true;
            keepButtonVisible();
            controlSeeSimilarVisibility();

            if (sizeErrorMsg && variantlabelHide) {
              variantlabelHide.classList.add('size-show-error');
              sizeErrorMsg.style.display = "block";
              if (stockMessageHandle) stockMessageHandle.style.display = "none";
            }
          }, 10);
        }
      });
    });

    const hasSizeIntent = isByobVariantNavigation ? true : cameFromPLPWithSizeFilter();
    if (!hasSizeIntent) {
      resetSizeSelection();
    } else {
      sizeSelected = true;
      const checkedSize = document.querySelector(`input[name="${sizeName}"]:checked`);
      selectedSizeIsOOS = checkedSize ? isOOS(checkedSize) : false;
      controlSeeSimilarVisibility();
    }

  });
}

/* DWFT-6430 PDP sticky cta */
document.addEventListener("DOMContentLoaded", function () {
  const containerSelector = ".sticky-reduced-atc.size-accordion";

  function formatVariantLabel() {
    const parentContainer = document.querySelector(containerSelector);
    if (!parentContainer) return;
    const variantLabel = parentContainer.querySelector(".active-variant-label");
    if (!variantLabel) return;
    const text = variantLabel.textContent.trim();
    if (text.includes(" / ") && !variantLabel.innerHTML.includes("<br>")) {
      variantLabel.innerHTML = text.replace(" / ", "<br>");
    }
    if (variantLabel.innerHTML.includes("<br>")) {
      parentContainer.classList.add("variant-split");
    } else {
      parentContainer.classList.remove("variant-split");
    }
  }
  setTimeout(formatVariantLabel, 100);
  const parent = document.querySelector(containerSelector);
  if (!parent) return;
  const observer = new MutationObserver(() => {
    setTimeout(formatVariantLabel, 50);
    setTimeout(formatVariantLabel, 150);
  });

  observer.observe(parent, {
    childList: true,
    subtree: true
  });
});

/* DWFT-6445 PLP/PDP */
if (theme.settings.prefiltered_size_selected == 'true') {
  (function () {
    try {
      // BYOB-specific guard: do not override explicit BYOB variant selection on PDP.
      var currentParams = new URLSearchParams(window.location.search || '');
      var isByobVariantNavigation = !!currentParams.get('variant') && (
        currentParams.get('byob') === '1' ||
        (document.referrer && /\/collections\/build-your-own-bundle/i.test(document.referrer))
      );
      if (isByobVariantNavigation) return;

      var referrer = document.referrer;
      if (!referrer) return;
      var refUrl;
      try {
        refUrl = new URL(referrer);
      } catch (e) {
        return;
      }

      if (refUrl.hostname !== window.location.hostname) return;
      if (!refUrl.pathname || !refUrl.pathname.includes('/collections/')) return;

      var SIZE_FILTER_KEYS = [
        'filter.v.option.size',
        'filter.v.option.taille',
        'filter.v.option.größe',
        'filter.v.option.størrelse',
        'filter.v.option.koko',
        'filter.v.option.storlek'
      ];

      var sizes = [];
      SIZE_FILTER_KEYS.forEach(function (key) {
        var values = refUrl.searchParams.getAll(key);
        if (values && values.length) {
          sizes = sizes.concat(values);
        }
      });

      if (!sizes.length) return;
      // Normalize
      sizes = sizes.map(function (s) {
        return (s || '').trim().toUpperCase();
      });

      var SIZE_NAMES = [
        'SIZE',
        'TAILLE',
        'Größe',
        'STØRRELSE',
        'KOKO',
        'STORLEK'
      ];

      var allInputs = document.querySelectorAll('.variant-input input[type="radio"]');
      if (!allInputs.length) return;

      var variantInputs = Array.prototype.filter.call(allInputs, function (input) {
        var name = (input.name || '').trim().toUpperCase();
        return SIZE_NAMES.indexOf(name) !== -1;
      });
      if (!variantInputs.length) return;
      var target = null;

      for (var i = 0; i < sizes.length; i++) {
        for (var j = 0; j < variantInputs.length; j++) {
          var input = variantInputs[j];
          var value = (input.value || '').trim().toUpperCase();
          var isDisabled =
            input.disabled ||
            input.classList.contains('disabled') ||
            (input.closest('.variant-item') &&
              input.closest('.variant-item').classList.contains('disabled'));

          if (value === sizes[i] && !isDisabled) {
            target = input;
            break;
          }
        }
        if (target) break;
      }

      if (!target) return;
      if (target.checked) return;
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));

    } catch (e) {
      console.warn('Size preselection error:', e);
    }
  })();
}

if (theme.settings.close_details_tab == 'true') {
  document.addEventListener("DOMContentLoaded", function () {
    const firstTab = document.querySelectorAll(".custom-side-tab")[0];

    if (!firstTab) return;

    const trigger = firstTab.querySelector(".collapsible-trigger");

    if (trigger && trigger.classList.contains("is-open")) {
      // Remove open state
      trigger.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");

      // If content is controlled via aria-controls, collapse it too
      const contentId = trigger.getAttribute("aria-controls");
      if (contentId) {
        const content = document.getElementById(contentId);
        if (content) {
          content.style.height = "0px";
          content.classList.remove("is-open");
        }
      }
    }
  });
}


/* DWFT-5928 Predefined bundle */
if (theme.settings.predefined_bundle_code == 'true') {
  (() => {

  const processedItems = new Map();

  let isProcessing = false;

  function debounce(fn, delay = 300) {

    let timer;

    return (...args) => {

      clearTimeout(timer);

      timer = setTimeout(() => {
        fn(...args);
      }, delay);
    };
  }

  function extractBundleData(cartItem) {

  const bundleItems = cartItem.querySelectorAll(
    '.cart__item-bundles ul.cart__item-list > li.bundle__item'
  );

  const data = [];

  bundleItems.forEach((item, index) => {

    const titleEl =
      item.querySelector('.bundle__item-title');

    const title =
      titleEl?.textContent?.trim() || '';

    const productId =
      titleEl?.dataset?.productChildId
      '';

    let rawPrice =
      titleEl?.dataset?.productChildPrice || '';

    let price = 0;
    if (rawPrice !== null && rawPrice !== undefined) {
      const parsed = parseFloat(String(rawPrice).trim());
      if (!isNaN(parsed)) {
        price = parsed;
      }
    }

    const variants = [];

    item.querySelectorAll(
      '.bundle__item-variants li.variant-input'
    ).forEach(variant => {

      const value =
        variant.querySelector(
          '.option-value strong'
        )?.textContent?.trim();

      if (value) {
        variants.push(value);
      }
    });

    data.push({

      id: String(productId),

      t: title,

      p: String(price),

      v: variants.join(' / '),

      i: index,

      is_custom_bundle: false,

      is_predefined_bundle: true

    });

  });
    return data;
  }

  function buildProperties(bundleData) {

    return {
      _bundle_data: JSON.stringify(bundleData)
    };
  }

  async function updateLineItem(
    lineItemKey,
    quantity,
    properties
  ) {

    return fetch('/cart/change.js', {

      method: 'POST',

      headers: {
        'Content-Type': 'application/json'
      },

      body: JSON.stringify({
        id: lineItemKey,
        quantity,
        properties
      })

    });
  }

  async function syncBundleProperties() {

    if (isProcessing) return;

    isProcessing = true;

    try {

      const cartItems =
        document.querySelectorAll(
          'li.cart__item'
        );

      for (const cartItem of cartItems) {

        if (
          !cartItem.classList.contains(
            'cart__item-bundle'
          )
        ) {
          continue;
        }

        const lineItemKey =
          cartItem.dataset.key;

        if (!lineItemKey) continue;

        const bundleData =
          extractBundleData(cartItem);

        if (!bundleData.length) continue;

        const properties =
          buildProperties(bundleData);

        const hash =
          JSON.stringify(properties);

        if (
          processedItems.get(lineItemKey) === hash
        ) {
          continue;
        }

        processedItems.set(
          lineItemKey,
          hash
        );

        await updateLineItem(
          lineItemKey,
          parseInt(
            cartItem.dataset.quantity || 1
          ),
          properties
        );
      }

    } catch (error) {
      console.error(
        'Bundle sync failed:',
        error
      );

    } finally {
      isProcessing = false;
    }
  }

  const debouncedSync =
    debounce(syncBundleProperties, 400);

  function initBundleSync() {

    debouncedSync();

    document.addEventListener(
      'cart:refresh',
      debouncedSync
    );

    document.addEventListener(
      'ajaxProduct:added',
      debouncedSync
    );

    document.addEventListener(
      'cart:updated',
      debouncedSync
    );

    document.addEventListener(
      'drawer:opened',
      debouncedSync
    );

    const observer =
      new MutationObserver((mutations) => {

        const hasCartItems =
          mutations.some(mutation => {

            return Array.from(
              mutation.addedNodes
            ).some(node => {

              return (
                node.nodeType === 1 &&
                (
                  node.matches?.('li.cart__item') ||
                  node.querySelector?.(
                    'li.cart__item'
                  )
                )
              );
            });
          });

        if (hasCartItems) {
          debouncedSync();
        }
      });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initBundleSync
    );
  } else {
    initBundleSync();
  }
  })();
}

// DWFT-6453
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('custom-sort-bsellers')) {
    return;
  }
  const sortSelect = document.getElementById('SortBy');
  if (!sortSelect) {
    return;
  }
  Array.from(sortSelect.options).forEach(function (option) {
    if (option.value !== 'best-selling') {
      option.style.display = 'none';
      option.disabled = true;
    } else {
      option.style.display = '';
      option.disabled = false;
      option.selected = true;
    }
  });
  sortSelect.value = 'best-selling';
});

//DWFT-6761
(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.byob__widget-button');
    if (!button) return;
    let storedItems = [];
    try {
      const raw = localStorage.getItem('byob_items');
      if (!raw) {
        console.warn('[BYOB] No byob_items found.');
        return;
      }

      storedItems = JSON.parse(raw);

      if (!Array.isArray(storedItems) || !storedItems.length) {
        console.warn('[BYOB] byob_items is empty.');
        return;
      }
    } catch (err) {
      console.error('[BYOB] Unable to read localStorage.', err);
      return;
    }

    const totalItems = storedItems.length;
    const settings =
      (window.theme && window.theme.settings) ||
      (typeof theme !== 'undefined' && theme.settings) ||
      {};

    const tiers = [
      {
        qty: Number(settings.byob_tier1_qty),
        discount: Number(settings.byob_tier1_discount)
      },
      {
        qty: Number(settings.byob_tier2_qty),
        discount: Number(settings.byob_tier2_discount)
      },
      {
        qty: Number(settings.byob_tier3_qty),
        discount: Number(settings.byob_tier3_discount)
      }
    ]
      .filter(function (tier) {
        return Number.isFinite(tier.qty) && tier.qty > 0;
      })
      .sort(function (a, b) {
        return a.qty - b.qty;
      });

    // Highest eligible tier
    let discountPercentage = 0;

    tiers.forEach(function (tier) {
      if (totalItems >= tier.qty) {
        discountPercentage = Number(tier.discount) || 0;
      }
    });

    // Safety
    discountPercentage = Math.max(0, Math.min(discountPercentage, 100));
    const ecommerceItems = [];

    storedItems.forEach(function (item, index) {

      if (!item || typeof item !== 'object') return;
      let price = parseFloat(item.price);
      if (!Number.isFinite(price)) {
        price = 0;
      }

      price = price / 100;
      price = Number(price.toFixed(2));
      // Calculate percentage discount
      const discountAmount = Number(
        ((price * discountPercentage) / 100).toFixed(2)
      );
      // Final price
      const finalPrice = Number(
        Math.max(0, price - discountAmount).toFixed(2)
      );

      ecommerceItems.push({
        item_id: String(item.id || ''),
        item_name: item.productTitle || '',
        currency: 'GBP',
        discount: discountAmount,
        index: index,
        item_variant: [
          item.colorTitle,
          item.sizeTitle
        ]
          .filter(Boolean)
          .join(' / '),
        price: finalPrice,
        quantity: 1
      });

    });

    if (!ecommerceItems.length) {
      console.warn('[BYOB] No valid items found.');
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      location: 'BYOB page',
      ecommerce: {
        items: ecommerceItems
      }
    });
    console.log('[BYOB] Discount %:', discountPercentage);
    console.log('[BYOB] add_to_cart fired', ecommerceItems);

  });

})();
